
(function (global, factory) {
  typeof exports === 'object' && typeof module !== 'undefined' ? factory(exports) :
  typeof define === 'function' && define.amd ? define(['exports'], factory) :
  (factory((global['fa-kit-77f017bde2'] = {})));
}(this, (function (exports) { 'use strict';

  
  var falIcons = (function () {
  
    

    var faDown = {
      prefix: 'fal',
      iconName: 'down',
      icon: [
        384,
        512,
        
            ['arrow-alt-down']
        ,
        'f354',
        
        'M189.7 448h4.6c4.4 0 8.6-1.8 11.6-5L348.5 293.2c2.2-2.3 3.5-5.4 3.5-8.7c0-6.9-5.6-12.6-12.6-12.6H256c-8.8 0-16-7.2-16-16V80c0-8.8-7.2-16-16-16H160c-8.8 0-16 7.2-16 16V256c0 8.8-7.2 16-16 16H44.6c-6.9 0-12.6 5.6-12.6 12.6c0 3.2 1.2 6.3 3.5 8.7L178.1 443c3 3.2 7.2 5 11.6 5zM384 284.6c0 11.4-4.4 22.5-12.3 30.7L229 465.1c-9.1 9.5-21.6 14.9-34.8 14.9h-4.6c-13.1 0-25.7-5.4-34.8-14.9L12.3 315.3C4.4 307 0 296 0 284.6C0 260 20 240 44.6 240H112V80c0-26.5 21.5-48 48-48h64c26.5 0 48 21.5 48 48V240h67.4c24.6 0 44.6 20 44.6 44.6z'
        
      ]
    };

    
      var faArrowAltDown = faDown;
    
  
    

    var faCircleXmark = {
      prefix: 'fal',
      iconName: 'circle-xmark',
      icon: [
        512,
        512,
        
            [61532,'times-circle','xmark-circle']
        ,
        'f057',
        
        'M256 32a224 224 0 1 1 0 448 224 224 0 1 1 0-448zm0 480A256 256 0 1 0 256 0a256 256 0 1 0 0 512zM180.7 180.7c-6.2 6.2-6.2 16.4 0 22.6L233.4 256l-52.7 52.7c-6.2 6.2-6.2 16.4 0 22.6s16.4 6.2 22.6 0L256 278.6l52.7 52.7c6.2 6.2 16.4 6.2 22.6 0s6.2-16.4 0-22.6L278.6 256l52.7-52.7c6.2-6.2 6.2-16.4 0-22.6s-16.4-6.2-22.6 0L256 233.4l-52.7-52.7c-6.2-6.2-16.4-6.2-22.6 0z'
        
      ]
    };

    
      var faTimesCircle = faCircleXmark;
    
      var faXmarkCircle = faCircleXmark;
    
  
    

    var faBookOpen = {
      prefix: 'fal',
      iconName: 'book-open',
      icon: [
        576,
        512,
        
            [128366,128214]
        ,
        'f518',
        
        'M156 32c44.6 0 89.7 8.6 132 22.6C330.3 40.6 375.4 32 420 32c55.4 0 107.2 14.6 128.9 21.6C565.7 59 576 74.5 576 91.1V402.5c0 26.9-25.1 44.8-49 40.6c-18.5-3.2-51.3-7.2-99-7.2c-58.9 0-97.8 24.3-111.2 34.1c-7.5 5.5-17.2 9.6-28.2 9.9c-.2 0-.5 0-.7 0c-.1 0-.1 0-.2 0c-.1 0-.2 0-.3 0c-10.2 0-19.6-3.4-27-8.4C245.5 461.5 202 436 148 436c-45.2 0-80.1 4.4-100 7.7c-24 4-48-14.1-48-40.2V91.1C0 74.5 10.3 59 27.1 53.6C48.8 46.6 100.6 32 156 32zM304 440c20.3-13.5 63.1-36 124-36c49.5 0 84.1 4.2 104.4 7.6c2.5 .4 5.7-.3 8.2-2.3c2.2-1.8 3.4-4 3.4-6.8V91.1c0-3.5-2.1-6.1-4.9-7C518.6 77.5 470.5 64 420 64c-38.6 0-78.1 7.1-116 19V440zM272 83c-37.9-12-77.4-19-116-19C105.5 64 57.4 77.5 36.9 84c-2.8 .9-4.9 3.6-4.9 7V403.5c0 2.7 1.1 4.9 3.1 6.5c2.2 1.8 5.1 2.5 7.6 2.1c21.3-3.6 58-8.2 105.3-8.2c56.8 0 102.8 23.7 124 36.9V83z'
        
      ]
    };

    
  
    

    var faCheck = {
      prefix: 'fal',
      iconName: 'check',
      icon: [
        448,
        512,
        
            [10004,10003]
        ,
        'f00c',
        
        'M443.3 100.7c6.2 6.2 6.2 16.4 0 22.6l-272 272c-6.2 6.2-16.4 6.2-22.6 0l-144-144c-6.2-6.2-6.2-16.4 0-22.6s16.4-6.2 22.6 0L160 361.4 420.7 100.7c6.2-6.2 16.4-6.2 22.6 0z'
        
      ]
    };

    
  
    

    var faBook = {
      prefix: 'fal',
      iconName: 'book',
      icon: [
        448,
        512,
        
            [128212]
        ,
        'f02d',
        
        'M64 0C28.7 0 0 28.7 0 64L0 448l0 0c0 35.3 28.7 64 64 64H432c8.8 0 16-7.2 16-16s-7.2-16-16-16H416V413.3c18.6-6.6 32-24.4 32-45.3V48c0-26.5-21.5-48-48-48H64zM384 416v64H64c-17.7 0-32-14.3-32-32s14.3-32 32-32H384zM64 384c-11.7 0-22.6 3.1-32 8.6L32 64c0-17.7 14.3-32 32-32H96V384H64zm64 0V32H400c8.8 0 16 7.2 16 16V368c0 8.8-7.2 16-16 16H128zm48-240c0 8.8 7.2 16 16 16H352c8.8 0 16-7.2 16-16s-7.2-16-16-16H192c-8.8 0-16 7.2-16 16zm0 96c0 8.8 7.2 16 16 16H352c8.8 0 16-7.2 16-16s-7.2-16-16-16H192c-8.8 0-16 7.2-16 16z'
        
      ]
    };

    
  
    

    var faCirclePlus = {
      prefix: 'fal',
      iconName: 'circle-plus',
      icon: [
        512,
        512,
        
            ['plus-circle']
        ,
        'f055',
        
        'M256 32a224 224 0 1 1 0 448 224 224 0 1 1 0-448zm0 480A256 256 0 1 0 256 0a256 256 0 1 0 0 512zM240 352c0 8.8 7.2 16 16 16s16-7.2 16-16V272h80c8.8 0 16-7.2 16-16s-7.2-16-16-16H272V160c0-8.8-7.2-16-16-16s-16 7.2-16 16v80H160c-8.8 0-16 7.2-16 16s7.2 16 16 16h80v80z'
        
      ]
    };

    
      var faPlusCircle = faCirclePlus;
    
  
    

    var faClockRotateLeft = {
      prefix: 'fal',
      iconName: 'clock-rotate-left',
      icon: [
        512,
        512,
        
            ['history']
        ,
        'f1da',
        
        'M32 132V48c0-8.8-7.2-16-16-16S0 39.2 0 48V176c0 8.8 7.2 16 16 16H144c8.8 0 16-7.2 16-16s-7.2-16-16-16H53.6C89.5 84.3 166.7 32 256 32c123.7 0 224 100.3 224 224s-100.3 224-224 224c-73.3 0-138.3-35.2-179.2-89.6c-5.3-7.1-15.3-8.5-22.4-3.2s-8.5 15.3-3.2 22.4C97.9 471.8 172.2 512 256 512c141.4 0 256-114.6 256-256S397.4 0 256 0C159.6 0 75.7 53.3 32 132zm224-4c-8.8 0-16 7.2-16 16V256c0 4.2 1.7 8.3 4.7 11.3l80 80c6.2 6.2 16.4 6.2 22.6 0s6.2-16.4 0-22.6L272 249.4V144c0-8.8-7.2-16-16-16z'
        
      ]
    };

    
      var faHistory = faClockRotateLeft;
    
  
    

    var faChevronRight = {
      prefix: 'fal',
      iconName: 'chevron-right',
      icon: [
        320,
        512,
        
            [9002]
        ,
        'f054',
        
        'M299.3 244.7c6.2 6.2 6.2 16.4 0 22.6l-192 192c-6.2 6.2-16.4 6.2-22.6 0s-6.2-16.4 0-22.6L265.4 256 84.7 75.3c-6.2-6.2-6.2-16.4 0-22.6s16.4-6.2 22.6 0l192 192z'
        
      ]
    };

    
  
    

    var faChevronLeft = {
      prefix: 'fal',
      iconName: 'chevron-left',
      icon: [
        320,
        512,
        
            [9001]
        ,
        'f053',
        
        'M20.7 267.3c-6.2-6.2-6.2-16.4 0-22.6l192-192c6.2-6.2 16.4-6.2 22.6 0s6.2 16.4 0 22.6L54.6 256 235.3 436.7c6.2 6.2 6.2 16.4 0 22.6s-16.4 6.2-22.6 0l-192-192z'
        
      ]
    };

    
  
    

    var faXmark = {
      prefix: 'fal',
      iconName: 'xmark',
      icon: [
        384,
        512,
        
            [215,10060,10006,10005,128473,'close','multiply','remove','times']
        ,
        'f00d',
        
        'M324.5 411.1c6.2 6.2 16.4 6.2 22.6 0s6.2-16.4 0-22.6L214.6 256 347.1 123.5c6.2-6.2 6.2-16.4 0-22.6s-16.4-6.2-22.6 0L192 233.4 59.5 100.9c-6.2-6.2-16.4-6.2-22.6 0s-6.2 16.4 0 22.6L169.4 256 36.9 388.5c-6.2 6.2-6.2 16.4 0 22.6s16.4 6.2 22.6 0L192 278.6 324.5 411.1z'
        
      ]
    };

    
      var faClose = faXmark;
    
      var faMultiply = faXmark;
    
      var faRemove = faXmark;
    
      var faTimes = faXmark;
    
  
    

    var faPlus = {
      prefix: 'fal',
      iconName: 'plus',
      icon: [
        448,
        512,
        
            [61543,10133,'add']
        ,
        '2b',
        
        'M240 64c0-8.8-7.2-16-16-16s-16 7.2-16 16V240H32c-8.8 0-16 7.2-16 16s7.2 16 16 16H208V448c0 8.8 7.2 16 16 16s16-7.2 16-16V272H416c8.8 0 16-7.2 16-16s-7.2-16-16-16H240V64z'
        
      ]
    };

    
      var faAdd = faPlus;
    
  
    

    var faUserHeadset = {
      prefix: 'fal',
      iconName: 'user-headset',
      icon: [
        448,
        512,
        
            []
          ,
        'f82d',
        
        'M224 32C135.6 32 64 103.6 64 192v16c0 8.8-7.2 16-16 16s-16-7.2-16-16V192C32 86 118 0 224 0S416 86 416 192v16c0 61.9-50.1 112-112 112H240 224 208c-17.7 0-32-14.3-32-32s14.3-32 32-32h32c17.7 0 32 14.3 32 32h32c44.2 0 80-35.8 80-80V192c0-88.4-71.6-160-160-160zm0 32c70.7 0 128 57.3 128 128c0 13.9-2.2 27.3-6.3 39.8C337.4 246.3 321.8 256 304 256h-8.4c15.2-17 24.4-39.4 24.4-64c0-53-43-96-96-96s-96 43-96 96c0 24.6 9.3 47.1 24.5 64.1c-5.4 9.4-8.5 20.3-8.5 31.9c0 1.4 0 2.7 .1 4C114.8 268.6 96 232.5 96 192c0-70.7 57.3-128 128-128zM208 352h16 16 64 9.6C387.8 352 448 412.2 448 486.4c0 14.1-11.5 25.6-25.6 25.6H25.6C11.5 512 0 500.5 0 486.4C0 412.2 60.2 352 134.4 352H208zm105.6 32H134.4C80 384 35.5 426.4 32.2 480H415.8c-3.3-53.6-47.8-96-102.2-96z'
        
      ]
    };

    
  
    

    var faCircleUser = {
      prefix: 'fal',
      iconName: 'circle-user',
      icon: [
        512,
        512,
        
            [62142,'user-circle']
        ,
        'f2bd',
        
        'M412.1 416.6C398.1 361.1 347.9 320 288 320H224c-59.9 0-110.1 41.1-124.1 96.6C58 375.9 32 319 32 256C32 132.3 132.3 32 256 32s224 100.3 224 224c0 63-26 119.9-67.9 160.6zm-28.5 23.4C347.5 465.2 303.5 480 256 480s-91.5-14.8-127.7-39.9c4-49.3 45.3-88.1 95.7-88.1h64c50.4 0 91.6 38.8 95.7 88.1zM256 512A256 256 0 1 0 256 0a256 256 0 1 0 0 512zm0-256a48 48 0 1 1 0-96 48 48 0 1 1 0 96zm-80-48a80 80 0 1 0 160 0 80 80 0 1 0 -160 0z'
        
      ]
    };

    
      var faUserCircle = faCircleUser;
    
  
    

    var faChevronDown = {
      prefix: 'fal',
      iconName: 'chevron-down',
      icon: [
        512,
        512,
        
            []
          ,
        'f078',
        
        'M267.3 395.3c-6.2 6.2-16.4 6.2-22.6 0l-192-192c-6.2-6.2-6.2-16.4 0-22.6s16.4-6.2 22.6 0L256 361.4 436.7 180.7c6.2-6.2 16.4-6.2 22.6 0s6.2 16.4 0 22.6l-192 192z'
        
      ]
    };

    
  
    

    var faPlay = {
      prefix: 'fal',
      iconName: 'play',
      icon: [
        384,
        512,
        
            [9654]
        ,
        'f04b',
        
        'M56.3 66.3c-4.9-3-11.1-3.1-16.2-.3s-8.2 8.2-8.2 14V432c0 5.8 3.1 11.1 8.2 14s11.2 2.7 16.2-.3l288-176c4.8-2.9 7.7-8.1 7.7-13.7s-2.9-10.7-7.7-13.7l-288-176zM24.5 38.1C39.7 29.6 58.2 30 73 39L361 215c14.3 8.7 23 24.2 23 41s-8.7 32.2-23 41L73 473c-14.8 9.1-33.4 9.4-48.5 .9S0 449.4 0 432V80C0 62.6 9.4 46.6 24.5 38.1z'
        
      ]
    };

    
  
    

    var faEraser = {
      prefix: 'fal',
      iconName: 'eraser',
      icon: [
        576,
        512,
        
            []
          ,
        'f12d',
        
        'M353 74.3c-9.4-9.4-24.6-9.4-33.9 0l-111 111L390.6 368l111-111c9.4-9.4 9.4-24.6 0-33.9L353 74.3zM74.3 319c-9.4 9.4-9.4 24.6 0 33.9l88 88c4.5 4.5 10.6 7 17 7H300.7c6.4 0 12.5-2.5 17-7L368 390.6 185.4 208 74.3 319zM296.4 51.7c21.9-21.9 57.3-21.9 79.2 0L524.3 200.4c21.9 21.9 21.9 57.3 0 79.2L355.9 448H528c8.8 0 16 7.2 16 16s-7.2 16-16 16H304v-.1c-1.1 .1-2.2 .1-3.3 .1H179.3c-14.9 0-29.1-5.9-39.6-16.4l-88-88c-21.9-21.9-21.9-57.3 0-79.2L296.4 51.7z'
        
      ]
    };

    
  
    

    var faGreaterThan = {
      prefix: 'fal',
      iconName: 'greater-than',
      icon: [
        384,
        512,
        
            [62769]
        ,
        '3e',
        
        'M1.7 72.8c-4 7.9-.7 17.5 7.2 21.5L332.2 256 8.8 417.7c-7.9 4-11.1 13.6-7.2 21.5s13.6 11.1 21.5 7.2l352-176c5.4-2.7 8.8-8.3 8.8-14.3s-3.4-11.6-8.8-14.3l-352-176c-7.9-4-17.5-.7-21.5 7.2z'
        
      ]
    };

    
  
    

    var faLocationDot = {
      prefix: 'fal',
      iconName: 'location-dot',
      icon: [
        384,
        512,
        
            ['map-marker-alt']
        ,
        'f3c5',
        
        'M352 192c0-88.4-71.6-160-160-160S32 103.6 32 192c0 15.6 5.4 37 16.6 63.4c10.9 25.9 26.2 54 43.6 82.1c34.1 55.3 74.4 108.2 99.9 140c25.4-31.8 65.8-84.7 99.9-140c17.3-28.1 32.7-56.3 43.6-82.1C346.6 229 352 207.6 352 192zm32 0c0 87.4-117 243-168.3 307.2c-12.3 15.3-35.1 15.3-47.4 0C117 435 0 279.4 0 192C0 86 86 0 192 0S384 86 384 192zm-240 0a48 48 0 1 0 96 0 48 48 0 1 0 -96 0zm48 80a80 80 0 1 1 0-160 80 80 0 1 1 0 160z'
        
      ]
    };

    
      var faMapMarkerAlt = faLocationDot;
    
  
    

    var faBookOpenReader = {
      prefix: 'fal',
      iconName: 'book-open-reader',
      icon: [
        512,
        512,
        
            ['book-reader']
        ,
        'f5da',
        
        'M256 32a64 64 0 1 1 0 128 64 64 0 1 1 0-128zm0 160A96 96 0 1 0 256 0a96 96 0 1 0 0 192zm0 48s-56.8-42.6-224-47.5C14.4 191.9 0 206.3 0 224V432c0 17.7 14.4 31.9 32 32.7c114.9 4.7 186.9 33.7 208.8 43.8c4.8 2.2 9.9 3.5 15.1 3.5s10.4-1.3 15.1-3.5c21.9-10.1 93.9-39.1 208.8-43.8c17.7-.7 32-15 32-32.7V224c0-17.7-14.4-32.1-32-31.5C312.8 197.4 256 240 256 240zm-18.9 25.8L240 268V473.3c-34-13.8-104.4-36.4-206.7-40.6c-.5 0-.9-.2-1.2-.5c-.1-.1-.1-.1-.1-.2l0 0 0 0 0 0 0 0 0 0 0 0V224.5c80.5 2.4 133.2 13.9 164.9 24.1c15.9 5.1 26.7 9.9 33 13.2c3.2 1.6 5.3 2.9 6.4 3.6c.4 .3 .7 .5 .9 .6zM272 268l2.9-2.2c.1-.1 .4-.3 .9-.6c1.1-.7 3.2-1.9 6.4-3.6c6.3-3.3 17-8.1 33-13.2c31.8-10.2 84.5-21.6 164.9-24.1V432v0l0 .1c0 0-.1 .1-.1 .1c-.3 .3-.7 .5-1.2 .5C376.4 436.9 306 459.5 272 473.3V268z'
        
      ]
    };

    
      var faBookReader = faBookOpenReader;
    
  
    

    var faLessThan = {
      prefix: 'fal',
      iconName: 'less-than',
      icon: [
        384,
        512,
        
            [62774]
        ,
        '3c',
        
        'M382.3 72.8c4 7.9 .7 17.5-7.2 21.5L51.8 256 375.2 417.7c7.9 4 11.1 13.6 7.2 21.5s-13.6 11.1-21.5 7.2l-352-176C3.4 267.6 0 262.1 0 256s3.4-11.6 8.8-14.3l352-176c7.9-4 17.5-.7 21.5 7.2z'
        
      ]
    };

    
  
    

    var faSquareArrowLeft = {
      prefix: 'fal',
      iconName: 'square-arrow-left',
      icon: [
        448,
        512,
        
            ['arrow-square-left']
        ,
        'f33a',
        
        'M32 416c0 17.7 14.3 32 32 32l320 0c17.7 0 32-14.3 32-32l0-320c0-17.7-14.3-32-32-32L64 64C46.3 64 32 78.3 32 96l0 320zm32 64c-35.3 0-64-28.7-64-64L0 96C0 60.7 28.7 32 64 32l320 0c35.3 0 64 28.7 64 64l0 320c0 35.3-28.7 64-64 64L64 480zm36.7-235.3l96-96c6.2-6.2 16.4-6.2 22.6 0s6.2 16.4 0 22.6L150.6 240 336 240c8.8 0 16 7.2 16 16s-7.2 16-16 16l-185.4 0 68.7 68.7c6.2 6.2 6.2 16.4 0 22.6s-16.4 6.2-22.6 0l-96-96c-6.2-6.2-6.2-16.4 0-22.6z'
        
      ]
    };

    
      var faArrowSquareLeft = faSquareArrowLeft;
    
  
    

    var faStop = {
      prefix: 'fal',
      iconName: 'stop',
      icon: [
        384,
        512,
        
            [9209]
        ,
        'f04d',
        
        'M320 96c17.7 0 32 14.3 32 32V384c0 17.7-14.3 32-32 32H64c-17.7 0-32-14.3-32-32V128c0-17.7 14.3-32 32-32H320zM64 64C28.7 64 0 92.7 0 128V384c0 35.3 28.7 64 64 64H320c35.3 0 64-28.7 64-64V128c0-35.3-28.7-64-64-64H64z'
        
      ]
    };

    
  
    

    var faImages = {
      prefix: 'fal',
      iconName: 'images',
      icon: [
        576,
        512,
        
            []
          ,
        'f302',
        
        'M160 64H512c17.7 0 32 14.3 32 32V201.4L486.6 144c-12.5-12.5-32.8-12.5-45.3 0L304 281.4 230.6 208c-12.5-12.5-32.8-12.5-45.3 0L128 265.4V96c0-17.7 14.3-32 32-32zM576 96c0-35.3-28.7-64-64-64H160c-35.3 0-64 28.7-64 64V304v16c0 35.3 28.7 64 64 64h80 0H512c35.3 0 64-28.7 64-64V240 240 96zM464 166.6l80 80V320c0 17.7-14.3 32-32 32H278.6l36.7-36.7L464 166.6zM281.4 304l-48 48H160c-17.7 0-32-14.3-32-32v-9.4l80-80L281.4 304zM32 112c0-8.8-7.2-16-16-16s-16 7.2-16 16V352c0 70.7 57.3 128 128 128H464c8.8 0 16-7.2 16-16s-7.2-16-16-16H128c-53 0-96-43-96-96V112zm232 48a24 24 0 1 0 0-48 24 24 0 1 0 0 48z'
        
      ]
    };

    
  
    

    var faPowerOff = {
      prefix: 'fal',
      iconName: 'power-off',
      icon: [
        512,
        512,
        
            [9211]
        ,
        'f011',
        
        'M272 16c0-8.8-7.2-16-16-16s-16 7.2-16 16V272c0 8.8 7.2 16 16 16s16-7.2 16-16V16zM164.3 78.2c7.8-4.1 10.9-13.7 6.9-21.6s-13.7-10.9-21.6-6.9C75 88.3 24 166.2 24 256c0 128.1 103.9 232 232 232s232-103.9 232-232c0-89.8-51-167.7-125.6-206.2c-7.8-4.1-17.5-1-21.6 6.9s-1 17.5 6.9 21.6C412.1 111.5 456 178.6 456 256c0 110.5-89.5 200-200 200S56 366.5 56 256c0-77.4 43.9-144.5 108.3-177.8z'
        
      ]
    };

    
  
    

    var faEllipsisVertical = {
      prefix: 'fal',
      iconName: 'ellipsis-vertical',
      icon: [
        128,
        512,
        
            ['ellipsis-v']
        ,
        'f142',
        
        'M64 384a32 32 0 1 0 0 64 32 32 0 1 0 0-64zm0-160a32 32 0 1 0 0 64 32 32 0 1 0 0-64zM96 96A32 32 0 1 0 32 96a32 32 0 1 0 64 0z'
        
      ]
    };

    
      var faEllipsisV = faEllipsisVertical;
    
  
    

    var faMinus = {
      prefix: 'fal',
      iconName: 'minus',
      icon: [
        448,
        512,
        
            [10134,8722,8211,'subtract']
        ,
        'f068',
        
        'M432 256c0 8.8-7.2 16-16 16L32 272c-8.8 0-16-7.2-16-16s7.2-16 16-16l384 0c8.8 0 16 7.2 16 16z'
        
      ]
    };

    
      var faSubtract = faMinus;
    
  
    

    var faCircleInfo = {
      prefix: 'fal',
      iconName: 'circle-info',
      icon: [
        512,
        512,
        
            ['info-circle']
        ,
        'f05a',
        
        'M256 32a224 224 0 1 1 0 448 224 224 0 1 1 0-448zm0 480A256 256 0 1 0 256 0a256 256 0 1 0 0 512zM208 352c-8.8 0-16 7.2-16 16s7.2 16 16 16h96c8.8 0 16-7.2 16-16s-7.2-16-16-16H272V240c0-8.8-7.2-16-16-16H216c-8.8 0-16 7.2-16 16s7.2 16 16 16h24v96H208zm48-168a24 24 0 1 0 0-48 24 24 0 1 0 0 48z'
        
      ]
    };

    
      var faInfoCircle = faCircleInfo;
    
  
    

    var faArrowLeft = {
      prefix: 'fal',
      iconName: 'arrow-left',
      icon: [
        448,
        512,
        
            [8592]
        ,
        'f060',
        
        'M4.7 244.7c-6.2 6.2-6.2 16.4 0 22.6l176 176c6.2 6.2 16.4 6.2 22.6 0s6.2-16.4 0-22.6L54.6 272 432 272c8.8 0 16-7.2 16-16s-7.2-16-16-16L54.6 240 203.3 91.3c6.2-6.2 6.2-16.4 0-22.6s-16.4-6.2-22.6 0l-176 176z'
        
      ]
    };

    
  
    

    var faCircleQuestion = {
      prefix: 'fal',
      iconName: 'circle-question',
      icon: [
        512,
        512,
        
            [62108,'question-circle']
        ,
        'f059',
        
        'M480 256A224 224 0 1 0 32 256a224 224 0 1 0 448 0zM0 256a256 256 0 1 1 512 0A256 256 0 1 1 0 256zm168.7-86.2c6.5-24.6 28.7-41.8 54.2-41.8H280c35.5 0 64 29 64 64.3c0 24-13.4 46.2-34.9 57.2L272 268.3V288c0 8.8-7.2 16-16 16s-16-7.2-16-16V258.5c0-6 3.4-11.5 8.7-14.3l45.8-23.4c10.7-5.4 17.5-16.6 17.5-28.7c0-17.8-14.4-32.3-32-32.3H222.9c-10.9 0-20.5 7.4-23.2 17.9l-.2 .7c-2.2 8.5-11 13.7-19.5 11.4s-13.7-11-11.4-19.5l.2-.7zM232 352a24 24 0 1 1 48 0 24 24 0 1 1 -48 0z'
        
      ]
    };

    
      var faQuestionCircle = faCircleQuestion;
    
  
    

    var faWrench = {
      prefix: 'fal',
      iconName: 'wrench',
      icon: [
        512,
        512,
        
            [128295]
        ,
        'f0ad',
        
        'M480 160c0-10.7-1.3-21.1-3.8-31l-48.9 48.9c-9 9-21.2 14.1-33.9 14.1H368c-26.5 0-48-21.5-48-48V118.6c0-12.7 5.1-24.9 14.1-33.9L383 35.8c-9.9-2.5-20.3-3.8-31-3.8c-70.7 0-128 57.3-128 128c0 9.2 1 18.1 2.8 26.7c3.2 15.2-.6 32.4-13.1 44.9L45.8 399.4C37 408.3 32 420.3 32 432.8C32 458.9 53.1 480 79.2 480c12.5 0 24.5-5 33.4-13.8L280.5 298.3c12.4-12.4 29.7-16.3 44.9-13.1c8.6 1.8 17.5 2.8 26.7 2.8c70.7 0 128-57.3 128-128zm32 0c0 88.4-71.6 160-160 160c-11.4 0-22.6-1.2-33.3-3.5c-5.6-1.2-11.5 .3-15.6 4.4L135.2 488.8c-14.9 14.9-35 23.2-56 23.2C35.5 512 0 476.5 0 432.8c0-21 8.3-41.1 23.2-56L191.1 208.9c4.1-4.1 5.6-10 4.4-15.6c-2.3-10.7-3.5-21.9-3.5-33.3C192 71.6 263.6 0 352 0c24.8 0 48.3 5.7 69.3 15.7c9.2 4.4 10.5 16.5 3.3 23.7l-67.9 67.9c-3 3-4.7 7.1-4.7 11.3V144c0 8.8 7.2 16 16 16h25.4c4.2 0 8.3-1.7 11.3-4.7l67.9-67.9c7.2-7.2 19.3-5.9 23.7 3.3c10.1 21 15.7 44.5 15.7 69.3zM88 408a16 16 0 1 1 0 32 16 16 0 1 1 0-32z'
        
      ]
    };

    
  
    

    var faCircle = {
      prefix: 'fal',
      iconName: 'circle',
      icon: [
        512,
        512,
        
            [61915,61708,11044,9899,9898,9679,128996,128995,128994,128993,128992,128309,128308]
        ,
        'f111',
        
        'M256 32a224 224 0 1 1 0 448 224 224 0 1 1 0-448zm0 480A256 256 0 1 0 256 0a256 256 0 1 0 0 512z'
        
      ]
    };

    
  
    

    var faLockKeyhole = {
      prefix: 'fal',
      iconName: 'lock-keyhole',
      icon: [
        448,
        512,
        
            ['lock-alt']
        ,
        'f30d',
        
        'M224 32c53 0 96 43 96 96v64H128V128c0-53 43-96 96-96zM96 128v64H80c-44.2 0-80 35.8-80 80V432c0 44.2 35.8 80 80 80H368c44.2 0 80-35.8 80-80V272c0-44.2-35.8-80-80-80H352V128C352 57.3 294.7 0 224 0S96 57.3 96 128zM80 224H368c26.5 0 48 21.5 48 48V432c0 26.5-21.5 48-48 48H80c-26.5 0-48-21.5-48-48V272c0-26.5 21.5-48 48-48zm160 88c0-8.8-7.2-16-16-16s-16 7.2-16 16v80c0 8.8 7.2 16 16 16s16-7.2 16-16V312z'
        
      ]
    };

    
      var faLockAlt = faLockKeyhole;
    
  
    

    var faArrowRight = {
      prefix: 'fal',
      iconName: 'arrow-right',
      icon: [
        448,
        512,
        
            [8594]
        ,
        'f061',
        
        'M443.3 267.3c6.2-6.2 6.2-16.4 0-22.6l-176-176c-6.2-6.2-16.4-6.2-22.6 0s-6.2 16.4 0 22.6L393.4 240 16 240c-8.8 0-16 7.2-16 16s7.2 16 16 16l377.4 0L244.7 420.7c-6.2 6.2-6.2 16.4 0 22.6s16.4 6.2 22.6 0l176-176z'
        
      ]
    };

    
  
    

    var faCircleArrowRight = {
      prefix: 'fal',
      iconName: 'circle-arrow-right',
      icon: [
        512,
        512,
        
            ['arrow-circle-right']
        ,
        'f0a9',
        
        'M480 256A224 224 0 1 1 32 256a224 224 0 1 1 448 0zM0 256a256 256 0 1 0 512 0A256 256 0 1 0 0 256zM283.3 363.3l96-96c6.2-6.2 6.2-16.4 0-22.6l-96-96c-6.2-6.2-16.4-6.2-22.6 0s-6.2 16.4 0 22.6L329.4 240 144 240c-8.8 0-16 7.2-16 16s7.2 16 16 16l185.4 0-68.7 68.7c-6.2 6.2-6.2 16.4 0 22.6s16.4 6.2 22.6 0z'
        
      ]
    };

    
      var faArrowCircleRight = faCircleArrowRight;
    
  
    

    var faSquare = {
      prefix: 'fal',
      iconName: 'square',
      icon: [
        448,
        512,
        
            [61590,9724,9723,9632]
        ,
        'f0c8',
        
        'M384 64c17.7 0 32 14.3 32 32V416c0 17.7-14.3 32-32 32H64c-17.7 0-32-14.3-32-32V96c0-17.7 14.3-32 32-32H384zM64 32C28.7 32 0 60.7 0 96V416c0 35.3 28.7 64 64 64H384c35.3 0 64-28.7 64-64V96c0-35.3-28.7-64-64-64H64z'
        
      ]
    };

    
  
    

    var faCommentQuestion = {
      prefix: 'fal',
      iconName: 'comment-question',
      icon: [
        512,
        512,
        
            []
          ,
        'e14b',
        
        'M32 240c0-91.4 93.8-176 224-176s224 84.6 224 176s-93.8 176-224 176c-32 0-63-5.9-93.5-16.2c-9.9-3.3-20.7-1.8-29.2 4.2c-15.4 10.7-31.4 20-48.4 27.4L91.2 446l-6.4-14.7c-10.5 4.6-21.5 8.6-32.7 11.5c.5-.9 1.1-1.8 1.6-2.6C68 416.5 76.3 391 79.4 363.9c1-9.2-2.1-17.7-7.4-23.9c-24.5-29.4-40-62.9-40-100zM256 32C114.5 32 0 125.2 0 240c0 46.6 19.6 87.1 47.4 120.5c0 .1 .1 .1 .1 .2c-2.6 22.6-9.5 43.5-21.3 63.1c-6.5 10.8-13.5 20.8-21.7 29c-4.5 4.6-5.9 11.5-3.4 17.4s8.3 9.8 14.8 9.8c28.7 0 57.6-8.9 81.6-19.3c19.2-8.4 37.1-18.7 53.9-30.5c.2-.1 .5-.2 .7-.1C185.5 441.3 220 448 256 448c141.5 0 256-93.2 256-208S397.5 32 256 32zM168.7 153.8l-.2 .7c-2.2 8.5 2.9 17.3 11.4 19.5s17.3-2.9 19.5-11.4l.2-.7c2.8-10.6 12.3-17.9 23.2-17.9H280c17.6 0 32 14.5 32 32.3c0 12.1-6.8 23.2-17.5 28.7l-45.8 23.4c-5.4 2.7-8.7 8.2-8.7 14.3V272c0 8.8 7.2 16 16 16s16-7.2 16-16V252.3l37.1-18.9c21.5-11 34.9-33.2 34.9-57.2c0-35.2-28.5-64.3-64-64.3H222.9c-25.5 0-47.7 17.2-54.2 41.8zM280 336a24 24 0 1 0 -48 0 24 24 0 1 0 48 0z'
        
      ]
    };

    
  
    

    var faCircleArrowLeft = {
      prefix: 'fal',
      iconName: 'circle-arrow-left',
      icon: [
        512,
        512,
        
            ['arrow-circle-left']
        ,
        'f0a8',
        
        'M32 256a224 224 0 1 1 448 0A224 224 0 1 1 32 256zm480 0A256 256 0 1 0 0 256a256 256 0 1 0 512 0zM228.7 148.7l-96 96c-6.2 6.2-6.2 16.4 0 22.6l96 96c6.2 6.2 16.4 6.2 22.6 0s6.2-16.4 0-22.6L182.6 272 368 272c8.8 0 16-7.2 16-16s-7.2-16-16-16l-185.4 0 68.7-68.7c6.2-6.2 6.2-16.4 0-22.6s-16.4-6.2-22.6 0z'
        
      ]
    };

    
      var faArrowCircleLeft = faCircleArrowLeft;
    
  
    

    var faPause = {
      prefix: 'fal',
      iconName: 'pause',
      icon: [
        320,
        512,
        
            [9208]
        ,
        'f04c',
        
        'M48 96c-8.8 0-16 7.2-16 16V400c0 8.8 7.2 16 16 16H96c8.8 0 16-7.2 16-16V112c0-8.8-7.2-16-16-16H48zM0 112C0 85.5 21.5 64 48 64H96c26.5 0 48 21.5 48 48V400c0 26.5-21.5 48-48 48H48c-26.5 0-48-21.5-48-48V112zM224 96c-8.8 0-16 7.2-16 16V400c0 8.8 7.2 16 16 16h48c8.8 0 16-7.2 16-16V112c0-8.8-7.2-16-16-16H224zm-48 16c0-26.5 21.5-48 48-48h48c26.5 0 48 21.5 48 48V400c0 26.5-21.5 48-48 48H224c-26.5 0-48-21.5-48-48V112z'
        
      ]
    };

    
  
    

    var faIdBadge = {
      prefix: 'fal',
      iconName: 'id-badge',
      icon: [
        384,
        512,
        
            []
          ,
        'f2c1',
        
        'M64 32C46.3 32 32 46.3 32 64V448c0 17.7 14.3 32 32 32H320c17.7 0 32-14.3 32-32V64c0-17.7-14.3-32-32-32H64zM0 64C0 28.7 28.7 0 64 0H320c35.3 0 64 28.7 64 64V448c0 35.3-28.7 64-64 64H64c-35.3 0-64-28.7-64-64V64zM224 224a32 32 0 1 0 -64 0 32 32 0 1 0 64 0zm-96 0a64 64 0 1 1 128 0 64 64 0 1 1 -128 0zm0-144c0-8.8 7.2-16 16-16h96c8.8 0 16 7.2 16 16s-7.2 16-16 16H144c-8.8 0-16-7.2-16-16zM112 400c0 8.8-7.2 16-16 16s-16-7.2-16-16c0-44.2 35.8-80 80-80h64c44.2 0 80 35.8 80 80c0 8.8-7.2 16-16 16s-16-7.2-16-16c0-26.5-21.5-48-48-48H160c-26.5 0-48 21.5-48 48z'
        
      ]
    };

    
  
    

    var faCircleCheck = {
      prefix: 'fal',
      iconName: 'circle-check',
      icon: [
        512,
        512,
        
            [61533,'check-circle']
        ,
        'f058',
        
        'M256 32a224 224 0 1 1 0 448 224 224 0 1 1 0-448zm0 480A256 256 0 1 0 256 0a256 256 0 1 0 0 512zM363.3 203.3c6.2-6.2 6.2-16.4 0-22.6s-16.4-6.2-22.6 0L224 297.4l-52.7-52.7c-6.2-6.2-16.4-6.2-22.6 0s-6.2 16.4 0 22.6l64 64c6.2 6.2 16.4 6.2 22.6 0l128-128z'
        
      ]
    };

    
      var faCheckCircle = faCircleCheck;
    
  
    

    var faSquarePlus = {
      prefix: 'fal',
      iconName: 'square-plus',
      icon: [
        448,
        512,
        
            [61846,'plus-square']
        ,
        'f0fe',
        
        'M64 64C46.3 64 32 78.3 32 96V416c0 17.7 14.3 32 32 32H384c17.7 0 32-14.3 32-32V96c0-17.7-14.3-32-32-32H64zM0 96C0 60.7 28.7 32 64 32H384c35.3 0 64 28.7 64 64V416c0 35.3-28.7 64-64 64H64c-35.3 0-64-28.7-64-64V96zM208 352V272H128c-8.8 0-16-7.2-16-16s7.2-16 16-16h80V160c0-8.8 7.2-16 16-16s16 7.2 16 16v80h80c8.8 0 16 7.2 16 16s-7.2 16-16 16H240v80c0 8.8-7.2 16-16 16s-16-7.2-16-16z'
        
      ]
    };

    
      var faPlusSquare = faSquarePlus;
    
  
    

    var faVolume = {
      prefix: 'fal',
      iconName: 'volume',
      icon: [
        576,
        512,
        
            [128265,'volume-medium']
        ,
        'f6a8',
        
        'M320 66.7L183.6 188c-2.9 2.6-6.7 4-10.6 4H88c-13.3 0-24 10.7-24 24v80c0 13.3 10.7 24 24 24h85c3.9 0 7.7 1.4 10.6 4L320 445.3V66.7zM302.4 39.5c5.5-4.8 12.5-7.5 19.8-7.5C338.7 32 352 45.3 352 61.8V450.2c0 16.5-13.3 29.8-29.8 29.8c-7.3 0-14.3-2.7-19.8-7.5l10.6-12-10.6 12L166.9 352H88c-30.9 0-56-25.1-56-56V216c0-30.9 25.1-56 56-56h78.9L302.4 39.5zM419.2 182.4c5.3-7.1 15.3-8.5 22.4-3.2C464.9 196.7 480 224.6 480 256s-15.1 59.3-38.4 76.8c-7.1 5.3-17.1 3.9-22.4-3.2s-3.9-17.1 3.2-22.4C438 295.5 448 276.9 448 256s-10-39.5-25.6-51.2c-7.1-5.3-8.5-15.3-3.2-22.4zm87-74.5C548.8 143.1 576 196.4 576 256s-27.2 112.9-69.8 148.1c-6.8 5.6-16.9 4.7-22.5-2.1s-4.7-16.9 2.1-22.5C521.4 350.1 544 305.7 544 256s-22.6-94.1-58.2-123.4c-6.8-5.6-7.8-15.7-2.1-22.5s15.7-7.8 22.5-2.1z'
        
      ]
    };

    
      var faVolumeMedium = faVolume;
    
  
    

    var faUserPen = {
      prefix: 'fal',
      iconName: 'user-pen',
      icon: [
        640,
        512,
        
            ['user-edit']
        ,
        'f4ff',
        
        'M320 128a96 96 0 1 0 -192 0 96 96 0 1 0 192 0zM96 128a128 128 0 1 1 256 0A128 128 0 1 1 96 128zM32 480H322.2l-1 3.8c-2.4 9.5-1.8 19.3 1.4 28.2H29.7C13.3 512 0 498.7 0 482.3C0 383.8 79.8 304 178.3 304h91.4c44.2 0 84.6 16.1 115.8 42.7l-22.7 22.7c-25.3-20.9-57.7-33.4-93.1-33.4H178.3c-80 0-145 64.3-146.3 144zM582.8 264c-6.2-6.2-16.4-6.2-22.6 0l-24.8 24.8 40 40L600.2 304c6.2-6.2 6.2-16.4 0-22.6L582.8 264zM406.5 417.7c-2.1 2.1-3.5 4.6-4.2 7.4l-12.3 49 49-12.3c2.8-.7 5.4-2.2 7.4-4.2L552.7 351.4l-40-40L406.5 417.7zM537.5 241.4c18.7-18.7 49.1-18.7 67.9 0l17.4 17.4c18.7 18.7 18.7 49.1 0 67.9L469.1 480.3c-6.2 6.2-13.9 10.5-22.3 12.6l-74.9 18.7c-5.5 1.4-11.2-.2-15.2-4.2s-5.6-9.7-4.2-15.2l18.7-74.9c2.1-8.4 6.5-16.1 12.6-22.3L537.5 241.4z'
        
      ]
    };

    
      var faUserEdit = faUserPen;
    
  
    

    var faBooks = {
      prefix: 'fal',
      iconName: 'books',
      icon: [
        512,
        512,
        
            [128218]
        ,
        'f5db',
        
        'M128 416v48c0 8.8-7.2 16-16 16H48c-8.8 0-16-7.2-16-16V416h96zm-16 96c12.3 0 23.5-4.6 32-12.2c8.5 7.6 19.7 12.2 32 12.2h64c26.5 0 48-21.5 48-48V416 400 384 193.8l51.4 198.1 4 15.5 18 69.2c6.6 25.5 32 40.6 56.7 33.8l59.6-16.5c24.7-6.8 39.3-33 32.7-58.5l-13.9-53.7-4-15.5-63.9-246-4-15.5-18-69.2C400 9.9 374.6-5.2 349.9 1.6L290.3 18.1c-3.5 1-6.8 2.3-9.9 4C271.9 8.8 257 0 240 0H176c-12.3 0-23.5 4.6-32 12.2C135.5 4.6 124.3 0 112 0H48C21.5 0 0 21.5 0 48V96v16 16V384v16 16 48c0 26.5 21.5 48 48 48h64zM288 64.8V63.5c.3-7.2 5.1-13 10.8-14.6l59.6-16.5c6.6-1.8 14.8 2 17.2 11l14.1 54.2-87.3 24.2L288.6 68.6c-.3-1.3-.5-2.6-.6-3.8zm-32-.6c0 0 0 0 0 0V96H160V48c0-8.8 7.2-16 16-16h64c8.8 0 16 7.2 16 16V64.2zM176 480c-8.8 0-16-7.2-16-16V416h96v48c0 8.8-7.2 16-16 16H176zM128 128V384H32V128h96zm0-80V96H32V48c0-8.8 7.2-16 16-16h64c8.8 0 16 7.2 16 16zM256 384H160V128h96V384zM397.7 128.7l59.8 230.5-87.3 24.2L310.4 152.8l87.3-24.2zm67.9 261.5l13.8 53.2c2.4 9.4-3.2 17.7-10.3 19.6l-59.6 16.5c-6.6 1.8-14.8-2-17.2-11l-14.1-54.2 87.3-24.2z'
        
      ]
    };

    
  
    

    var faHighlighter = {
      prefix: 'fal',
      iconName: 'highlighter',
      icon: [
        576,
        512,
        
            []
          ,
        'f591',
        
        'M176 296.6v-48c0-5.2 2.5-10 6.7-13l27-19.4L343.7 350.4l-19.4 27c-3 4.2-7.8 6.7-13 6.7h-48c-8.5 0-16.6 3.4-22.6 9.4L197 437.1c-3.1 3.1-8.2 3.1-11.3 0l-62.8-62.8c-3.1-3.1-3.1-8.2 0-11.3l43.7-43.7c6-6 9.4-14.1 9.4-22.6zM523.8 99.5L362.6 324 236 197.4 460.5 36.2c3.8-2.7 8.4-4.2 13-4.2c5.9 0 11.6 2.4 15.8 6.5l32.2 32.2c4.2 4.2 6.5 9.9 6.5 15.8c0 4.7-1.5 9.2-4.2 13zM263.4 416h48c15.5 0 30-7.4 39-20L549.8 118.2C556.4 109 560 97.9 560 86.5c0-14.4-5.7-28.2-15.9-38.4L511.9 15.9C501.7 5.7 487.9 0 473.5 0C462.1 0 451 3.6 441.8 10.2L164 209.6c-12.6 9-20 23.5-20 39v48l-43.7 43.7c-11.4 11.4-14.5 27.9-9.3 42l-84 84c-4.5 4.5-7 10.6-7 17V488c0 13.3 10.7 24 24 24H124.7c6.4 0 12.5-2.5 17-7l36-36c14.2 5.2 30.7 2.1 42-9.3L263.4 416zm-111 33l-31 31H38.6L111 407.6 152.4 449z'
        
      ]
    };

    
  
    

    var faUser = {
      prefix: 'fal',
      iconName: 'user',
      icon: [
        448,
        512,
        
            [62144,128100]
        ,
        'f007',
        
        'M320 128a96 96 0 1 0 -192 0 96 96 0 1 0 192 0zM96 128a128 128 0 1 1 256 0A128 128 0 1 1 96 128zM32 480H416c-1.2-79.7-66.2-144-146.3-144H178.3c-80 0-145 64.3-146.3 144zM0 482.3C0 383.8 79.8 304 178.3 304h91.4C368.2 304 448 383.8 448 482.3c0 16.4-13.3 29.7-29.7 29.7H29.7C13.3 512 0 498.7 0 482.3z'
        
      ]
    };

    
  
    

    var faChevronUp = {
      prefix: 'fal',
      iconName: 'chevron-up',
      icon: [
        512,
        512,
        
            []
          ,
        'f077',
        
        'M244.7 116.7c6.2-6.2 16.4-6.2 22.6 0l192 192c6.2 6.2 6.2 16.4 0 22.6s-16.4 6.2-22.6 0L256 150.6 75.3 331.3c-6.2 6.2-16.4 6.2-22.6 0s-6.2-16.4 0-22.6l192-192z'
        
      ]
    };

    
  
    

    var faUsers = {
      prefix: 'fal',
      iconName: 'users',
      icon: [
        640,
        512,
        
            []
          ,
        'f0c0',
        
        'M96 80a48 48 0 1 1 96 0A48 48 0 1 1 96 80zm128 0A80 80 0 1 0 64 80a80 80 0 1 0 160 0zm96 80a64 64 0 1 1 0 128 64 64 0 1 1 0-128zm0 160a96 96 0 1 0 0-192 96 96 0 1 0 0 192zm-58.7 64H378.7c54.2 0 98.4 42.5 101.2 96H160.1c2.8-53.5 47-96 101.2-96zm0-32C187.7 352 128 411.7 128 485.3c0 14.7 11.9 26.7 26.7 26.7H485.3c14.7 0 26.7-11.9 26.7-26.7C512 411.7 452.3 352 378.7 352H261.3zM512 32a48 48 0 1 1 0 96 48 48 0 1 1 0-96zm0 128A80 80 0 1 0 512 0a80 80 0 1 0 0 160zm16 64c44.2 0 80 35.8 80 80c0 8.8 7.2 16 16 16s16-7.2 16-16c0-61.9-50.1-112-112-112H444c2.6 10.2 4 21 4 32h80zm-336 0c0-11 1.4-21.8 4-32H112C50.1 192 0 242.1 0 304c0 8.8 7.2 16 16 16s16-7.2 16-16c0-44.2 35.8-80 80-80h80z'
        
      ]
    };

    
  
    

    var faLightbulbOn = {
      prefix: 'fal',
      iconName: 'lightbulb-on',
      icon: [
        640,
        512,
        
            []
          ,
        'f672',
        
        'M55.2 1.7c-7.9-4-17.5-.7-21.5 7.2s-.7 17.5 7.2 21.5l64 32c7.9 4 17.5 .7 21.5-7.2s.7-17.5-7.2-21.5l-64-32zm544 28.6c7.9-4 11.1-13.6 7.2-21.5s-13.6-11.1-21.5-7.2l-64 32c-7.9 4-11.1 13.6-7.2 21.5s13.6 11.1 21.5 7.2l64-32zM16 160c-8.8 0-16 7.2-16 16s7.2 16 16 16H80c8.8 0 16-7.2 16-16s-7.2-16-16-16H16zm544 0c-8.8 0-16 7.2-16 16s7.2 16 16 16h64c8.8 0 16-7.2 16-16s-7.2-16-16-16H560zM119.2 318.3c7.9-4 11.1-13.6 7.2-21.5s-13.6-11.1-21.5-7.2l-64 32c-7.9 4-11.1 13.6-7.2 21.5s13.6 11.1 21.5 7.2l64-32zm416-28.6c-7.9-4-17.5-.7-21.5 7.2s-.7 17.5 7.2 21.5l64 32c7.9 4 17.5 .7 21.5-7.2s.7-17.5-7.2-21.5l-64-32zM464 176c0 30.6-9.5 58.8-25.7 82.1c-4.1 5.9-8.7 12.3-13.6 19c-12.7 17.5-27.1 37.2-38 57.1c-8.9 16.2-13.7 33.3-16.2 49.9H403c2.2-12 5.9-23.7 11.8-34.5c9.9-18 22.2-34.9 34.5-51.8l0 0 0 0 0 0c5.2-7.1 10.4-14.2 15.4-21.4c19.8-28.5 31.4-63 31.4-100.3C496 78.8 417.2 0 320 0S144 78.8 144 176c0 37.3 11.6 71.9 31.4 100.3c5 7.2 10.2 14.3 15.4 21.4l0 0 0 0 0 0c12.3 16.8 24.6 33.7 34.5 51.8c5.9 10.8 9.6 22.5 11.8 34.5h32.4c-2.5-16.6-7.3-33.7-16.2-49.9c-10.9-20-25.3-39.7-38-57.1l0 0c-4.9-6.7-9.5-13-13.6-19C185.5 234.8 176 206.6 176 176c0-79.5 64.5-144 144-144s144 64.5 144 144zm-224 0c0-44.2 35.8-80 80-80c8.8 0 16-7.2 16-16s-7.2-16-16-16c-61.9 0-112 50.1-112 112c0 8.8 7.2 16 16 16s16-7.2 16-16zm80 304c-20.9 0-38.7-13.4-45.3-32h90.5c-6.6 18.6-24.4 32-45.3 32zm-80-53.3V432c0 44.2 35.8 80 80 80s80-35.8 80-80v-5.3c0-5.9-4.8-10.7-10.7-10.7H250.7c-5.9 0-10.7 4.8-10.7 10.7z'
        
      ]
    };

    
  
    

    var faLock = {
      prefix: 'fal',
      iconName: 'lock',
      icon: [
        448,
        512,
        
            [128274]
        ,
        'f023',
        
        'M128 128v64H320V128c0-53-43-96-96-96s-96 43-96 96zM96 192V128C96 57.3 153.3 0 224 0s128 57.3 128 128v64h16c44.2 0 80 35.8 80 80V432c0 44.2-35.8 80-80 80H80c-44.2 0-80-35.8-80-80V272c0-44.2 35.8-80 80-80H96zM32 272V432c0 26.5 21.5 48 48 48H368c26.5 0 48-21.5 48-48V272c0-26.5-21.5-48-48-48H80c-26.5 0-48 21.5-48 48z'
        
      ]
    };

    
  
    

    var faCircleDot = {
      prefix: 'fal',
      iconName: 'circle-dot',
      icon: [
        512,
        512,
        
            [128280,'dot-circle']
        ,
        'f192',
        
        'M480 256A224 224 0 1 0 32 256a224 224 0 1 0 448 0zM0 256a256 256 0 1 1 512 0A256 256 0 1 1 0 256zm320 0a64 64 0 1 0 -128 0 64 64 0 1 0 128 0zm-160 0a96 96 0 1 1 192 0 96 96 0 1 1 -192 0z'
        
      ]
    };

    
      var faDotCircle = faCircleDot;
    
  
    

    var faSquareCheck = {
      prefix: 'fal',
      iconName: 'square-check',
      icon: [
        448,
        512,
        
            [61510,9989,9745,'check-square']
        ,
        'f14a',
        
        'M64 64C46.3 64 32 78.3 32 96V416c0 17.7 14.3 32 32 32H384c17.7 0 32-14.3 32-32V96c0-17.7-14.3-32-32-32H64zM0 96C0 60.7 28.7 32 64 32H384c35.3 0 64 28.7 64 64V416c0 35.3-28.7 64-64 64H64c-35.3 0-64-28.7-64-64V96zM331.3 203.3l-128 128c-6.2 6.2-16.4 6.2-22.6 0l-64-64c-6.2-6.2-6.2-16.4 0-22.6s16.4-6.2 22.6 0L192 297.4 308.7 180.7c6.2-6.2 16.4-6.2 22.6 0s6.2 16.4 0 22.6z'
        
      ]
    };

    
      var faCheckSquare = faSquareCheck;
    
  
    

    var faLightbulb = {
      prefix: 'fal',
      iconName: 'lightbulb',
      icon: [
        384,
        512,
        
            [128161]
        ,
        'f0eb',
        
        'M310.3 258.1C326.5 234.8 336 206.6 336 176c0-79.5-64.5-144-144-144S48 96.5 48 176c0 30.6 9.5 58.8 25.7 82.1c4.1 5.9 8.8 12.3 13.6 19l0 0c12.7 17.5 27.1 37.2 38 57.1c8.9 16.2 13.7 33.3 16.2 49.9H109c-2.2-12-5.9-23.7-11.8-34.5c-9.9-18-22.2-34.9-34.5-51.8l0 0 0 0 0 0c-5.2-7.1-10.4-14.2-15.4-21.4C27.6 247.9 16 213.3 16 176C16 78.8 94.8 0 192 0s176 78.8 176 176c0 37.3-11.6 71.9-31.4 100.3c-5 7.2-10.2 14.3-15.4 21.4l0 0 0 0c-12.3 16.8-24.6 33.7-34.5 51.8c-5.9 10.8-9.6 22.5-11.8 34.5H242.5c2.5-16.6 7.3-33.7 16.2-49.9c10.9-20 25.3-39.7 38-57.1c4.9-6.7 9.5-13 13.6-19zM192 96c-44.2 0-80 35.8-80 80c0 8.8-7.2 16-16 16s-16-7.2-16-16c0-61.9 50.1-112 112-112c8.8 0 16 7.2 16 16s-7.2 16-16 16zM146.7 448c6.6 18.6 24.4 32 45.3 32s38.7-13.4 45.3-32H146.7zM112 432v-5.3c0-5.9 4.8-10.7 10.7-10.7H261.3c5.9 0 10.7 4.8 10.7 10.7V432c0 44.2-35.8 80-80 80s-80-35.8-80-80z'
        
      ]
    };

    
  
    

    var faBars = {
      prefix: 'fal',
      iconName: 'bars',
      icon: [
        448,
        512,
        
            ['navicon']
        ,
        'f0c9',
        
        'M0 80c0-8.8 7.2-16 16-16H432c8.8 0 16 7.2 16 16s-7.2 16-16 16H16C7.2 96 0 88.8 0 80zM0 240c0-8.8 7.2-16 16-16H432c8.8 0 16 7.2 16 16s-7.2 16-16 16H16c-8.8 0-16-7.2-16-16zM448 400c0 8.8-7.2 16-16 16H16c-8.8 0-16-7.2-16-16s7.2-16 16-16H432c8.8 0 16 7.2 16 16z'
        
      ]
    };

    
      var faNavicon = faBars;
    
  
    

    var faSquareMinus = {
      prefix: 'fal',
      iconName: 'square-minus',
      icon: [
        448,
        512,
        
            [61767,'minus-square']
        ,
        'f146',
        
        'M64 64C46.3 64 32 78.3 32 96V416c0 17.7 14.3 32 32 32H384c17.7 0 32-14.3 32-32V96c0-17.7-14.3-32-32-32H64zM0 96C0 60.7 28.7 32 64 32H384c35.3 0 64 28.7 64 64V416c0 35.3-28.7 64-64 64H64c-35.3 0-64-28.7-64-64V96zM128 240H320c8.8 0 16 7.2 16 16s-7.2 16-16 16H128c-8.8 0-16-7.2-16-16s7.2-16 16-16z'
        
      ]
    };

    
      var faMinusSquare = faSquareMinus;
    
  
    

    var faCircleNotch = {
      prefix: 'fal',
      iconName: 'circle-notch',
      icon: [
        512,
        512,
        
            []
          ,
        'f1ce',
        
        'M207.4 20.4c2.4 8.5-2.6 17.3-11.2 19.7C101.5 66.2 32 153 32 256c0 123.7 100.3 224 224 224s224-100.3 224-224c0-103-69.5-189.8-164.3-215.9c-8.5-2.4-13.5-11.2-11.2-19.7s11.2-13.5 19.7-11.2C432.5 39.1 512 138.2 512 256c0 141.4-114.6 256-256 256S0 397.4 0 256C0 138.2 79.5 39.1 187.7 9.2c8.5-2.4 17.3 2.6 19.7 11.2z'
        
      ]
    };

    
  
    

    var faSquareArrowRight = {
      prefix: 'fal',
      iconName: 'square-arrow-right',
      icon: [
        448,
        512,
        
            ['arrow-square-right']
        ,
        'f33b',
        
        'M416 96c0-17.7-14.3-32-32-32L64 64C46.3 64 32 78.3 32 96l0 320c0 17.7 14.3 32 32 32l320 0c17.7 0 32-14.3 32-32l0-320zM384 32c35.3 0 64 28.7 64 64l0 320c0 35.3-28.7 64-64 64L64 480c-35.3 0-64-28.7-64-64L0 96C0 60.7 28.7 32 64 32l320 0zM347.3 267.3l-96 96c-6.2 6.2-16.4 6.2-22.6 0s-6.2-16.4 0-22.6L297.4 272 112 272c-8.8 0-16-7.2-16-16s7.2-16 16-16l185.4 0-68.7-68.7c-6.2-6.2-6.2-16.4 0-22.6s16.4-6.2 22.6 0l96 96c6.2 6.2 6.2 16.4 0 22.6z'
        
      ]
    };

    
      var faArrowSquareRight = faSquareArrowRight;
    
  
    

    var faCalculatorSimple = {
      prefix: 'fal',
      iconName: 'calculator-simple',
      icon: [
        512,
        512,
        
            ['calculator-alt']
        ,
        'f64c',
        
        'M256 0c8.8 0 16 7.2 16 16V240H496c8.8 0 16 7.2 16 16s-7.2 16-16 16H272V496c0 8.8-7.2 16-16 16s-16-7.2-16-16V272H16c-8.8 0-16-7.2-16-16s7.2-16 16-16H240V16c0-8.8 7.2-16 16-16zm88 96h40V56 48c0-8.8 7.2-16 16-16s16 7.2 16 16v8V96h40 8c8.8 0 16 7.2 16 16s-7.2 16-16 16h-8H416v40 8c0 8.8-7.2 16-16 16s-16-7.2-16-16v-8V128H344h-8c-8.8 0-16-7.2-16-16s7.2-16 16-16h8zM53.1 341.1c6.2-6.2 16.4-6.2 22.6 0L112 377.4l36.3-36.3c6.2-6.2 16.4-6.2 22.6 0s6.2 16.4 0 22.6L134.6 400l36.3 36.3c6.2 6.2 6.2 16.4 0 22.6s-16.4 6.2-22.6 0L112 422.6 75.7 458.9c-6.2 6.2-16.4 6.2-22.6 0s-6.2-16.4 0-22.6L89.4 400 53.1 363.7c-6.2-6.2-6.2-16.4 0-22.6zM48 96H176c8.8 0 16 7.2 16 16s-7.2 16-16 16H48c-8.8 0-16-7.2-16-16s7.2-16 16-16zM336 352H464c8.8 0 16 7.2 16 16s-7.2 16-16 16H336c-8.8 0-16-7.2-16-16s7.2-16 16-16zm0 64H464c8.8 0 16 7.2 16 16s-7.2 16-16 16H336c-8.8 0-16-7.2-16-16s7.2-16 16-16z'
        
      ]
    };

    
      var faCalculatorAlt = faCalculatorSimple;
    
  
    

    var faCircleMinus = {
      prefix: 'fal',
      iconName: 'circle-minus',
      icon: [
        512,
        512,
        
            ['minus-circle']
        ,
        'f056',
        
        'M256 32a224 224 0 1 1 0 448 224 224 0 1 1 0-448zm0 480A256 256 0 1 0 256 0a256 256 0 1 0 0 512zM160 240c-8.8 0-16 7.2-16 16s7.2 16 16 16H352c8.8 0 16-7.2 16-16s-7.2-16-16-16H160z'
        
      ]
    };

    
      var faMinusCircle = faCircleMinus;
    
  

  return {
  
    faDown: faDown,
    
      faArrowAltDown: faArrowAltDown,
    
  
    faCircleXmark: faCircleXmark,
    
      faTimesCircle: faTimesCircle,
    
      faXmarkCircle: faXmarkCircle,
    
  
    faBookOpen: faBookOpen,
    
  
    faCheck: faCheck,
    
  
    faBook: faBook,
    
  
    faCirclePlus: faCirclePlus,
    
      faPlusCircle: faPlusCircle,
    
  
    faClockRotateLeft: faClockRotateLeft,
    
      faHistory: faHistory,
    
  
    faChevronRight: faChevronRight,
    
  
    faChevronLeft: faChevronLeft,
    
  
    faXmark: faXmark,
    
      faClose: faClose,
    
      faMultiply: faMultiply,
    
      faRemove: faRemove,
    
      faTimes: faTimes,
    
  
    faPlus: faPlus,
    
      faAdd: faAdd,
    
  
    faUserHeadset: faUserHeadset,
    
  
    faCircleUser: faCircleUser,
    
      faUserCircle: faUserCircle,
    
  
    faChevronDown: faChevronDown,
    
  
    faPlay: faPlay,
    
  
    faEraser: faEraser,
    
  
    faGreaterThan: faGreaterThan,
    
  
    faLocationDot: faLocationDot,
    
      faMapMarkerAlt: faMapMarkerAlt,
    
  
    faBookOpenReader: faBookOpenReader,
    
      faBookReader: faBookReader,
    
  
    faLessThan: faLessThan,
    
  
    faSquareArrowLeft: faSquareArrowLeft,
    
      faArrowSquareLeft: faArrowSquareLeft,
    
  
    faStop: faStop,
    
  
    faImages: faImages,
    
  
    faPowerOff: faPowerOff,
    
  
    faEllipsisVertical: faEllipsisVertical,
    
      faEllipsisV: faEllipsisV,
    
  
    faMinus: faMinus,
    
      faSubtract: faSubtract,
    
  
    faCircleInfo: faCircleInfo,
    
      faInfoCircle: faInfoCircle,
    
  
    faArrowLeft: faArrowLeft,
    
  
    faCircleQuestion: faCircleQuestion,
    
      faQuestionCircle: faQuestionCircle,
    
  
    faWrench: faWrench,
    
  
    faCircle: faCircle,
    
  
    faLockKeyhole: faLockKeyhole,
    
      faLockAlt: faLockAlt,
    
  
    faArrowRight: faArrowRight,
    
  
    faCircleArrowRight: faCircleArrowRight,
    
      faArrowCircleRight: faArrowCircleRight,
    
  
    faSquare: faSquare,
    
  
    faCommentQuestion: faCommentQuestion,
    
  
    faCircleArrowLeft: faCircleArrowLeft,
    
      faArrowCircleLeft: faArrowCircleLeft,
    
  
    faPause: faPause,
    
  
    faIdBadge: faIdBadge,
    
  
    faCircleCheck: faCircleCheck,
    
      faCheckCircle: faCheckCircle,
    
  
    faSquarePlus: faSquarePlus,
    
      faPlusSquare: faPlusSquare,
    
  
    faVolume: faVolume,
    
      faVolumeMedium: faVolumeMedium,
    
  
    faUserPen: faUserPen,
    
      faUserEdit: faUserEdit,
    
  
    faBooks: faBooks,
    
  
    faHighlighter: faHighlighter,
    
  
    faUser: faUser,
    
  
    faChevronUp: faChevronUp,
    
  
    faUsers: faUsers,
    
  
    faLightbulbOn: faLightbulbOn,
    
  
    faLock: faLock,
    
  
    faCircleDot: faCircleDot,
    
      faDotCircle: faDotCircle,
    
  
    faSquareCheck: faSquareCheck,
    
      faCheckSquare: faCheckSquare,
    
  
    faLightbulb: faLightbulb,
    
  
    faBars: faBars,
    
      faNavicon: faNavicon,
    
  
    faSquareMinus: faSquareMinus,
    
      faMinusSquare: faMinusSquare,
    
  
    faCircleNotch: faCircleNotch,
    
  
    faSquareArrowRight: faSquareArrowRight,
    
      faArrowSquareRight: faArrowSquareRight,
    
  
    faCalculatorSimple: faCalculatorSimple,
    
      faCalculatorAlt: faCalculatorAlt,
    
  
    faCircleMinus: faCircleMinus,
    
      faMinusCircle: faMinusCircle,
    
  
  };

 })()
  

  
  var farIcons = (function () {
  
    

    var faPrint = {
      prefix: 'far',
      iconName: 'print',
      icon: [
        512,
        512,
        
            [9113,128438,128424]
        ,
        'f02f',
        
        'M112 160V64c0-8.8 7.2-16 16-16H357.5c4.2 0 8.3 1.7 11.3 4.7l26.5 26.5c3 3 4.7 7.1 4.7 11.3V160h48V90.5c0-17-6.7-33.3-18.7-45.3L402.7 18.7C390.7 6.7 374.5 0 357.5 0H128C92.7 0 64 28.7 64 64v96h48zm16 208H384v96H128V368zm-16-48c-17.7 0-32 14.3-32 32H48V256c0-8.8 7.2-16 16-16H448c8.8 0 16 7.2 16 16v96H432c0-17.7-14.3-32-32-32H112zm320 80h48c17.7 0 32-14.3 32-32V256c0-35.3-28.7-64-64-64H64c-35.3 0-64 28.7-64 64V368c0 17.7 14.3 32 32 32H80v80c0 17.7 14.3 32 32 32H400c17.7 0 32-14.3 32-32V400z'
        
      ]
    };

    
  
    

    var faDown = {
      prefix: 'far',
      iconName: 'down',
      icon: [
        384,
        512,
        
            ['arrow-alt-down']
        ,
        'f354',
        
        'M192 429.6L49.3 279.7c-.8-.8-1.3-2-1.3-3.2c0-2.5 2-4.6 4.6-4.6l83.4 0c13.3 0 24-10.7 24-24l0-168 64 0 0 168c0 13.3 10.7 24 24 24l83.4 0c2.5 0 4.6 2 4.6 4.6c0 1.2-.5 2.3-1.3 3.2L192 429.6zM0 276.6c0 13.5 5.2 26.5 14.5 36.3L161.1 466.8c8.1 8.5 19.2 13.2 30.9 13.2s22.8-4.8 30.9-13.2L369.5 312.8c9.3-9.8 14.5-22.8 14.5-36.3c0-29-23.5-52.6-52.6-52.6L272 224l0-144c0-26.5-21.5-48-48-48l-64 0c-26.5 0-48 21.5-48 48l0 144-59.4 0C23.5 224 0 247.5 0 276.6z'
        
      ]
    };

    
      var faArrowAltDown = faDown;
    
  
    

    var faCircleXmark = {
      prefix: 'far',
      iconName: 'circle-xmark',
      icon: [
        512,
        512,
        
            [61532,'times-circle','xmark-circle']
        ,
        'f057',
        
        'M256 48a208 208 0 1 1 0 416 208 208 0 1 1 0-416zm0 464A256 256 0 1 0 256 0a256 256 0 1 0 0 512zM175 175c-9.4 9.4-9.4 24.6 0 33.9l47 47-47 47c-9.4 9.4-9.4 24.6 0 33.9s24.6 9.4 33.9 0l47-47 47 47c9.4 9.4 24.6 9.4 33.9 0s9.4-24.6 0-33.9l-47-47 47-47c9.4-9.4 9.4-24.6 0-33.9s-24.6-9.4-33.9 0l-47 47-47-47c-9.4-9.4-24.6-9.4-33.9 0z'
        
      ]
    };

    
      var faTimesCircle = faCircleXmark;
    
      var faXmarkCircle = faCircleXmark;
    
  
    

    var faBookOpen = {
      prefix: 'far',
      iconName: 'book-open',
      icon: [
        576,
        512,
        
            [128366,128214]
        ,
        'f518',
        
        'M156 32C100.6 32 48.8 46.6 27.1 53.6C10.3 59 0 74.5 0 91.1V403.5c0 26.1 24 44.2 48 40.2c19.8-3.3 54.8-7.7 100-7.7c54 0 97.5 25.5 112.5 35.6c7.5 5 16.8 8.4 27 8.4c11.5 0 21.6-4.2 29.3-9.9C330.2 460.3 369.1 436 428 436c47.7 0 80.5 4 99 7.2c23.9 4.1 49-13.8 49-40.6V91.1c0-16.5-10.3-32.1-27.1-37.5C527.2 46.6 475.4 32 420 32c-36.8 0-71.8 6.4-97.4 12.7c-12.8 3.2-23.5 6.3-30.9 8.7c-1.3 .4-2.6 .8-3.7 1.2c-1.1-.4-2.4-.8-3.7-1.2c-7.5-2.4-18.1-5.5-30.9-8.7C227.8 38.4 192.8 32 156 32zM264 97.3V417.9C238 404.2 196.8 388 148 388c-42.9 0-77.4 3.7-100 7.1V97.3C70.3 90.6 112.4 80 156 80c31.6 0 62.6 5.6 85.9 11.3c8.6 2.1 16.1 4.2 22.1 6zm48 319.2V97.3c6-1.8 13.5-3.9 22.1-6C357.4 85.6 388.4 80 420 80c43.6 0 85.7 10.6 108 17.3V394.7c-21.7-3.3-54.9-6.7-100-6.7c-51.4 0-90.8 15-116 28.6z'
        
      ]
    };

    
  
    

    var faCheck = {
      prefix: 'far',
      iconName: 'check',
      icon: [
        448,
        512,
        
            [10004,10003]
        ,
        'f00c',
        
        'M441 103c9.4 9.4 9.4 24.6 0 33.9L177 401c-9.4 9.4-24.6 9.4-33.9 0L7 265c-9.4-9.4-9.4-24.6 0-33.9s24.6-9.4 33.9 0l119 119L407 103c9.4-9.4 24.6-9.4 33.9 0z'
        
      ]
    };

    
  
    

    var faBook = {
      prefix: 'far',
      iconName: 'book',
      icon: [
        448,
        512,
        
            [128212]
        ,
        'f02d',
        
        'M0 88C0 39.4 39.4 0 88 0H392c30.9 0 56 25.1 56 56V344c0 22.3-13.1 41.6-32 50.6V464h8c13.3 0 24 10.7 24 24s-10.7 24-24 24H80c-44.2 0-80-35.8-80-80c0-2.7 .1-5.4 .4-8H0V88zM80 400c-17.7 0-32 14.3-32 32s14.3 32 32 32H368V400H80zM48 358.7c9.8-4.3 20.6-6.7 32-6.7H392c4.4 0 8-3.6 8-8V56c0-4.4-3.6-8-8-8H88C65.9 48 48 65.9 48 88V358.7zM152 112H328c13.3 0 24 10.7 24 24s-10.7 24-24 24H152c-13.3 0-24-10.7-24-24s10.7-24 24-24zm0 80H328c13.3 0 24 10.7 24 24s-10.7 24-24 24H152c-13.3 0-24-10.7-24-24s10.7-24 24-24z'
        
      ]
    };

    
  
    

    var faCirclePlus = {
      prefix: 'far',
      iconName: 'circle-plus',
      icon: [
        512,
        512,
        
            ['plus-circle']
        ,
        'f055',
        
        'M256 48a208 208 0 1 1 0 416 208 208 0 1 1 0-416zm0 464A256 256 0 1 0 256 0a256 256 0 1 0 0 512zM232 344c0 13.3 10.7 24 24 24s24-10.7 24-24V280h64c13.3 0 24-10.7 24-24s-10.7-24-24-24H280V168c0-13.3-10.7-24-24-24s-24 10.7-24 24v64H168c-13.3 0-24 10.7-24 24s10.7 24 24 24h64v64z'
        
      ]
    };

    
      var faPlusCircle = faCirclePlus;
    
  
    

    var faClockRotateLeft = {
      prefix: 'far',
      iconName: 'clock-rotate-left',
      icon: [
        512,
        512,
        
            ['history']
        ,
        'f1da',
        
        'M48 106.7V56c0-13.3-10.7-24-24-24S0 42.7 0 56V168c0 13.3 10.7 24 24 24H136c13.3 0 24-10.7 24-24s-10.7-24-24-24H80.7c37-57.8 101.7-96 175.3-96c114.9 0 208 93.1 208 208s-93.1 208-208 208c-42.5 0-81.9-12.7-114.7-34.5c-11-7.3-25.9-4.3-33.3 6.7s-4.3 25.9 6.7 33.3C155.2 496.4 203.8 512 256 512c141.4 0 256-114.6 256-256S397.4 0 256 0C170.3 0 94.4 42.1 48 106.7zM256 128c-13.3 0-24 10.7-24 24V256c0 6.4 2.5 12.5 7 17l72 72c9.4 9.4 24.6 9.4 33.9 0s9.4-24.6 0-33.9l-65-65V152c0-13.3-10.7-24-24-24z'
        
      ]
    };

    
      var faHistory = faClockRotateLeft;
    
  
    

    var faChevronRight = {
      prefix: 'far',
      iconName: 'chevron-right',
      icon: [
        320,
        512,
        
            [9002]
        ,
        'f054',
        
        'M305 239c9.4 9.4 9.4 24.6 0 33.9L113 465c-9.4 9.4-24.6 9.4-33.9 0s-9.4-24.6 0-33.9l175-175L79 81c-9.4-9.4-9.4-24.6 0-33.9s24.6-9.4 33.9 0L305 239z'
        
      ]
    };

    
  
    

    var faChevronLeft = {
      prefix: 'far',
      iconName: 'chevron-left',
      icon: [
        320,
        512,
        
            [9001]
        ,
        'f053',
        
        'M15 239c-9.4 9.4-9.4 24.6 0 33.9L207 465c9.4 9.4 24.6 9.4 33.9 0s9.4-24.6 0-33.9L65.9 256 241 81c9.4-9.4 9.4-24.6 0-33.9s-24.6-9.4-33.9 0L15 239z'
        
      ]
    };

    
  
    

    var faXmark = {
      prefix: 'far',
      iconName: 'xmark',
      icon: [
        384,
        512,
        
            [215,10060,10006,10005,128473,'close','multiply','remove','times']
        ,
        'f00d',
        
        'M345 137c9.4-9.4 9.4-24.6 0-33.9s-24.6-9.4-33.9 0l-119 119L73 103c-9.4-9.4-24.6-9.4-33.9 0s-9.4 24.6 0 33.9l119 119L39 375c-9.4 9.4-9.4 24.6 0 33.9s24.6 9.4 33.9 0l119-119L311 409c9.4 9.4 24.6 9.4 33.9 0s9.4-24.6 0-33.9l-119-119L345 137z'
        
      ]
    };

    
      var faClose = faXmark;
    
      var faMultiply = faXmark;
    
      var faRemove = faXmark;
    
      var faTimes = faXmark;
    
  
    

    var faPlus = {
      prefix: 'far',
      iconName: 'plus',
      icon: [
        448,
        512,
        
            [61543,10133,'add']
        ,
        '2b',
        
        'M248 72c0-13.3-10.7-24-24-24s-24 10.7-24 24V232H40c-13.3 0-24 10.7-24 24s10.7 24 24 24H200V440c0 13.3 10.7 24 24 24s24-10.7 24-24V280H408c13.3 0 24-10.7 24-24s-10.7-24-24-24H248V72z'
        
      ]
    };

    
      var faAdd = faPlus;
    
  
    

    var faUserHeadset = {
      prefix: 'far',
      iconName: 'user-headset',
      icon: [
        448,
        512,
        
            []
          ,
        'f82d',
        
        'M224 32C135.6 32 64 103.6 64 192v16c0 8.8-7.2 16-16 16s-16-7.2-16-16V192C32 86 118 0 224 0S416 86 416 192v16c0 61.9-50.1 112-112 112H240 224 208c-17.7 0-32-14.3-32-32s14.3-32 32-32h32c17.7 0 32 14.3 32 32h32c44.2 0 80-35.8 80-80V192c0-88.4-71.6-160-160-160zm0 32c70.7 0 128 57.3 128 128c0 13.9-2.2 27.3-6.3 39.8C337.4 246.3 321.8 256 304 256h-8.6c-2.7-4.7-6.1-9.1-9.9-12.9C297.1 229.2 304 211.4 304 192c0-44.2-35.8-80-80-80s-80 35.8-80 80c0 19.4 6.9 37.2 18.4 51.1C151 254.6 144 270.5 144 288c0 1.4 0 2.7 .1 4C114.8 268.6 96 232.5 96 192c0-70.7 57.3-128 128-128zM208 352h16 16 57.4H304h9.6C387.8 352 448 412.2 448 486.4c0 14.1-11.5 25.6-25.6 25.6H25.6C11.5 512 0 500.5 0 486.4C0 412.2 60.2 352 134.4 352h16.2H208zm105.6 48H134.4c-40 0-73.6 27.1-83.5 64H397.1c-9.9-36.9-43.5-64-83.5-64z'
        
      ]
    };

    
  
    

    var faCircleUser = {
      prefix: 'far',
      iconName: 'circle-user',
      icon: [
        512,
        512,
        
            [62142,'user-circle']
        ,
        'f2bd',
        
        'M406.5 399.6C387.4 352.9 341.5 320 288 320H224c-53.5 0-99.4 32.9-118.5 79.6C69.9 362.2 48 311.7 48 256C48 141.1 141.1 48 256 48s208 93.1 208 208c0 55.7-21.9 106.2-57.5 143.6zm-40.1 32.7C334.4 452.4 296.6 464 256 464s-78.4-11.6-110.5-31.7c7.3-36.7 39.7-64.3 78.5-64.3h64c38.8 0 71.2 27.6 78.5 64.3zM256 512A256 256 0 1 0 256 0a256 256 0 1 0 0 512zm0-272a40 40 0 1 1 0-80 40 40 0 1 1 0 80zm-88-40a88 88 0 1 0 176 0 88 88 0 1 0 -176 0z'
        
      ]
    };

    
      var faUserCircle = faCircleUser;
    
  
    

    var faChevronDown = {
      prefix: 'far',
      iconName: 'chevron-down',
      icon: [
        512,
        512,
        
            []
          ,
        'f078',
        
        'M239 401c9.4 9.4 24.6 9.4 33.9 0L465 209c9.4-9.4 9.4-24.6 0-33.9s-24.6-9.4-33.9 0l-175 175L81 175c-9.4-9.4-24.6-9.4-33.9 0s-9.4 24.6 0 33.9L239 401z'
        
      ]
    };

    
  
    

    var faPlay = {
      prefix: 'far',
      iconName: 'play',
      icon: [
        384,
        512,
        
            [9654]
        ,
        'f04b',
        
        'M48 432L336 256 48 80l0 352zM24.5 38.1C39.7 29.6 58.2 30 73 39L361 215c14.3 8.7 23 24.2 23 41s-8.7 32.2-23 41L73 473c-14.8 9.1-33.4 9.4-48.5 .9S0 449.4 0 432V80C0 62.6 9.4 46.6 24.5 38.1z'
        
      ]
    };

    
  
    

    var faEraser = {
      prefix: 'far',
      iconName: 'eraser',
      icon: [
        576,
        512,
        
            []
          ,
        'f12d',
        
        'M97 319c-9.4 9.4-9.4 24.6 0 33.9l72 72c4.5 4.5 10.6 7 17 7H294.1c6.4 0 12.5-2.5 17-7l65-65L216 200 97 319zM285.1 63c28.1-28.1 73.7-28.1 101.8 0L513 189.1c28.1 28.1 28.1 73.7 0 101.8L371.9 432H520c13.3 0 24 10.7 24 24s-10.7 24-24 24H296v0c-.6 0-1.3 0-1.9 0H185.9c-19.1 0-37.4-7.6-50.9-21.1l-72-72c-28.1-28.1-28.1-73.7 0-101.8L285.1 63z'
        
      ]
    };

    
  
    

    var faGreaterThan = {
      prefix: 'far',
      iconName: 'greater-than',
      icon: [
        384,
        512,
        
            [62769]
        ,
        '3e',
        
        'M2.5 77.3c-5.9 11.9-1.1 26.3 10.7 32.2L306.3 256 13.3 402.5C1.4 408.5-3.4 422.9 2.5 434.7s20.3 16.7 32.2 10.7l336-168c8.1-4.1 13.3-12.4 13.3-21.5s-5.1-17.4-13.3-21.5l-336-168C22.9 60.6 8.5 65.4 2.5 77.3z'
        
      ]
    };

    
  
    

    var faLocationDot = {
      prefix: 'far',
      iconName: 'location-dot',
      icon: [
        384,
        512,
        
            ['map-marker-alt']
        ,
        'f3c5',
        
        'M336 192c0-79.5-64.5-144-144-144S48 112.5 48 192c0 12.4 4.5 31.6 15.3 57.2c10.5 24.8 25.4 52.2 42.5 79.9c28.5 46.2 61.5 90.8 86.2 122.6c24.8-31.8 57.8-76.4 86.2-122.6c17.1-27.7 32-55.1 42.5-79.9C331.5 223.6 336 204.4 336 192zm48 0c0 87.4-117 243-168.3 307.2c-12.3 15.3-35.1 15.3-47.4 0C117 435 0 279.4 0 192C0 86 86 0 192 0S384 86 384 192zm-160 0a32 32 0 1 0 -64 0 32 32 0 1 0 64 0zm-112 0a80 80 0 1 1 160 0 80 80 0 1 1 -160 0z'
        
      ]
    };

    
      var faMapMarkerAlt = faLocationDot;
    
  
    

    var faBookOpenReader = {
      prefix: 'far',
      iconName: 'book-open-reader',
      icon: [
        512,
        512,
        
            ['book-reader']
        ,
        'f5da',
        
        'M256 144a48 48 0 1 0 0-96 48 48 0 1 0 0 96zM256 0a96 96 0 1 1 0 192A96 96 0 1 1 256 0zM228 279l-.2-.1c-.7-.5-2.4-1.5-5.2-2.9c-5.5-2.8-15.4-7.3-30.6-12.2c-28-9-74.2-19.3-144-22.7V417.4c84.9 5 147.1 22.3 184 35.7V282l-4-3zm52 3V453.1c36.9-13.4 99.1-30.7 184-35.7V241.1c-69.9 3.4-116 13.7-144 22.7c-15.1 4.9-25 9.4-30.6 12.2c-2.8 1.4-4.5 2.4-5.2 2.9l-.2 .1-4 3zM32 192.5C199.2 197.4 256 240 256 240s56.8-42.6 224-47.5c17.7-.5 32 13.9 32 31.5V432c0 17.7-14.4 31.9-32 32.7c-114.9 4.7-186.9 33.7-208.8 43.8c-4.8 2.2-9.9 3.5-15.1 3.5s-10.4-1.3-15.1-3.5c-21.9-10.1-93.9-39.1-208.8-43.8c-17.7-.7-32-15-32-32.7V224c0-17.7 14.4-32.1 32-31.5z'
        
      ]
    };

    
      var faBookReader = faBookOpenReader;
    
  
    

    var faLessThan = {
      prefix: 'far',
      iconName: 'less-than',
      icon: [
        384,
        512,
        
            [62774]
        ,
        '3c',
        
        'M381.5 77.3c5.9 11.9 1.1 26.3-10.7 32.2L77.7 256 370.7 402.5c11.9 5.9 16.7 20.3 10.7 32.2s-20.3 16.7-32.2 10.7l-336-168C5.1 273.4 0 265.1 0 256s5.1-17.4 13.3-21.5l336-168c11.9-5.9 26.3-1.1 32.2 10.7z'
        
      ]
    };

    
  
    

    var faSquareArrowLeft = {
      prefix: 'far',
      iconName: 'square-arrow-left',
      icon: [
        448,
        512,
        
            ['arrow-square-left']
        ,
        'f33a',
        
        'M48 96c0-8.8 7.2-16 16-16l320 0c8.8 0 16 7.2 16 16l0 320c0 8.8-7.2 16-16 16L64 432c-8.8 0-16-7.2-16-16L48 96zM64 32C28.7 32 0 60.7 0 96L0 416c0 35.3 28.7 64 64 64l320 0c35.3 0 64-28.7 64-64l0-320c0-35.3-28.7-64-64-64L64 32zm39 241l88 88c9.4 9.4 24.6 9.4 33.9 0s9.4-24.6 0-33.9l-47-47L328 280c13.3 0 24-10.7 24-24s-10.7-24-24-24l-150.1 0 47-47c9.4-9.4 9.4-24.6 0-33.9s-24.6-9.4-33.9 0l-88 88c-9.4 9.4-9.4 24.6 0 33.9z'
        
      ]
    };

    
      var faArrowSquareLeft = faSquareArrowLeft;
    
  
    

    var faStop = {
      prefix: 'far',
      iconName: 'stop',
      icon: [
        384,
        512,
        
            [9209]
        ,
        'f04d',
        
        'M320 112c8.8 0 16 7.2 16 16V384c0 8.8-7.2 16-16 16H64c-8.8 0-16-7.2-16-16V128c0-8.8 7.2-16 16-16H320zM64 64C28.7 64 0 92.7 0 128V384c0 35.3 28.7 64 64 64H320c35.3 0 64-28.7 64-64V128c0-35.3-28.7-64-64-64H64z'
        
      ]
    };

    
  
    

    var faImages = {
      prefix: 'far',
      iconName: 'images',
      icon: [
        576,
        512,
        
            []
          ,
        'f302',
        
        'M160 80H512c8.8 0 16 7.2 16 16V320c0 8.8-7.2 16-16 16H490.8L388.1 178.9c-4.4-6.8-12-10.9-20.1-10.9s-15.7 4.1-20.1 10.9l-52.2 79.8-12.4-16.9c-4.5-6.2-11.7-9.8-19.4-9.8s-14.8 3.6-19.4 9.8L175.6 336H160c-8.8 0-16-7.2-16-16V96c0-8.8 7.2-16 16-16zM96 96V320c0 35.3 28.7 64 64 64H512c35.3 0 64-28.7 64-64V96c0-35.3-28.7-64-64-64H160c-35.3 0-64 28.7-64 64zM48 120c0-13.3-10.7-24-24-24S0 106.7 0 120V344c0 75.1 60.9 136 136 136H456c13.3 0 24-10.7 24-24s-10.7-24-24-24H136c-48.6 0-88-39.4-88-88V120zm208 24a32 32 0 1 0 -64 0 32 32 0 1 0 64 0z'
        
      ]
    };

    
  
    

    var faPowerOff = {
      prefix: 'far',
      iconName: 'power-off',
      icon: [
        512,
        512,
        
            [9211]
        ,
        'f011',
        
        'M280 24c0-13.3-10.7-24-24-24s-24 10.7-24 24V264c0 13.3 10.7 24 24 24s24-10.7 24-24V24zM134.2 107.3c10.7-7.9 12.9-22.9 5.1-33.6s-22.9-12.9-33.6-5.1C46.5 112.3 8 182.7 8 262C8 394.6 115.5 502 248 502s240-107.5 240-240c0-79.3-38.5-149.7-97.8-193.3c-10.7-7.9-25.7-5.6-33.6 5.1s-5.6 25.7 5.1 33.6c47.5 35 78.2 91.2 78.2 154.7c0 106-86 192-192 192S56 368 56 262c0-63.4 30.7-119.7 78.2-154.7z'
        
      ]
    };

    
  
    

    var faEllipsisVertical = {
      prefix: 'far',
      iconName: 'ellipsis-vertical',
      icon: [
        128,
        512,
        
            ['ellipsis-v']
        ,
        'f142',
        
        'M64 368a48 48 0 1 0 0 96 48 48 0 1 0 0-96zm0-160a48 48 0 1 0 0 96 48 48 0 1 0 0-96zM112 96A48 48 0 1 0 16 96a48 48 0 1 0 96 0z'
        
      ]
    };

    
      var faEllipsisV = faEllipsisVertical;
    
  
    

    var faMinus = {
      prefix: 'far',
      iconName: 'minus',
      icon: [
        448,
        512,
        
            [10134,8722,8211,'subtract']
        ,
        'f068',
        
        'M432 256c0 13.3-10.7 24-24 24L40 280c-13.3 0-24-10.7-24-24s10.7-24 24-24l368 0c13.3 0 24 10.7 24 24z'
        
      ]
    };

    
      var faSubtract = faMinus;
    
  
    

    var faCircleInfo = {
      prefix: 'far',
      iconName: 'circle-info',
      icon: [
        512,
        512,
        
            ['info-circle']
        ,
        'f05a',
        
        'M256 48a208 208 0 1 1 0 416 208 208 0 1 1 0-416zm0 464A256 256 0 1 0 256 0a256 256 0 1 0 0 512zM216 336c-13.3 0-24 10.7-24 24s10.7 24 24 24h80c13.3 0 24-10.7 24-24s-10.7-24-24-24h-8V248c0-13.3-10.7-24-24-24H216c-13.3 0-24 10.7-24 24s10.7 24 24 24h24v64H216zm40-144a32 32 0 1 0 0-64 32 32 0 1 0 0 64z'
        
      ]
    };

    
      var faInfoCircle = faCircleInfo;
    
  
    

    var faArrowLeft = {
      prefix: 'far',
      iconName: 'arrow-left',
      icon: [
        448,
        512,
        
            [8592]
        ,
        'f060',
        
        'M7.4 273.4C2.7 268.8 0 262.6 0 256s2.7-12.8 7.4-17.4l176-168c9.6-9.2 24.8-8.8 33.9 .8s8.8 24.8-.8 33.9L83.9 232 424 232c13.3 0 24 10.7 24 24s-10.7 24-24 24L83.9 280 216.6 406.6c9.6 9.2 9.9 24.3 .8 33.9s-24.3 9.9-33.9 .8l-176-168z'
        
      ]
    };

    
  
    

    var faCircleQuestion = {
      prefix: 'far',
      iconName: 'circle-question',
      icon: [
        512,
        512,
        
            [62108,'question-circle']
        ,
        'f059',
        
        'M464 256A208 208 0 1 0 48 256a208 208 0 1 0 416 0zM0 256a256 256 0 1 1 512 0A256 256 0 1 1 0 256zm169.8-90.7c7.9-22.3 29.1-37.3 52.8-37.3h58.3c34.9 0 63.1 28.3 63.1 63.1c0 22.6-12.1 43.5-31.7 54.8L280 264.4c-.2 13-10.9 23.6-24 23.6c-13.3 0-24-10.7-24-24V250.5c0-8.6 4.6-16.5 12.1-20.8l44.3-25.4c4.7-2.7 7.6-7.7 7.6-13.1c0-8.4-6.8-15.1-15.1-15.1H222.6c-3.4 0-6.4 2.1-7.5 5.3l-.4 1.2c-4.4 12.5-18.2 19-30.6 14.6s-19-18.2-14.6-30.6l.4-1.2zM224 352a32 32 0 1 1 64 0 32 32 0 1 1 -64 0z'
        
      ]
    };

    
      var faQuestionCircle = faCircleQuestion;
    
  
    

    var faWrench = {
      prefix: 'far',
      iconName: 'wrench',
      icon: [
        512,
        512,
        
            [128295]
        ,
        'f0ad',
        
        'M322.3 268c9.4 2.6 19.3 4 29.7 4c60.5 0 109.8-48 111.9-108l-25.3 25.3c-12 12-28.3 18.7-45.3 18.7H368c-35.3 0-64-28.7-64-64V118.6c0-17 6.7-33.3 18.7-45.3l0 0L348 48.1C288 50.1 240 99.5 240 160c0 10.3 1.4 20.3 4 29.7c4.6 16.6-.2 34.4-12.4 46.6L57.1 410.7c-5.9 5.8-9.1 13.8-9.1 22.1C48 450 62 464 79.2 464c8.3 0 16.2-3.3 22.1-9.1L275.7 280.4c12.2-12.2 30-16.9 46.6-12.4zM424.6 39.4l-67.9 67.9c-3 3-4.7 7.1-4.7 11.3V144c0 8.8 7.2 16 16 16h25.4c4.2 0 8.3-1.7 11.3-4.7l67.9-67.9c7.2-7.2 19.3-5.9 23.7 3.3c10.1 21 15.7 44.5 15.7 69.3c0 88.4-71.6 160-160 160c-14.7 0-28.9-2-42.3-5.7L135.2 488.8c-14.9 14.9-35 23.2-56 23.2C35.5 512 0 476.5 0 432.8c0-21 8.3-41.1 23.2-56L197.7 202.3C194 188.9 192 174.7 192 160C192 71.6 263.6 0 352 0c24.8 0 48.3 5.7 69.3 15.7c9.2 4.4 10.5 16.5 3.3 23.7zM88 408a16 16 0 1 1 0 32 16 16 0 1 1 0-32z'
        
      ]
    };

    
  
    

    var faCircle = {
      prefix: 'far',
      iconName: 'circle',
      icon: [
        512,
        512,
        
            [61915,61708,11044,9899,9898,9679,128996,128995,128994,128993,128992,128309,128308]
        ,
        'f111',
        
        'M464 256A208 208 0 1 0 48 256a208 208 0 1 0 416 0zM0 256a256 256 0 1 1 512 0A256 256 0 1 1 0 256z'
        
      ]
    };

    
  
    

    var faLockKeyhole = {
      prefix: 'far',
      iconName: 'lock-keyhole',
      icon: [
        448,
        512,
        
            ['lock-alt']
        ,
        'f30d',
        
        'M224 48c44.2 0 80 35.8 80 80v64H144V128c0-44.2 35.8-80 80-80zM96 128v64H64c-35.3 0-64 28.7-64 64V448c0 35.3 28.7 64 64 64H384c35.3 0 64-28.7 64-64V256c0-35.3-28.7-64-64-64H352V128C352 57.3 294.7 0 224 0S96 57.3 96 128zM64 240H384c8.8 0 16 7.2 16 16V448c0 8.8-7.2 16-16 16H64c-8.8 0-16-7.2-16-16V256c0-8.8 7.2-16 16-16zm184 80c0-13.3-10.7-24-24-24s-24 10.7-24 24v64c0 13.3 10.7 24 24 24s24-10.7 24-24V320z'
        
      ]
    };

    
      var faLockAlt = faLockKeyhole;
    
  
    

    var faArrowRight = {
      prefix: 'far',
      iconName: 'arrow-right',
      icon: [
        448,
        512,
        
            [8594]
        ,
        'f061',
        
        'M440.6 273.4c4.7-4.5 7.4-10.8 7.4-17.4s-2.7-12.8-7.4-17.4l-176-168c-9.6-9.2-24.8-8.8-33.9 .8s-8.8 24.8 .8 33.9L364.1 232 24 232c-13.3 0-24 10.7-24 24s10.7 24 24 24l340.1 0L231.4 406.6c-9.6 9.2-9.9 24.3-.8 33.9s24.3 9.9 33.9 .8l176-168z'
        
      ]
    };

    
  
    

    var faCircleArrowRight = {
      prefix: 'far',
      iconName: 'circle-arrow-right',
      icon: [
        512,
        512,
        
            ['arrow-circle-right']
        ,
        'f0a9',
        
        'M464 256A208 208 0 1 1 48 256a208 208 0 1 1 416 0zM0 256a256 256 0 1 0 512 0A256 256 0 1 0 0 256zM289 361l88-88c9.4-9.4 9.4-24.6 0-33.9l-88-88c-9.4-9.4-24.6-9.4-33.9 0s-9.4 24.6 0 33.9l47 47L152 232c-13.3 0-24 10.7-24 24s10.7 24 24 24l150.1 0-47 47c-9.4 9.4-9.4 24.6 0 33.9s24.6 9.4 33.9 0z'
        
      ]
    };

    
      var faArrowCircleRight = faCircleArrowRight;
    
  
    

    var faSquare = {
      prefix: 'far',
      iconName: 'square',
      icon: [
        448,
        512,
        
            [61590,9724,9723,9632]
        ,
        'f0c8',
        
        'M384 80c8.8 0 16 7.2 16 16V416c0 8.8-7.2 16-16 16H64c-8.8 0-16-7.2-16-16V96c0-8.8 7.2-16 16-16H384zM64 32C28.7 32 0 60.7 0 96V416c0 35.3 28.7 64 64 64H384c35.3 0 64-28.7 64-64V96c0-35.3-28.7-64-64-64H64z'
        
      ]
    };

    
  
    

    var faCommentQuestion = {
      prefix: 'far',
      iconName: 'comment-question',
      icon: [
        512,
        512,
        
            []
          ,
        'e14b',
        
        'M168.2 384.9c-15-5.4-31.7-3.1-44.6 6.4c-8.2 6-22.3 14.8-39.4 22.7c5.6-14.7 9.9-31.3 11.3-49.4c1-12.9-3.3-25.7-11.8-35.5C60.4 302.8 48 272 48 240c0-79.5 83.3-160 208-160s208 80.5 208 160s-83.3 160-208 160c-31.6 0-61.3-5.5-87.8-15.1zM26.3 423.8c-1.6 2.7-3.3 5.4-5.1 8.1l-.3 .5c-1.6 2.3-3.2 4.6-4.8 6.9c-3.5 4.7-7.3 9.3-11.3 13.5c-4.6 4.6-5.9 11.4-3.4 17.4c2.5 6 8.3 9.9 14.8 9.9c5.1 0 10.2-.3 15.3-.8l.7-.1c4.4-.5 8.8-1.1 13.2-1.9c.8-.1 1.6-.3 2.4-.5c17.8-3.5 34.9-9.5 50.1-16.1c22.9-10 42.4-21.9 54.3-30.6c31.8 11.5 67 17.9 104.1 17.9c141.4 0 256-93.1 256-208S397.4 32 256 32S0 125.1 0 240c0 45.1 17.7 86.8 47.7 120.9c-1.9 24.5-11.4 46.3-21.4 62.9zM169.8 149.3l-.4 1.2c-4.4 12.5 2.1 26.2 14.6 30.6s26.2-2.1 30.6-14.6l.4-1.2c1.1-3.2 4.2-5.3 7.5-5.3h58.3c8.4 0 15.1 6.8 15.1 15.1c0 5.4-2.9 10.4-7.6 13.1l-44.3 25.4c-7.5 4.3-12.1 12.2-12.1 20.8V248c0 13.3 10.7 24 24 24c13.1 0 23.8-10.5 24-23.6l32.3-18.5c19.6-11.3 31.7-32.2 31.7-54.8c0-34.9-28.3-63.1-63.1-63.1H222.6c-23.7 0-44.8 14.9-52.8 37.3zM288 336a32 32 0 1 0 -64 0 32 32 0 1 0 64 0z'
        
      ]
    };

    
  
    

    var faCircleArrowLeft = {
      prefix: 'far',
      iconName: 'circle-arrow-left',
      icon: [
        512,
        512,
        
            ['arrow-circle-left']
        ,
        'f0a8',
        
        'M48 256a208 208 0 1 1 416 0A208 208 0 1 1 48 256zm464 0A256 256 0 1 0 0 256a256 256 0 1 0 512 0zM223 151l-88 88c-9.4 9.4-9.4 24.6 0 33.9l88 88c9.4 9.4 24.6 9.4 33.9 0s9.4-24.6 0-33.9l-47-47L360 280c13.3 0 24-10.7 24-24s-10.7-24-24-24l-150.1 0 47-47c9.4-9.4 9.4-24.6 0-33.9s-24.6-9.4-33.9 0z'
        
      ]
    };

    
      var faArrowCircleLeft = faCircleArrowLeft;
    
  
    

    var faPause = {
      prefix: 'far',
      iconName: 'pause',
      icon: [
        320,
        512,
        
            [9208]
        ,
        'f04c',
        
        'M48 112l0 288H96V112H48zM0 112C0 85.5 21.5 64 48 64H96c26.5 0 48 21.5 48 48V400c0 26.5-21.5 48-48 48H48c-26.5 0-48-21.5-48-48V112zm224 0V400h48V112H224zm-48 0c0-26.5 21.5-48 48-48h48c26.5 0 48 21.5 48 48V400c0 26.5-21.5 48-48 48H224c-26.5 0-48-21.5-48-48V112z'
        
      ]
    };

    
  
    

    var faIdBadge = {
      prefix: 'far',
      iconName: 'id-badge',
      icon: [
        384,
        512,
        
            []
          ,
        'f2c1',
        
        'M256 48V64c0 17.7-14.3 32-32 32H160c-17.7 0-32-14.3-32-32V48H64c-8.8 0-16 7.2-16 16V448c0 8.8 7.2 16 16 16H320c8.8 0 16-7.2 16-16V64c0-8.8-7.2-16-16-16H256zM0 64C0 28.7 28.7 0 64 0H320c35.3 0 64 28.7 64 64V448c0 35.3-28.7 64-64 64H64c-35.3 0-64-28.7-64-64V64zM160 320h64c44.2 0 80 35.8 80 80c0 8.8-7.2 16-16 16H96c-8.8 0-16-7.2-16-16c0-44.2 35.8-80 80-80zm-32-96a64 64 0 1 1 128 0 64 64 0 1 1 -128 0z'
        
      ]
    };

    
  
    

    var faCircleCheck = {
      prefix: 'far',
      iconName: 'circle-check',
      icon: [
        512,
        512,
        
            [61533,'check-circle']
        ,
        'f058',
        
        'M256 48a208 208 0 1 1 0 416 208 208 0 1 1 0-416zm0 464A256 256 0 1 0 256 0a256 256 0 1 0 0 512zM369 209c9.4-9.4 9.4-24.6 0-33.9s-24.6-9.4-33.9 0l-111 111-47-47c-9.4-9.4-24.6-9.4-33.9 0s-9.4 24.6 0 33.9l64 64c9.4 9.4 24.6 9.4 33.9 0L369 209z'
        
      ]
    };

    
      var faCheckCircle = faCircleCheck;
    
  
    

    var faSquarePlus = {
      prefix: 'far',
      iconName: 'square-plus',
      icon: [
        448,
        512,
        
            [61846,'plus-square']
        ,
        'f0fe',
        
        'M64 80c-8.8 0-16 7.2-16 16V416c0 8.8 7.2 16 16 16H384c8.8 0 16-7.2 16-16V96c0-8.8-7.2-16-16-16H64zM0 96C0 60.7 28.7 32 64 32H384c35.3 0 64 28.7 64 64V416c0 35.3-28.7 64-64 64H64c-35.3 0-64-28.7-64-64V96zM200 344V280H136c-13.3 0-24-10.7-24-24s10.7-24 24-24h64V168c0-13.3 10.7-24 24-24s24 10.7 24 24v64h64c13.3 0 24 10.7 24 24s-10.7 24-24 24H248v64c0 13.3-10.7 24-24 24s-24-10.7-24-24z'
        
      ]
    };

    
      var faPlusSquare = faSquarePlus;
    
  
    

    var faVolume = {
      prefix: 'far',
      iconName: 'volume',
      icon: [
        576,
        512,
        
            [128265,'volume-medium']
        ,
        'f6a8',
        
        'M191.9 201.9L304 102.3V409.7L191.9 310.1c-4.4-3.9-10.1-6.1-15.9-6.1H88c-4.4 0-8-3.6-8-8V216c0-4.4 3.6-8 8-8h88c5.9 0 11.6-2.2 15.9-6.1zM322.2 32c-7.3 0-14.3 2.7-19.8 7.5L166.9 160H88c-30.9 0-56 25.1-56 56v80c0 30.9 25.1 56 56 56h78.9L302.4 472.5c5.5 4.8 12.5 7.5 19.8 7.5c16.5 0 29.8-13.3 29.8-29.8V61.8C352 45.3 338.7 32 322.2 32zm182.9 75c-10.3-8.4-25.4-6.8-33.8 3.5s-6.8 25.4 3.5 33.8C507.3 170.7 528 210.9 528 256s-20.7 85.3-53.2 111.8c-10.3 8.4-11.8 23.5-3.5 33.8s23.5 11.8 33.8 3.5c43.2-35.2 70.9-88.9 70.9-149s-27.7-113.8-70.9-149zm-60.5 74.5c-10.3-8.4-25.4-6.8-33.8 3.5s-6.8 25.4 3.5 33.8C425.1 227.6 432 241 432 256s-6.9 28.4-17.7 37.3c-10.3 8.4-11.8 23.5-3.5 33.8s23.5 11.8 33.8 3.5C466.1 312.9 480 286.1 480 256s-13.9-56.9-35.4-74.5z'
        
      ]
    };

    
      var faVolumeMedium = faVolume;
    
  
    

    var faUserPen = {
      prefix: 'far',
      iconName: 'user-pen',
      icon: [
        640,
        512,
        
            ['user-edit']
        ,
        'f4ff',
        
        'M144 128a80 80 0 1 1 160 0 80 80 0 1 1 -160 0zm208 0A128 128 0 1 0 96 128a128 128 0 1 0 256 0zM49.3 464c8.9-63.3 63.3-112 129-112h91.4c34.9 0 66.5 13.7 89.9 36l33.9-33.9c-32.1-31-75.7-50.1-123.9-50.1H178.3C79.8 304 0 383.8 0 482.3C0 498.7 13.3 512 29.7 512H322.8c-3.1-8.8-3.7-18.4-1.4-27.8l5.1-20.2H49.3zM613.8 235.7c-15.6-15.6-40.9-15.6-56.6 0l-29.4 29.4 71 71 29.4-29.4c15.6-15.6 15.6-40.9 0-56.6l-14.4-14.4zM375.9 417c-4.1 4.1-7 9.2-8.4 14.9l-15 60.1c-1.4 5.5 .2 11.2 4.2 15.2s9.7 5.6 15.2 4.2l60.1-15c5.6-1.4 10.8-4.3 14.9-8.4L576.1 358.7l-71-71L375.9 417z'
        
      ]
    };

    
      var faUserEdit = faUserPen;
    
  
    

    var faBooks = {
      prefix: 'far',
      iconName: 'books',
      icon: [
        512,
        512,
        
            [128218]
        ,
        'f5db',
        
        'M48 416v48h64V416H48zm88 89.6c-7.1 4.1-15.3 6.4-24 6.4H48c-26.5 0-48-21.5-48-48V416 392 368 144 120 96 48C0 21.5 21.5 0 48 0h64c8.7 0 16.9 2.3 24 6.4C143.1 2.3 151.3 0 160 0h64c20.6 0 38.1 12.9 45 31.1c5.6-6.1 12.9-10.7 21.4-13L349.9 1.6c24.7-6.8 50.1 8.3 56.7 33.8l18 69.2 6 23.2 61.8 238.3 6 23.2 11.9 46c6.6 25.5-8 51.7-32.7 58.5l-59.6 16.5c-24.7 6.8-50.1-8.3-56.7-33.8l-18-69.2-6-23.2L275.6 145.9 272 132.2V144 368v24 24 48c0 26.5-21.5 48-48 48H160c-8.7 0-16.9-2.3-24-6.4zM160 464h64V416H160v48zM112 48H48V96h64V48zm0 96H48V368h64V144zm48-48h64V48H160V96zm64 272V144H160V368h64zm216.1-12.3l-55.8-215-56.5 15.6 55.8 215 56.5-15.6zm-44.4 62.1l11.9 45.7L464 447.9c0-.1 0-.2 0-.3l0-.1-11.7-45.2-56.5 15.6zm-79.9-308l56.5-15.6L360.4 48.5 304 64.1c0 .1 0 .2 0 .4l11.7 45.2z'
        
      ]
    };

    
  
    

    var faHighlighter = {
      prefix: 'far',
      iconName: 'highlighter',
      icon: [
        576,
        512,
        
            []
          ,
        'f591',
        
        'M184 296.6v-48l22.5-16.2 113 113L303.4 368l-48 0c-12.7 0-24.9 5.1-33.9 14.1l-38.1 38.1-51.5-51.5 38.1-38.1c9-9 14.1-21.2 14.1-33.9zM502.8 90.2L347.9 306 246 204.1 461.8 49.2c1.1-.8 2.4-1.2 3.7-1.2c1.7 0 3.3 .7 4.5 1.9L502.1 82c1.2 1.2 1.9 2.8 1.9 4.5c0 1.3-.4 2.6-1.2 3.7zM255.4 416h48c15.5 0 30-7.4 39-20L541.8 118.2C548.4 109 552 97.9 552 86.5c0-14.4-5.7-28.2-15.9-38.4L503.9 15.9C493.7 5.7 479.9 0 465.5 0C454.1 0 443 3.6 433.8 10.2L156 209.6c-12.6 9-20 23.5-20 39v48L92.3 340.3c-10.7 10.7-14.1 26-10.1 39.5L9.4 452.7c-6 6-9.4 14.1-9.4 22.6V480c0 17.7 14.3 32 32 32h84.7c8.5 0 16.6-3.4 22.6-9.4l32.8-32.8c13.6 4 28.8 .6 39.5-10.1L255.4 416zM134.7 439.3L110.1 464H65.9l46.7-46.7 22.1 22.1z'
        
      ]
    };

    
  
    

    var faUser = {
      prefix: 'far',
      iconName: 'user',
      icon: [
        448,
        512,
        
            [62144,128100]
        ,
        'f007',
        
        'M304 128a80 80 0 1 0 -160 0 80 80 0 1 0 160 0zM96 128a128 128 0 1 1 256 0A128 128 0 1 1 96 128zM49.3 464H398.7c-8.9-63.3-63.3-112-129-112H178.3c-65.7 0-120.1 48.7-129 112zM0 482.3C0 383.8 79.8 304 178.3 304h91.4C368.2 304 448 383.8 448 482.3c0 16.4-13.3 29.7-29.7 29.7H29.7C13.3 512 0 498.7 0 482.3z'
        
      ]
    };

    
  
    

    var faChevronUp = {
      prefix: 'far',
      iconName: 'chevron-up',
      icon: [
        512,
        512,
        
            []
          ,
        'f077',
        
        'M239 111c9.4-9.4 24.6-9.4 33.9 0L465 303c9.4 9.4 9.4 24.6 0 33.9s-24.6 9.4-33.9 0l-175-175L81 337c-9.4 9.4-24.6 9.4-33.9 0s-9.4-24.6 0-33.9L239 111z'
        
      ]
    };

    
  
    

    var faUsers = {
      prefix: 'far',
      iconName: 'users',
      icon: [
        640,
        512,
        
            []
          ,
        'f0c0',
        
        'M144 160A80 80 0 1 0 144 0a80 80 0 1 0 0 160zm368 0A80 80 0 1 0 512 0a80 80 0 1 0 0 160zM0 298.7C0 310.4 9.6 320 21.3 320H234.7c.2 0 .4 0 .7 0c-26.6-23.5-43.3-57.8-43.3-96c0-7.6 .7-15 1.9-22.3c-13.6-6.3-28.7-9.7-44.6-9.7H106.7C47.8 192 0 239.8 0 298.7zM405.3 320H618.7c11.8 0 21.3-9.6 21.3-21.3C640 239.8 592.2 192 533.3 192H490.7c-15.9 0-31 3.5-44.6 9.7c1.3 7.2 1.9 14.7 1.9 22.3c0 38.2-16.8 72.5-43.3 96c.2 0 .4 0 .7 0zM320 176a48 48 0 1 1 0 96 48 48 0 1 1 0-96zm0 144a96 96 0 1 0 0-192 96 96 0 1 0 0 192zm-58.7 80H378.7c39.8 0 73.2 27.2 82.6 64H178.7c9.5-36.8 42.9-64 82.6-64zm0-48C187.7 352 128 411.7 128 485.3c0 14.7 11.9 26.7 26.7 26.7H485.3c14.7 0 26.7-11.9 26.7-26.7C512 411.7 452.3 352 378.7 352H261.3z'
        
      ]
    };

    
  
    

    var faLightbulbOn = {
      prefix: 'far',
      iconName: 'lightbulb-on',
      icon: [
        640,
        512,
        
            []
          ,
        'f672',
        
        'M69.3 4C58.3-3.3 43.4-.3 36 10.7s-4.4 25.9 6.7 33.3l48 32c11 7.4 25.9 4.4 33.3-6.7s4.4-25.9-6.7-33.3L69.3 4zM597.3 44c11-7.4 14-22.3 6.7-33.3s-22.3-14-33.3-6.7l-48 32c-11 7.4-14 22.3-6.7 33.3s22.3 14 33.3 6.7l48-32zM24 160c-13.3 0-24 10.7-24 24s10.7 24 24 24H88c13.3 0 24-10.7 24-24s-10.7-24-24-24H24zm528 0c-13.3 0-24 10.7-24 24s10.7 24 24 24h64c13.3 0 24-10.7 24-24s-10.7-24-24-24H552zM117.3 332c11-7.4 14-22.3 6.7-33.3s-22.3-14-33.3-6.7l-48 32c-11 7.4-14 22.3-6.7 33.3s22.3 14 33.3 6.7l48-32zm432-39.9c-11-7.4-25.9-4.4-33.3 6.7s-4.4 25.9 6.7 33.3l48 32c11 7.4 25.9 4.4 33.3-6.7s4.4-25.9-6.7-33.3l-48-32zM448 176c0 27.2-8.4 52.3-22.8 72.9c-3.7 5.3-8 11.3-12.7 17.7l0 0 0 0 0 0 0 0c-12.9 17.7-28.3 38.9-39.8 59.8c-10.4 19-15.7 38.8-18.3 57.5H403c2.2-12 5.9-23.7 11.8-34.5c9.9-18 22.2-34.9 34.5-51.8l0 0 0 0 0 0c5.2-7.1 10.4-14.2 15.4-21.4c19.8-28.5 31.4-63 31.4-100.3C496 78.8 417.2 0 320 0S144 78.8 144 176c0 37.3 11.6 71.9 31.4 100.3c5 7.2 10.2 14.3 15.4 21.4l0 0 0 0c12.3 16.8 24.6 33.7 34.5 51.8c5.9 10.8 9.6 22.5 11.8 34.5h48.6c-2.6-18.7-7.9-38.6-18.3-57.5c-11.5-20.9-26.9-42.1-39.8-59.8l0 0 0 0c-4.7-6.4-9-12.4-12.8-17.7C200.4 228.3 192 203.2 192 176c0-70.7 57.3-128 128-128s128 57.3 128 128zm-176 0c0-26.5 21.5-48 48-48c8.8 0 16-7.2 16-16s-7.2-16-16-16c-44.2 0-80 35.8-80 80c0 8.8 7.2 16 16 16s16-7.2 16-16zM400 432V416H240v16c0 44.2 35.8 80 80 80s80-35.8 80-80z'
        
      ]
    };

    
  
    

    var faLock = {
      prefix: 'far',
      iconName: 'lock',
      icon: [
        448,
        512,
        
            [128274]
        ,
        'f023',
        
        'M144 128v64H304V128c0-44.2-35.8-80-80-80s-80 35.8-80 80zM96 192V128C96 57.3 153.3 0 224 0s128 57.3 128 128v64h32c35.3 0 64 28.7 64 64V448c0 35.3-28.7 64-64 64H64c-35.3 0-64-28.7-64-64V256c0-35.3 28.7-64 64-64H96zM48 256V448c0 8.8 7.2 16 16 16H384c8.8 0 16-7.2 16-16V256c0-8.8-7.2-16-16-16H64c-8.8 0-16 7.2-16 16z'
        
      ]
    };

    
  
    

    var faCircleDot = {
      prefix: 'far',
      iconName: 'circle-dot',
      icon: [
        512,
        512,
        
            [128280,'dot-circle']
        ,
        'f192',
        
        'M464 256A208 208 0 1 0 48 256a208 208 0 1 0 416 0zM0 256a256 256 0 1 1 512 0A256 256 0 1 1 0 256zm256-96a96 96 0 1 1 0 192 96 96 0 1 1 0-192z'
        
      ]
    };

    
      var faDotCircle = faCircleDot;
    
  
    

    var faSquareCheck = {
      prefix: 'far',
      iconName: 'square-check',
      icon: [
        448,
        512,
        
            [61510,9989,9745,'check-square']
        ,
        'f14a',
        
        'M64 80c-8.8 0-16 7.2-16 16V416c0 8.8 7.2 16 16 16H384c8.8 0 16-7.2 16-16V96c0-8.8-7.2-16-16-16H64zM0 96C0 60.7 28.7 32 64 32H384c35.3 0 64 28.7 64 64V416c0 35.3-28.7 64-64 64H64c-35.3 0-64-28.7-64-64V96zM337 209L209 337c-9.4 9.4-24.6 9.4-33.9 0l-64-64c-9.4-9.4-9.4-24.6 0-33.9s24.6-9.4 33.9 0l47 47L303 175c9.4-9.4 24.6-9.4 33.9 0s9.4 24.6 0 33.9z'
        
      ]
    };

    
      var faCheckSquare = faSquareCheck;
    
  
    

    var faLightbulb = {
      prefix: 'far',
      iconName: 'lightbulb',
      icon: [
        384,
        512,
        
            [128161]
        ,
        'f0eb',
        
        'M297.2 248.9C311.6 228.3 320 203.2 320 176c0-70.7-57.3-128-128-128S64 105.3 64 176c0 27.2 8.4 52.3 22.8 72.9c3.7 5.3 8.1 11.3 12.8 17.7l0 0c12.9 17.7 28.3 38.9 39.8 59.8c10.4 19 15.7 38.8 18.3 57.5H109c-2.2-12-5.9-23.7-11.8-34.5c-9.9-18-22.2-34.9-34.5-51.8l0 0 0 0c-5.2-7.1-10.4-14.2-15.4-21.4C27.6 247.9 16 213.3 16 176C16 78.8 94.8 0 192 0s176 78.8 176 176c0 37.3-11.6 71.9-31.4 100.3c-5 7.2-10.2 14.3-15.4 21.4l0 0 0 0c-12.3 16.8-24.6 33.7-34.5 51.8c-5.9 10.8-9.6 22.5-11.8 34.5H226.4c2.6-18.7 7.9-38.6 18.3-57.5c11.5-20.9 26.9-42.1 39.8-59.8l0 0 0 0 0 0c4.7-6.4 9-12.4 12.7-17.7zM192 128c-26.5 0-48 21.5-48 48c0 8.8-7.2 16-16 16s-16-7.2-16-16c0-44.2 35.8-80 80-80c8.8 0 16 7.2 16 16s-7.2 16-16 16zm0 384c-44.2 0-80-35.8-80-80V416H272v16c0 44.2-35.8 80-80 80z'
        
      ]
    };

    
  
    

    var faBars = {
      prefix: 'far',
      iconName: 'bars',
      icon: [
        448,
        512,
        
            ['navicon']
        ,
        'f0c9',
        
        'M0 88C0 74.7 10.7 64 24 64H424c13.3 0 24 10.7 24 24s-10.7 24-24 24H24C10.7 112 0 101.3 0 88zM0 248c0-13.3 10.7-24 24-24H424c13.3 0 24 10.7 24 24s-10.7 24-24 24H24c-13.3 0-24-10.7-24-24zM448 408c0 13.3-10.7 24-24 24H24c-13.3 0-24-10.7-24-24s10.7-24 24-24H424c13.3 0 24 10.7 24 24z'
        
      ]
    };

    
      var faNavicon = faBars;
    
  
    

    var faSquareMinus = {
      prefix: 'far',
      iconName: 'square-minus',
      icon: [
        448,
        512,
        
            [61767,'minus-square']
        ,
        'f146',
        
        'M64 80c-8.8 0-16 7.2-16 16V416c0 8.8 7.2 16 16 16H384c8.8 0 16-7.2 16-16V96c0-8.8-7.2-16-16-16H64zM0 96C0 60.7 28.7 32 64 32H384c35.3 0 64 28.7 64 64V416c0 35.3-28.7 64-64 64H64c-35.3 0-64-28.7-64-64V96zM152 232H296c13.3 0 24 10.7 24 24s-10.7 24-24 24H152c-13.3 0-24-10.7-24-24s10.7-24 24-24z'
        
      ]
    };

    
      var faMinusSquare = faSquareMinus;
    
  
    

    var faCircleNotch = {
      prefix: 'far',
      iconName: 'circle-notch',
      icon: [
        512,
        512,
        
            []
          ,
        'f1ce',
        
        'M215.1 26.3c3.6 12.7-3.7 26-16.5 29.7C111.6 80.9 48 161.1 48 256c0 114.9 93.1 208 208 208s208-93.1 208-208c0-94.9-63.6-175.1-150.6-200c-12.7-3.6-20.1-16.9-16.5-29.7s16.9-20.1 29.7-16.5C433.6 40.5 512 139.1 512 256c0 141.4-114.6 256-256 256S0 397.4 0 256C0 139.1 78.4 40.5 185.4 9.9c12.7-3.6 26 3.7 29.7 16.5z'
        
      ]
    };

    
  
    

    var faSquareArrowRight = {
      prefix: 'far',
      iconName: 'square-arrow-right',
      icon: [
        448,
        512,
        
            ['arrow-square-right']
        ,
        'f33b',
        
        'M400 96c0-8.8-7.2-16-16-16L64 80c-8.8 0-16 7.2-16 16l0 320c0 8.8 7.2 16 16 16l320 0c8.8 0 16-7.2 16-16l0-320zM384 32c35.3 0 64 28.7 64 64l0 320c0 35.3-28.7 64-64 64L64 480c-35.3 0-64-28.7-64-64L0 96C0 60.7 28.7 32 64 32l320 0zM345 273l-88 88c-9.4 9.4-24.6 9.4-33.9 0s-9.4-24.6 0-33.9l47-47L120 280c-13.3 0-24-10.7-24-24s10.7-24 24-24l150.1 0-47-47c-9.4-9.4-9.4-24.6 0-33.9s24.6-9.4 33.9 0l88 88c9.4 9.4 9.4 24.6 0 33.9z'
        
      ]
    };

    
      var faArrowSquareRight = faSquareArrowRight;
    
  
    

    var faCalculatorSimple = {
      prefix: 'far',
      iconName: 'calculator-simple',
      icon: [
        512,
        512,
        
            ['calculator-alt']
        ,
        'f64c',
        
        'M256 0c13.3 0 24 10.7 24 24V232H488c13.3 0 24 10.7 24 24s-10.7 24-24 24H280V488c0 13.3-10.7 24-24 24s-24-10.7-24-24V280H24c-13.3 0-24-10.7-24-24s10.7-24 24-24H232V24c0-13.3 10.7-24 24-24zM400 32c13.3 0 24 10.7 24 24V88h32c13.3 0 24 10.7 24 24s-10.7 24-24 24H424v32c0 13.3-10.7 24-24 24s-24-10.7-24-24V136H344c-13.3 0-24-10.7-24-24s10.7-24 24-24h32V56c0-13.3 10.7-24 24-24zM55.4 343.4c9.4-9.4 24.6-9.4 33.9 0L112 366.1l22.6-22.6c9.4-9.4 24.6-9.4 33.9 0s9.4 24.6 0 33.9L145.9 400l22.6 22.6c9.4 9.4 9.4 24.6 0 33.9s-24.6 9.4-33.9 0L112 433.9 89.4 456.6c-9.4 9.4-24.6 9.4-33.9 0s-9.4-24.6 0-33.9L78.1 400 55.4 377.4c-9.4-9.4-9.4-24.6 0-33.9zM64 88h96c13.3 0 24 10.7 24 24s-10.7 24-24 24H64c-13.3 0-24-10.7-24-24s10.7-24 24-24zM352 336h96c13.3 0 24 10.7 24 24s-10.7 24-24 24H352c-13.3 0-24-10.7-24-24s10.7-24 24-24zm0 80h96c13.3 0 24 10.7 24 24s-10.7 24-24 24H352c-13.3 0-24-10.7-24-24s10.7-24 24-24z'
        
      ]
    };

    
      var faCalculatorAlt = faCalculatorSimple;
    
  
    

    var faCircleMinus = {
      prefix: 'far',
      iconName: 'circle-minus',
      icon: [
        512,
        512,
        
            ['minus-circle']
        ,
        'f056',
        
        'M256 48a208 208 0 1 1 0 416 208 208 0 1 1 0-416zm0 464A256 256 0 1 0 256 0a256 256 0 1 0 0 512zM184 232c-13.3 0-24 10.7-24 24s10.7 24 24 24H328c13.3 0 24-10.7 24-24s-10.7-24-24-24H184z'
        
      ]
    };

    
      var faMinusCircle = faCircleMinus;
    
  

  return {
  
    faPrint: faPrint,
    
  
    faDown: faDown,
    
      faArrowAltDown: faArrowAltDown,
    
  
    faCircleXmark: faCircleXmark,
    
      faTimesCircle: faTimesCircle,
    
      faXmarkCircle: faXmarkCircle,
    
  
    faBookOpen: faBookOpen,
    
  
    faCheck: faCheck,
    
  
    faBook: faBook,
    
  
    faCirclePlus: faCirclePlus,
    
      faPlusCircle: faPlusCircle,
    
  
    faClockRotateLeft: faClockRotateLeft,
    
      faHistory: faHistory,
    
  
    faChevronRight: faChevronRight,
    
  
    faChevronLeft: faChevronLeft,
    
  
    faXmark: faXmark,
    
      faClose: faClose,
    
      faMultiply: faMultiply,
    
      faRemove: faRemove,
    
      faTimes: faTimes,
    
  
    faPlus: faPlus,
    
      faAdd: faAdd,
    
  
    faUserHeadset: faUserHeadset,
    
  
    faCircleUser: faCircleUser,
    
      faUserCircle: faUserCircle,
    
  
    faChevronDown: faChevronDown,
    
  
    faPlay: faPlay,
    
  
    faEraser: faEraser,
    
  
    faGreaterThan: faGreaterThan,
    
  
    faLocationDot: faLocationDot,
    
      faMapMarkerAlt: faMapMarkerAlt,
    
  
    faBookOpenReader: faBookOpenReader,
    
      faBookReader: faBookReader,
    
  
    faLessThan: faLessThan,
    
  
    faSquareArrowLeft: faSquareArrowLeft,
    
      faArrowSquareLeft: faArrowSquareLeft,
    
  
    faStop: faStop,
    
  
    faImages: faImages,
    
  
    faPowerOff: faPowerOff,
    
  
    faEllipsisVertical: faEllipsisVertical,
    
      faEllipsisV: faEllipsisV,
    
  
    faMinus: faMinus,
    
      faSubtract: faSubtract,
    
  
    faCircleInfo: faCircleInfo,
    
      faInfoCircle: faInfoCircle,
    
  
    faArrowLeft: faArrowLeft,
    
  
    faCircleQuestion: faCircleQuestion,
    
      faQuestionCircle: faQuestionCircle,
    
  
    faWrench: faWrench,
    
  
    faCircle: faCircle,
    
  
    faLockKeyhole: faLockKeyhole,
    
      faLockAlt: faLockAlt,
    
  
    faArrowRight: faArrowRight,
    
  
    faCircleArrowRight: faCircleArrowRight,
    
      faArrowCircleRight: faArrowCircleRight,
    
  
    faSquare: faSquare,
    
  
    faCommentQuestion: faCommentQuestion,
    
  
    faCircleArrowLeft: faCircleArrowLeft,
    
      faArrowCircleLeft: faArrowCircleLeft,
    
  
    faPause: faPause,
    
  
    faIdBadge: faIdBadge,
    
  
    faCircleCheck: faCircleCheck,
    
      faCheckCircle: faCheckCircle,
    
  
    faSquarePlus: faSquarePlus,
    
      faPlusSquare: faPlusSquare,
    
  
    faVolume: faVolume,
    
      faVolumeMedium: faVolumeMedium,
    
  
    faUserPen: faUserPen,
    
      faUserEdit: faUserEdit,
    
  
    faBooks: faBooks,
    
  
    faHighlighter: faHighlighter,
    
  
    faUser: faUser,
    
  
    faChevronUp: faChevronUp,
    
  
    faUsers: faUsers,
    
  
    faLightbulbOn: faLightbulbOn,
    
  
    faLock: faLock,
    
  
    faCircleDot: faCircleDot,
    
      faDotCircle: faDotCircle,
    
  
    faSquareCheck: faSquareCheck,
    
      faCheckSquare: faCheckSquare,
    
  
    faLightbulb: faLightbulb,
    
  
    faBars: faBars,
    
      faNavicon: faNavicon,
    
  
    faSquareMinus: faSquareMinus,
    
      faMinusSquare: faMinusSquare,
    
  
    faCircleNotch: faCircleNotch,
    
  
    faSquareArrowRight: faSquareArrowRight,
    
      faArrowSquareRight: faArrowSquareRight,
    
  
    faCalculatorSimple: faCalculatorSimple,
    
      faCalculatorAlt: faCalculatorAlt,
    
  
    faCircleMinus: faCircleMinus,
    
      faMinusCircle: faMinusCircle,
    
  
  };

 })()
  

  
  var fasIcons = (function () {
  
    

    var faDown = {
      prefix: 'fas',
      iconName: 'down',
      icon: [
        384,
        512,
        
            ['arrow-alt-down']
        ,
        'f354',
        
        'M214.6 470.6c-12.5 12.5-32.8 12.5-45.3 0l-160-160c-9.2-9.2-11.9-22.9-6.9-34.9s16.6-19.8 29.6-19.8l96 0 0-184c0-22.1 17.9-40 40-40l48 0c22.1 0 40 17.9 40 40l0 184 96 0c12.9 0 24.6 7.8 29.6 19.8s2.2 25.7-6.9 34.9l-160 160z'
        
      ]
    };

    
      var faArrowAltDown = faDown;
    
  
    

    var faCircleXmark = {
      prefix: 'fas',
      iconName: 'circle-xmark',
      icon: [
        512,
        512,
        
            [61532,'times-circle','xmark-circle']
        ,
        'f057',
        
        'M256 512A256 256 0 1 0 256 0a256 256 0 1 0 0 512zM175 175c9.4-9.4 24.6-9.4 33.9 0l47 47 47-47c9.4-9.4 24.6-9.4 33.9 0s9.4 24.6 0 33.9l-47 47 47 47c9.4 9.4 9.4 24.6 0 33.9s-24.6 9.4-33.9 0l-47-47-47 47c-9.4 9.4-24.6 9.4-33.9 0s-9.4-24.6 0-33.9l47-47-47-47c-9.4-9.4-9.4-24.6 0-33.9z'
        
      ]
    };

    
      var faTimesCircle = faCircleXmark;
    
      var faXmarkCircle = faCircleXmark;
    
  
    

    var faTriangleExclamation = {
      prefix: 'fas',
      iconName: 'triangle-exclamation',
      icon: [
        512,
        512,
        
            [9888,'exclamation-triangle','warning']
        ,
        'f071',
        
        'M256 32c14.2 0 27.3 7.5 34.5 19.8l216 368c7.3 12.4 7.3 27.7 .2 40.1S486.3 480 472 480H40c-14.3 0-27.6-7.7-34.7-20.1s-7-27.8 .2-40.1l216-368C228.7 39.5 241.8 32 256 32zm0 128c-13.3 0-24 10.7-24 24V296c0 13.3 10.7 24 24 24s24-10.7 24-24V184c0-13.3-10.7-24-24-24zm32 224a32 32 0 1 0 -64 0 32 32 0 1 0 64 0z'
        
      ]
    };

    
      var faExclamationTriangle = faTriangleExclamation;
    
      var faWarning = faTriangleExclamation;
    
  
    

    var faBookOpen = {
      prefix: 'fas',
      iconName: 'book-open',
      icon: [
        576,
        512,
        
            [128366,128214]
        ,
        'f518',
        
        'M249.6 471.5c10.8 3.8 22.4-4.1 22.4-15.5V78.6c0-4.2-1.6-8.4-5-11C247.4 52 202.4 32 144 32C93.5 32 46.3 45.3 18.1 56.1C6.8 60.5 0 71.7 0 83.8V454.1c0 11.9 12.8 20.2 24.1 16.5C55.6 460.1 105.5 448 144 448c33.9 0 79 14 105.6 23.5zm76.8 0C353 462 398.1 448 432 448c38.5 0 88.4 12.1 119.9 22.6c11.3 3.8 24.1-4.6 24.1-16.5V83.8c0-12.1-6.8-23.3-18.1-27.6C529.7 45.3 482.5 32 432 32c-58.4 0-103.4 20-123 35.6c-3.3 2.6-5 6.8-5 11V456c0 11.4 11.7 19.3 22.4 15.5z'
        
      ]
    };

    
  
    

    var faCheck = {
      prefix: 'fas',
      iconName: 'check',
      icon: [
        448,
        512,
        
            [10004,10003]
        ,
        'f00c',
        
        'M438.6 105.4c12.5 12.5 12.5 32.8 0 45.3l-256 256c-12.5 12.5-32.8 12.5-45.3 0l-128-128c-12.5-12.5-12.5-32.8 0-45.3s32.8-12.5 45.3 0L160 338.7 393.4 105.4c12.5-12.5 32.8-12.5 45.3 0z'
        
      ]
    };

    
  
    

    var faBook = {
      prefix: 'fas',
      iconName: 'book',
      icon: [
        448,
        512,
        
            [128212]
        ,
        'f02d',
        
        'M96 0C43 0 0 43 0 96V416c0 53 43 96 96 96H384h32c17.7 0 32-14.3 32-32s-14.3-32-32-32V384c17.7 0 32-14.3 32-32V32c0-17.7-14.3-32-32-32H384 96zm0 384H352v64H96c-17.7 0-32-14.3-32-32s14.3-32 32-32zm32-240c0-8.8 7.2-16 16-16H336c8.8 0 16 7.2 16 16s-7.2 16-16 16H144c-8.8 0-16-7.2-16-16zm16 48H336c8.8 0 16 7.2 16 16s-7.2 16-16 16H144c-8.8 0-16-7.2-16-16s7.2-16 16-16z'
        
      ]
    };

    
  
    

    var faCirclePlus = {
      prefix: 'fas',
      iconName: 'circle-plus',
      icon: [
        512,
        512,
        
            ['plus-circle']
        ,
        'f055',
        
        'M256 512A256 256 0 1 0 256 0a256 256 0 1 0 0 512zM232 344V280H168c-13.3 0-24-10.7-24-24s10.7-24 24-24h64V168c0-13.3 10.7-24 24-24s24 10.7 24 24v64h64c13.3 0 24 10.7 24 24s-10.7 24-24 24H280v64c0 13.3-10.7 24-24 24s-24-10.7-24-24z'
        
      ]
    };

    
      var faPlusCircle = faCirclePlus;
    
  
    

    var faClockRotateLeft = {
      prefix: 'fas',
      iconName: 'clock-rotate-left',
      icon: [
        512,
        512,
        
            ['history']
        ,
        'f1da',
        
        'M75 75L41 41C25.9 25.9 0 36.6 0 57.9V168c0 13.3 10.7 24 24 24H134.1c21.4 0 32.1-25.9 17-41l-30.8-30.8C155 85.5 203 64 256 64c106 0 192 86 192 192s-86 192-192 192c-40.8 0-78.6-12.7-109.7-34.4c-14.5-10.1-34.4-6.6-44.6 7.9s-6.6 34.4 7.9 44.6C151.2 495 201.7 512 256 512c141.4 0 256-114.6 256-256S397.4 0 256 0C185.3 0 121.3 28.7 75 75zm181 53c-13.3 0-24 10.7-24 24V256c0 6.4 2.5 12.5 7 17l72 72c9.4 9.4 24.6 9.4 33.9 0s9.4-24.6 0-33.9l-65-65V152c0-13.3-10.7-24-24-24z'
        
      ]
    };

    
      var faHistory = faClockRotateLeft;
    
  
    

    var faChevronRight = {
      prefix: 'fas',
      iconName: 'chevron-right',
      icon: [
        320,
        512,
        
            [9002]
        ,
        'f054',
        
        'M310.6 233.4c12.5 12.5 12.5 32.8 0 45.3l-192 192c-12.5 12.5-32.8 12.5-45.3 0s-12.5-32.8 0-45.3L242.7 256 73.4 86.6c-12.5-12.5-12.5-32.8 0-45.3s32.8-12.5 45.3 0l192 192z'
        
      ]
    };

    
  
    

    var faChevronLeft = {
      prefix: 'fas',
      iconName: 'chevron-left',
      icon: [
        320,
        512,
        
            [9001]
        ,
        'f053',
        
        'M9.4 233.4c-12.5 12.5-12.5 32.8 0 45.3l192 192c12.5 12.5 32.8 12.5 45.3 0s12.5-32.8 0-45.3L77.3 256 246.6 86.6c12.5-12.5 12.5-32.8 0-45.3s-32.8-12.5-45.3 0l-192 192z'
        
      ]
    };

    
  
    

    var faXmark = {
      prefix: 'fas',
      iconName: 'xmark',
      icon: [
        384,
        512,
        
            [215,10060,10006,10005,128473,'close','multiply','remove','times']
        ,
        'f00d',
        
        'M342.6 150.6c12.5-12.5 12.5-32.8 0-45.3s-32.8-12.5-45.3 0L192 210.7 86.6 105.4c-12.5-12.5-32.8-12.5-45.3 0s-12.5 32.8 0 45.3L146.7 256 41.4 361.4c-12.5 12.5-12.5 32.8 0 45.3s32.8 12.5 45.3 0L192 301.3 297.4 406.6c12.5 12.5 32.8 12.5 45.3 0s12.5-32.8 0-45.3L237.3 256 342.6 150.6z'
        
      ]
    };

    
      var faClose = faXmark;
    
      var faMultiply = faXmark;
    
      var faRemove = faXmark;
    
      var faTimes = faXmark;
    
  
    

    var faPlus = {
      prefix: 'fas',
      iconName: 'plus',
      icon: [
        448,
        512,
        
            [61543,10133,'add']
        ,
        '2b',
        
        'M256 80c0-17.7-14.3-32-32-32s-32 14.3-32 32V224H48c-17.7 0-32 14.3-32 32s14.3 32 32 32H192V432c0 17.7 14.3 32 32 32s32-14.3 32-32V288H400c17.7 0 32-14.3 32-32s-14.3-32-32-32H256V80z'
        
      ]
    };

    
      var faAdd = faPlus;
    
  
    

    var faUserHeadset = {
      prefix: 'fas',
      iconName: 'user-headset',
      icon: [
        448,
        512,
        
            []
          ,
        'f82d',
        
        'M224 32C135.6 32 64 103.6 64 192v16c0 8.8-7.2 16-16 16s-16-7.2-16-16V192C32 86 118 0 224 0S416 86 416 192v16c0 61.9-50.1 112-112 112H240 224 208c-17.7 0-32-14.3-32-32s14.3-32 32-32h32c17.7 0 32 14.3 32 32h32c44.2 0 80-35.8 80-80V192c0-88.4-71.6-160-160-160zM96 192c0-70.7 57.3-128 128-128s128 57.3 128 128c0 13.9-2.2 27.3-6.3 39.8C337.4 246.3 321.8 256 304 256h-8.6c-11.1-19.1-31.7-32-55.4-32H208c-35.3 0-64 28.7-64 64c0 1.4 0 2.7 .1 4C114.8 268.6 96 232.5 96 192zM224 352h16 64 9.6C387.8 352 448 412.2 448 486.4c0 14.1-11.5 25.6-25.6 25.6H25.6C11.5 512 0 500.5 0 486.4C0 412.2 60.2 352 134.4 352H208h16z'
        
      ]
    };

    
  
    

    var faCircleUser = {
      prefix: 'fas',
      iconName: 'circle-user',
      icon: [
        512,
        512,
        
            [62142,'user-circle']
        ,
        'f2bd',
        
        'M399 384.2C376.9 345.8 335.4 320 288 320H224c-47.4 0-88.9 25.8-111 64.2c35.2 39.2 86.2 63.8 143 63.8s107.8-24.7 143-63.8zM0 256a256 256 0 1 1 512 0A256 256 0 1 1 0 256zm256 16a72 72 0 1 0 0-144 72 72 0 1 0 0 144z'
        
      ]
    };

    
      var faUserCircle = faCircleUser;
    
  
    

    var faChevronDown = {
      prefix: 'fas',
      iconName: 'chevron-down',
      icon: [
        512,
        512,
        
            []
          ,
        'f078',
        
        'M233.4 406.6c12.5 12.5 32.8 12.5 45.3 0l192-192c12.5-12.5 12.5-32.8 0-45.3s-32.8-12.5-45.3 0L256 338.7 86.6 169.4c-12.5-12.5-32.8-12.5-45.3 0s-12.5 32.8 0 45.3l192 192z'
        
      ]
    };

    
  
    

    var faPlay = {
      prefix: 'fas',
      iconName: 'play',
      icon: [
        384,
        512,
        
            [9654]
        ,
        'f04b',
        
        'M73 39c-14.8-9.1-33.4-9.4-48.5-.9S0 62.6 0 80V432c0 17.4 9.4 33.4 24.5 41.9s33.7 8.1 48.5-.9L361 297c14.3-8.7 23-24.2 23-41s-8.7-32.2-23-41L73 39z'
        
      ]
    };

    
  
    

    var faEraser = {
      prefix: 'fas',
      iconName: 'eraser',
      icon: [
        576,
        512,
        
            []
          ,
        'f12d',
        
        'M290.7 57.4L57.4 290.7c-25 25-25 65.5 0 90.5l80 80c12 12 28.3 18.7 45.3 18.7H288h9.4H512c17.7 0 32-14.3 32-32s-14.3-32-32-32H387.9L518.6 285.3c25-25 25-65.5 0-90.5L381.3 57.4c-25-25-65.5-25-90.5 0zM297.4 416H288l-105.4 0-80-80L227.3 211.3 364.7 348.7 297.4 416z'
        
      ]
    };

    
  
    

    var faGreaterThan = {
      prefix: 'fas',
      iconName: 'greater-than',
      icon: [
        384,
        512,
        
            [62769]
        ,
        '3e',
        
        'M3.4 81.7c-7.9 15.8-1.5 35 14.3 42.9L280.5 256 17.7 387.4C1.9 395.3-4.5 414.5 3.4 430.3s27.1 22.2 42.9 14.3l320-160c10.8-5.4 17.7-16.5 17.7-28.6s-6.8-23.2-17.7-28.6l-320-160c-15.8-7.9-35-1.5-42.9 14.3z'
        
      ]
    };

    
  
    

    var faLocationDot = {
      prefix: 'fas',
      iconName: 'location-dot',
      icon: [
        384,
        512,
        
            ['map-marker-alt']
        ,
        'f3c5',
        
        'M215.7 499.2C267 435 384 279.4 384 192C384 86 298 0 192 0S0 86 0 192c0 87.4 117 243 168.3 307.2c12.3 15.3 35.1 15.3 47.4 0zM192 128a64 64 0 1 1 0 128 64 64 0 1 1 0-128z'
        
      ]
    };

    
      var faMapMarkerAlt = faLocationDot;
    
  
    

    var faBookOpenReader = {
      prefix: 'fas',
      iconName: 'book-open-reader',
      icon: [
        512,
        512,
        
            ['book-reader']
        ,
        'f5da',
        
        'M160 96a96 96 0 1 1 192 0A96 96 0 1 1 160 96zm80 152V512l-48.4-24.2c-20.9-10.4-43.5-17-66.8-19.3l-96-9.6C12.5 457.2 0 443.5 0 427V224c0-17.7 14.3-32 32-32H62.3c63.6 0 125.6 19.6 177.7 56zm32 264V248c52.1-36.4 114.1-56 177.7-56H480c17.7 0 32 14.3 32 32V427c0 16.4-12.5 30.2-28.8 31.8l-96 9.6c-23.2 2.3-45.9 8.9-66.8 19.3L272 512z'
        
      ]
    };

    
      var faBookReader = faBookOpenReader;
    
  
    

    var faLessThan = {
      prefix: 'fas',
      iconName: 'less-than',
      icon: [
        384,
        512,
        
            [62774]
        ,
        '3c',
        
        'M380.6 81.7c7.9 15.8 1.5 35-14.3 42.9L103.6 256 366.3 387.4c15.8 7.9 22.2 27.1 14.3 42.9s-27.1 22.2-42.9 14.3l-320-160C6.8 279.2 0 268.1 0 256s6.8-23.2 17.7-28.6l320-160c15.8-7.9 35-1.5 42.9 14.3z'
        
      ]
    };

    
  
    

    var faSquareArrowLeft = {
      prefix: 'fas',
      iconName: 'square-arrow-left',
      icon: [
        448,
        512,
        
            ['arrow-square-left']
        ,
        'f33a',
        
        'M0 416c0 35.3 28.7 64 64 64l320 0c35.3 0 64-28.7 64-64l0-320c0-35.3-28.7-64-64-64L64 32C28.7 32 0 60.7 0 96L0 416zM87 239L199 127c9.4-9.4 24.6-9.4 33.9 0s9.4 24.6 0 33.9l-71 71L344 232c13.3 0 24 10.7 24 24s-10.7 24-24 24l-182.1 0 71 71c9.4 9.4 9.4 24.6 0 33.9s-24.6 9.4-33.9 0L87 273c-9.4-9.4-9.4-24.6 0-33.9z'
        
      ]
    };

    
      var faArrowSquareLeft = faSquareArrowLeft;
    
  
    

    var faStop = {
      prefix: 'fas',
      iconName: 'stop',
      icon: [
        384,
        512,
        
            [9209]
        ,
        'f04d',
        
        'M0 128C0 92.7 28.7 64 64 64H320c35.3 0 64 28.7 64 64V384c0 35.3-28.7 64-64 64H64c-35.3 0-64-28.7-64-64V128z'
        
      ]
    };

    
  
    

    var faImages = {
      prefix: 'fas',
      iconName: 'images',
      icon: [
        576,
        512,
        
            []
          ,
        'f302',
        
        'M160 32c-35.3 0-64 28.7-64 64V320c0 35.3 28.7 64 64 64H512c35.3 0 64-28.7 64-64V96c0-35.3-28.7-64-64-64H160zM396 138.7l96 144c4.9 7.4 5.4 16.8 1.2 24.6S480.9 320 472 320H328 280 200c-9.2 0-17.6-5.3-21.6-13.6s-2.9-18.2 2.9-25.4l64-80c4.6-5.7 11.4-9 18.7-9s14.2 3.3 18.7 9l17.3 21.6 56-84C360.5 132 368 128 376 128s15.5 4 20 10.7zM192 128a32 32 0 1 1 64 0 32 32 0 1 1 -64 0zM48 120c0-13.3-10.7-24-24-24S0 106.7 0 120V344c0 75.1 60.9 136 136 136H456c13.3 0 24-10.7 24-24s-10.7-24-24-24H136c-48.6 0-88-39.4-88-88V120z'
        
      ]
    };

    
  
    

    var faPowerOff = {
      prefix: 'fas',
      iconName: 'power-off',
      icon: [
        512,
        512,
        
            [9211]
        ,
        'f011',
        
        'M288 32c0-17.7-14.3-32-32-32s-32 14.3-32 32V256c0 17.7 14.3 32 32 32s32-14.3 32-32V32zM143.5 120.6c13.6-11.3 15.4-31.5 4.1-45.1s-31.5-15.4-45.1-4.1C49.7 115.4 16 181.8 16 256c0 132.5 107.5 240 240 240s240-107.5 240-240c0-74.2-33.8-140.6-86.6-184.6c-13.6-11.3-33.8-9.4-45.1 4.1s-9.4 33.8 4.1 45.1c38.9 32.3 63.5 81 63.5 135.4c0 97.2-78.8 176-176 176s-176-78.8-176-176c0-54.4 24.7-103.1 63.5-135.4z'
        
      ]
    };

    
  
    

    var faEllipsisVertical = {
      prefix: 'fas',
      iconName: 'ellipsis-vertical',
      icon: [
        128,
        512,
        
            ['ellipsis-v']
        ,
        'f142',
        
        'M64 360a56 56 0 1 0 0 112 56 56 0 1 0 0-112zm0-160a56 56 0 1 0 0 112 56 56 0 1 0 0-112zM120 96A56 56 0 1 0 8 96a56 56 0 1 0 112 0z'
        
      ]
    };

    
      var faEllipsisV = faEllipsisVertical;
    
  
    

    var faMinus = {
      prefix: 'fas',
      iconName: 'minus',
      icon: [
        448,
        512,
        
            [10134,8722,8211,'subtract']
        ,
        'f068',
        
        'M432 256c0 17.7-14.3 32-32 32L48 288c-17.7 0-32-14.3-32-32s14.3-32 32-32l352 0c17.7 0 32 14.3 32 32z'
        
      ]
    };

    
      var faSubtract = faMinus;
    
  
    

    var faCircleInfo = {
      prefix: 'fas',
      iconName: 'circle-info',
      icon: [
        512,
        512,
        
            ['info-circle']
        ,
        'f05a',
        
        'M256 512A256 256 0 1 0 256 0a256 256 0 1 0 0 512zM216 336h24V272H216c-13.3 0-24-10.7-24-24s10.7-24 24-24h48c13.3 0 24 10.7 24 24v88h8c13.3 0 24 10.7 24 24s-10.7 24-24 24H216c-13.3 0-24-10.7-24-24s10.7-24 24-24zm40-208a32 32 0 1 1 0 64 32 32 0 1 1 0-64z'
        
      ]
    };

    
      var faInfoCircle = faCircleInfo;
    
  
    

    var faArrowLeft = {
      prefix: 'fas',
      iconName: 'arrow-left',
      icon: [
        448,
        512,
        
            [8592]
        ,
        'f060',
        
        'M9.4 233.4c-12.5 12.5-12.5 32.8 0 45.3l160 160c12.5 12.5 32.8 12.5 45.3 0s12.5-32.8 0-45.3L109.2 288 416 288c17.7 0 32-14.3 32-32s-14.3-32-32-32l-306.7 0L214.6 118.6c12.5-12.5 12.5-32.8 0-45.3s-32.8-12.5-45.3 0l-160 160z'
        
      ]
    };

    
  
    

    var faCircleQuestion = {
      prefix: 'fas',
      iconName: 'circle-question',
      icon: [
        512,
        512,
        
            [62108,'question-circle']
        ,
        'f059',
        
        'M256 512A256 256 0 1 0 256 0a256 256 0 1 0 0 512zM169.8 165.3c7.9-22.3 29.1-37.3 52.8-37.3h58.3c34.9 0 63.1 28.3 63.1 63.1c0 22.6-12.1 43.5-31.7 54.8L280 264.4c-.2 13-10.9 23.6-24 23.6c-13.3 0-24-10.7-24-24V250.5c0-8.6 4.6-16.5 12.1-20.8l44.3-25.4c4.7-2.7 7.6-7.7 7.6-13.1c0-8.4-6.8-15.1-15.1-15.1H222.6c-3.4 0-6.4 2.1-7.5 5.3l-.4 1.2c-4.4 12.5-18.2 19-30.6 14.6s-19-18.2-14.6-30.6l.4-1.2zM224 352a32 32 0 1 1 64 0 32 32 0 1 1 -64 0z'
        
      ]
    };

    
      var faQuestionCircle = faCircleQuestion;
    
  
    

    var faWrench = {
      prefix: 'fas',
      iconName: 'wrench',
      icon: [
        512,
        512,
        
            [128295]
        ,
        'f0ad',
        
        'M352 320c88.4 0 160-71.6 160-160c0-15.3-2.2-30.1-6.2-44.2c-3.1-10.8-16.4-13.2-24.3-5.3l-76.8 76.8c-3 3-7.1 4.7-11.3 4.7H336c-8.8 0-16-7.2-16-16V118.6c0-4.2 1.7-8.3 4.7-11.3l76.8-76.8c7.9-7.9 5.4-21.2-5.3-24.3C382.1 2.2 367.3 0 352 0C263.6 0 192 71.6 192 160c0 19.1 3.4 37.5 9.5 54.5L19.9 396.1C7.2 408.8 0 426.1 0 444.1C0 481.6 30.4 512 67.9 512c18 0 35.3-7.2 48-19.9L297.5 310.5c17 6.2 35.4 9.5 54.5 9.5zM80 408a24 24 0 1 1 0 48 24 24 0 1 1 0-48z'
        
      ]
    };

    
  
    

    var faCircle = {
      prefix: 'fas',
      iconName: 'circle',
      icon: [
        512,
        512,
        
            [61915,61708,11044,9899,9898,9679,128996,128995,128994,128993,128992,128309,128308]
        ,
        'f111',
        
        'M256 512A256 256 0 1 0 256 0a256 256 0 1 0 0 512z'
        
      ]
    };

    
  
    

    var faLockKeyhole = {
      prefix: 'fas',
      iconName: 'lock-keyhole',
      icon: [
        448,
        512,
        
            ['lock-alt']
        ,
        'f30d',
        
        'M224 64c44.2 0 80 35.8 80 80v48H144V144c0-44.2 35.8-80 80-80zM80 144v48H64c-35.3 0-64 28.7-64 64V448c0 35.3 28.7 64 64 64H384c35.3 0 64-28.7 64-64V256c0-35.3-28.7-64-64-64H368V144C368 64.5 303.5 0 224 0S80 64.5 80 144zM256 320v64c0 17.7-14.3 32-32 32s-32-14.3-32-32V320c0-17.7 14.3-32 32-32s32 14.3 32 32z'
        
      ]
    };

    
      var faLockAlt = faLockKeyhole;
    
  
    

    var faArrowRight = {
      prefix: 'fas',
      iconName: 'arrow-right',
      icon: [
        448,
        512,
        
            [8594]
        ,
        'f061',
        
        'M438.6 278.6c12.5-12.5 12.5-32.8 0-45.3l-160-160c-12.5-12.5-32.8-12.5-45.3 0s-12.5 32.8 0 45.3L338.8 224 32 224c-17.7 0-32 14.3-32 32s14.3 32 32 32l306.7 0L233.4 393.4c-12.5 12.5-12.5 32.8 0 45.3s32.8 12.5 45.3 0l160-160z'
        
      ]
    };

    
  
    

    var faCircleArrowRight = {
      prefix: 'fas',
      iconName: 'circle-arrow-right',
      icon: [
        512,
        512,
        
            ['arrow-circle-right']
        ,
        'f0a9',
        
        'M0 256a256 256 0 1 0 512 0A256 256 0 1 0 0 256zM281 385c-9.4 9.4-24.6 9.4-33.9 0s-9.4-24.6 0-33.9l71-71L136 280c-13.3 0-24-10.7-24-24s10.7-24 24-24l182.1 0-71-71c-9.4-9.4-9.4-24.6 0-33.9s24.6-9.4 33.9 0L393 239c9.4 9.4 9.4 24.6 0 33.9L281 385z'
        
      ]
    };

    
      var faArrowCircleRight = faCircleArrowRight;
    
  
    

    var faSquare = {
      prefix: 'fas',
      iconName: 'square',
      icon: [
        448,
        512,
        
            [61590,9724,9723,9632]
        ,
        'f0c8',
        
        'M0 96C0 60.7 28.7 32 64 32H384c35.3 0 64 28.7 64 64V416c0 35.3-28.7 64-64 64H64c-35.3 0-64-28.7-64-64V96z'
        
      ]
    };

    
  
    

    var faCommentQuestion = {
      prefix: 'fas',
      iconName: 'comment-question',
      icon: [
        512,
        512,
        
            []
          ,
        'e14b',
        
        'M256 448c141.4 0 256-93.1 256-208S397.4 32 256 32S0 125.1 0 240c0 45.1 17.7 86.8 47.7 120.9c-1.9 24.5-11.4 46.3-21.4 62.9c-5.5 9.2-11.1 16.6-15.2 21.6c-2.1 2.5-3.7 4.4-4.9 5.7c-.6 .6-1 1.1-1.3 1.4l-.3 .3 0 0 0 0 0 0 0 0c-4.6 4.6-5.9 11.4-3.4 17.4c2.5 6 8.3 9.9 14.8 9.9c28.7 0 57.6-8.9 81.6-19.3c22.9-10 42.4-21.9 54.3-30.6c31.8 11.5 67 17.9 104.1 17.9zM169.8 149.3c7.9-22.3 29.1-37.3 52.8-37.3h58.3c34.9 0 63.1 28.3 63.1 63.1c0 22.6-12.1 43.5-31.7 54.8L280 248.4c-.2 13-10.9 23.6-24 23.6c-13.3 0-24-10.7-24-24V234.5c0-8.6 4.6-16.5 12.1-20.8l44.3-25.4c4.7-2.7 7.6-7.7 7.6-13.1c0-8.4-6.8-15.1-15.1-15.1H222.6c-3.4 0-6.4 2.1-7.5 5.3l-.4 1.2c-4.4 12.5-18.2 19-30.6 14.6s-19-18.2-14.6-30.6l.4-1.2zM224 336a32 32 0 1 1 64 0 32 32 0 1 1 -64 0z'
        
      ]
    };

    
  
    

    var faCircleArrowLeft = {
      prefix: 'fas',
      iconName: 'circle-arrow-left',
      icon: [
        512,
        512,
        
            ['arrow-circle-left']
        ,
        'f0a8',
        
        'M512 256A256 256 0 1 0 0 256a256 256 0 1 0 512 0zM231 127c9.4-9.4 24.6-9.4 33.9 0s9.4 24.6 0 33.9l-71 71L376 232c13.3 0 24 10.7 24 24s-10.7 24-24 24l-182.1 0 71 71c9.4 9.4 9.4 24.6 0 33.9s-24.6 9.4-33.9 0L119 273c-9.4-9.4-9.4-24.6 0-33.9L231 127z'
        
      ]
    };

    
      var faArrowCircleLeft = faCircleArrowLeft;
    
  
    

    var faPause = {
      prefix: 'fas',
      iconName: 'pause',
      icon: [
        320,
        512,
        
            [9208]
        ,
        'f04c',
        
        'M48 64C21.5 64 0 85.5 0 112V400c0 26.5 21.5 48 48 48H80c26.5 0 48-21.5 48-48V112c0-26.5-21.5-48-48-48H48zm192 0c-26.5 0-48 21.5-48 48V400c0 26.5 21.5 48 48 48h32c26.5 0 48-21.5 48-48V112c0-26.5-21.5-48-48-48H240z'
        
      ]
    };

    
  
    

    var faIdBadge = {
      prefix: 'fas',
      iconName: 'id-badge',
      icon: [
        384,
        512,
        
            []
          ,
        'f2c1',
        
        'M64 0C28.7 0 0 28.7 0 64V448c0 35.3 28.7 64 64 64H320c35.3 0 64-28.7 64-64V64c0-35.3-28.7-64-64-64H64zm96 320h64c44.2 0 80 35.8 80 80c0 8.8-7.2 16-16 16H96c-8.8 0-16-7.2-16-16c0-44.2 35.8-80 80-80zm-32-96a64 64 0 1 1 128 0 64 64 0 1 1 -128 0zM144 64h96c8.8 0 16 7.2 16 16s-7.2 16-16 16H144c-8.8 0-16-7.2-16-16s7.2-16 16-16z'
        
      ]
    };

    
  
    

    var faCircleCheck = {
      prefix: 'fas',
      iconName: 'circle-check',
      icon: [
        512,
        512,
        
            [61533,'check-circle']
        ,
        'f058',
        
        'M256 512A256 256 0 1 0 256 0a256 256 0 1 0 0 512zM369 209L241 337c-9.4 9.4-24.6 9.4-33.9 0l-64-64c-9.4-9.4-9.4-24.6 0-33.9s24.6-9.4 33.9 0l47 47L335 175c9.4-9.4 24.6-9.4 33.9 0s9.4 24.6 0 33.9z'
        
      ]
    };

    
      var faCheckCircle = faCircleCheck;
    
  
    

    var faSquarePlus = {
      prefix: 'fas',
      iconName: 'square-plus',
      icon: [
        448,
        512,
        
            [61846,'plus-square']
        ,
        'f0fe',
        
        'M64 32C28.7 32 0 60.7 0 96V416c0 35.3 28.7 64 64 64H384c35.3 0 64-28.7 64-64V96c0-35.3-28.7-64-64-64H64zM200 344V280H136c-13.3 0-24-10.7-24-24s10.7-24 24-24h64V168c0-13.3 10.7-24 24-24s24 10.7 24 24v64h64c13.3 0 24 10.7 24 24s-10.7 24-24 24H248v64c0 13.3-10.7 24-24 24s-24-10.7-24-24z'
        
      ]
    };

    
      var faPlusSquare = faSquarePlus;
    
  
    

    var faVolume = {
      prefix: 'fas',
      iconName: 'volume',
      icon: [
        576,
        512,
        
            [128265,'volume-medium']
        ,
        'f6a8',
        
        'M333.1 34.8C344.6 40 352 51.4 352 64V448c0 12.6-7.4 24-18.9 29.2s-25 3.1-34.4-5.3L163.8 352H96c-35.3 0-64-28.7-64-64V224c0-35.3 28.7-64 64-64h67.8L298.7 40.1c9.4-8.4 22.9-10.4 34.4-5.3zm172 72.2c43.2 35.2 70.9 88.9 70.9 149s-27.7 113.8-70.9 149c-10.3 8.4-25.4 6.8-33.8-3.5s-6.8-25.4 3.5-33.8C507.3 341.3 528 301.1 528 256s-20.7-85.3-53.2-111.8c-10.3-8.4-11.8-23.5-3.5-33.8s23.5-11.8 33.8-3.5zm-60.5 74.5C466.1 199.1 480 225.9 480 256s-13.9 56.9-35.4 74.5c-10.3 8.4-25.4 6.8-33.8-3.5s-6.8-25.4 3.5-33.8C425.1 284.4 432 271 432 256s-6.9-28.4-17.7-37.3c-10.3-8.4-11.8-23.5-3.5-33.8s23.5-11.8 33.8-3.5z'
        
      ]
    };

    
      var faVolumeMedium = faVolume;
    
  
    

    var faUserPen = {
      prefix: 'fas',
      iconName: 'user-pen',
      icon: [
        640,
        512,
        
            ['user-edit']
        ,
        'f4ff',
        
        'M224 256A128 128 0 1 0 224 0a128 128 0 1 0 0 256zm-45.7 48C79.8 304 0 383.8 0 482.3C0 498.7 13.3 512 29.7 512H322.8c-3.1-8.8-3.7-18.4-1.4-27.8l15-60.1c2.8-11.3 8.6-21.5 16.8-29.7l40.3-40.3c-32.1-31-75.7-50.1-123.9-50.1H178.3zm435.5-68.3c-15.6-15.6-40.9-15.6-56.6 0l-29.4 29.4 71 71 29.4-29.4c15.6-15.6 15.6-40.9 0-56.6l-14.4-14.4zM375.9 417c-4.1 4.1-7 9.2-8.4 14.9l-15 60.1c-1.4 5.5 .2 11.2 4.2 15.2s9.7 5.6 15.2 4.2l60.1-15c5.6-1.4 10.8-4.3 14.9-8.4L576.1 358.7l-71-71L375.9 417z'
        
      ]
    };

    
      var faUserEdit = faUserPen;
    
  
    

    var faBooks = {
      prefix: 'fas',
      iconName: 'books',
      icon: [
        512,
        512,
        
            [128218]
        ,
        'f5db',
        
        'M0 32C0 14.3 14.3 0 32 0H96c17.7 0 32 14.3 32 32V96H0V32zm0 96H128V384H0V128zM0 416H128v64c0 17.7-14.3 32-32 32H32c-17.7 0-32-14.3-32-32V416zM160 32c0-17.7 14.3-32 32-32h64c17.7 0 32 14.3 32 32V96H160V32zm0 96H288V384H160V128zm0 288H288v64c0 17.7-14.3 32-32 32H192c-17.7 0-32-14.3-32-32V416zm203.6-19.9L320 232.6V142.8l100.4-26.9 66 247.4L363.6 396.1zM412.2 85L320 109.6V11l36.9-9.9c16.9-4.6 34.4 5.5 38.9 22.6L412.2 85zM371.8 427l122.8-32.9 16.3 61.1c4.5 17-5.5 34.5-22.5 39.1l-61.4 16.5c-16.9 4.6-34.4-5.5-38.9-22.6L371.8 427z'
        
      ]
    };

    
  
    

    var faHighlighter = {
      prefix: 'fas',
      iconName: 'highlighter',
      icon: [
        576,
        512,
        
            []
          ,
        'f591',
        
        'M315 315l158.4-215L444.1 70.6 229 229 315 315zm-187 5l0 0V248.3c0-15.3 7.2-29.6 19.5-38.6L420.6 8.4C428 2.9 437 0 446.2 0c11.4 0 22.4 4.5 30.5 12.6l54.8 54.8c8.1 8.1 12.6 19 12.6 30.5c0 9.2-2.9 18.2-8.4 25.6L334.4 396.5c-9 12.3-23.4 19.5-38.6 19.5H224l-25.4 25.4c-12.5 12.5-32.8 12.5-45.3 0l-50.7-50.7c-12.5-12.5-12.5-32.8 0-45.3L128 320zM7 466.3l63-63 70.6 70.6-31 31c-4.5 4.5-10.6 7-17 7H24c-13.3 0-24-10.7-24-24v-4.7c0-6.4 2.5-12.5 7-17z'
        
      ]
    };

    
  
    

    var faUser = {
      prefix: 'fas',
      iconName: 'user',
      icon: [
        448,
        512,
        
            [62144,128100]
        ,
        'f007',
        
        'M224 256A128 128 0 1 0 224 0a128 128 0 1 0 0 256zm-45.7 48C79.8 304 0 383.8 0 482.3C0 498.7 13.3 512 29.7 512H418.3c16.4 0 29.7-13.3 29.7-29.7C448 383.8 368.2 304 269.7 304H178.3z'
        
      ]
    };

    
  
    

    var faChevronUp = {
      prefix: 'fas',
      iconName: 'chevron-up',
      icon: [
        512,
        512,
        
            []
          ,
        'f077',
        
        'M233.4 105.4c12.5-12.5 32.8-12.5 45.3 0l192 192c12.5 12.5 12.5 32.8 0 45.3s-32.8 12.5-45.3 0L256 173.3 86.6 342.6c-12.5 12.5-32.8 12.5-45.3 0s-12.5-32.8 0-45.3l192-192z'
        
      ]
    };

    
  
    

    var faUsers = {
      prefix: 'fas',
      iconName: 'users',
      icon: [
        640,
        512,
        
            []
          ,
        'f0c0',
        
        'M144 0a80 80 0 1 1 0 160A80 80 0 1 1 144 0zM512 0a80 80 0 1 1 0 160A80 80 0 1 1 512 0zM0 298.7C0 239.8 47.8 192 106.7 192h42.7c15.9 0 31 3.5 44.6 9.7c-1.3 7.2-1.9 14.7-1.9 22.3c0 38.2 16.8 72.5 43.3 96c-.2 0-.4 0-.7 0H21.3C9.6 320 0 310.4 0 298.7zM405.3 320c-.2 0-.4 0-.7 0c26.6-23.5 43.3-57.8 43.3-96c0-7.6-.7-15-1.9-22.3c13.6-6.3 28.7-9.7 44.6-9.7h42.7C592.2 192 640 239.8 640 298.7c0 11.8-9.6 21.3-21.3 21.3H405.3zM224 224a96 96 0 1 1 192 0 96 96 0 1 1 -192 0zM128 485.3C128 411.7 187.7 352 261.3 352H378.7C452.3 352 512 411.7 512 485.3c0 14.7-11.9 26.7-26.7 26.7H154.7c-14.7 0-26.7-11.9-26.7-26.7z'
        
      ]
    };

    
  
    

    var faLightbulbOn = {
      prefix: 'fas',
      iconName: 'lightbulb-on',
      icon: [
        640,
        512,
        
            []
          ,
        'f672',
        
        'M69.3 4l48 32c11 7.4 14 22.3 6.7 33.3s-22.3 14-33.3 6.7l-48-32c-11-7.4-14-22.3-6.7-33.3S58.3-3.3 69.3 4zM597.3 44l-48 32c-11 7.4-25.9 4.4-33.3-6.7s-4.4-25.9 6.7-33.3l48-32c11-7.4 25.9-4.4 33.3 6.7s4.4 25.9-6.7 33.3zM24 160H88c13.3 0 24 10.7 24 24s-10.7 24-24 24H24c-13.3 0-24-10.7-24-24s10.7-24 24-24zm528 0h64c13.3 0 24 10.7 24 24s-10.7 24-24 24H552c-13.3 0-24-10.7-24-24s10.7-24 24-24zM117.3 332l-48 32c-11 7.4-25.9 4.4-33.3-6.7s-4.4-25.9 6.7-33.3l48-32c11-7.4 25.9-4.4 33.3 6.7s4.4 25.9-6.7 33.3zm432-39.9l48 32c11 7.4 14 22.3 6.7 33.3s-22.3 14-33.3 6.7l-48-32c-11-7.4-14-22.3-6.7-33.3s22.3-14 33.3-6.7zm-100.1 5.7c-19.8 27.1-39.7 54.4-49.2 86.2H240c-9.6-31.9-29.5-59.1-49.2-86.2l0 0 0 0c-5.2-7.1-10.4-14.2-15.4-21.4C155.6 247.9 144 213.3 144 176C144 78.8 222.8 0 320 0s176 78.8 176 176c0 37.3-11.6 71.9-31.4 100.3c-5 7.2-10.2 14.3-15.4 21.4l0 0 0 0zM400 432c0 44.2-35.8 80-80 80s-80-35.8-80-80V416H400v16zM320 96c8.8 0 16-7.2 16-16s-7.2-16-16-16c-61.9 0-112 50.1-112 112c0 8.8 7.2 16 16 16s16-7.2 16-16c0-44.2 35.8-80 80-80z'
        
      ]
    };

    
  
    

    var faLock = {
      prefix: 'fas',
      iconName: 'lock',
      icon: [
        448,
        512,
        
            [128274]
        ,
        'f023',
        
        'M144 144v48H304V144c0-44.2-35.8-80-80-80s-80 35.8-80 80zM80 192V144C80 64.5 144.5 0 224 0s144 64.5 144 144v48h16c35.3 0 64 28.7 64 64V448c0 35.3-28.7 64-64 64H64c-35.3 0-64-28.7-64-64V256c0-35.3 28.7-64 64-64H80z'
        
      ]
    };

    
  
    

    var faCircleDot = {
      prefix: 'fas',
      iconName: 'circle-dot',
      icon: [
        512,
        512,
        
            [128280,'dot-circle']
        ,
        'f192',
        
        'M256 512A256 256 0 1 0 256 0a256 256 0 1 0 0 512zm0-352a96 96 0 1 1 0 192 96 96 0 1 1 0-192z'
        
      ]
    };

    
      var faDotCircle = faCircleDot;
    
  
    

    var faSquareCheck = {
      prefix: 'fas',
      iconName: 'square-check',
      icon: [
        448,
        512,
        
            [61510,9989,9745,'check-square']
        ,
        'f14a',
        
        'M64 32C28.7 32 0 60.7 0 96V416c0 35.3 28.7 64 64 64H384c35.3 0 64-28.7 64-64V96c0-35.3-28.7-64-64-64H64zM337 209L209 337c-9.4 9.4-24.6 9.4-33.9 0l-64-64c-9.4-9.4-9.4-24.6 0-33.9s24.6-9.4 33.9 0l47 47L303 175c9.4-9.4 24.6-9.4 33.9 0s9.4 24.6 0 33.9z'
        
      ]
    };

    
      var faCheckSquare = faSquareCheck;
    
  
    

    var faLightbulb = {
      prefix: 'fas',
      iconName: 'lightbulb',
      icon: [
        384,
        512,
        
            [128161]
        ,
        'f0eb',
        
        'M272 384c9.6-31.9 29.5-59.1 49.2-86.2l0 0c5.2-7.1 10.4-14.2 15.4-21.4c19.8-28.5 31.4-63 31.4-100.3C368 78.8 289.2 0 192 0S16 78.8 16 176c0 37.3 11.6 71.9 31.4 100.3c5 7.2 10.2 14.3 15.4 21.4l0 0c19.8 27.1 39.7 54.4 49.2 86.2H272zM192 512c44.2 0 80-35.8 80-80V416H112v16c0 44.2 35.8 80 80 80zM112 176c0 8.8-7.2 16-16 16s-16-7.2-16-16c0-61.9 50.1-112 112-112c8.8 0 16 7.2 16 16s-7.2 16-16 16c-44.2 0-80 35.8-80 80z'
        
      ]
    };

    
  
    

    var faBars = {
      prefix: 'fas',
      iconName: 'bars',
      icon: [
        448,
        512,
        
            ['navicon']
        ,
        'f0c9',
        
        'M0 96C0 78.3 14.3 64 32 64H416c17.7 0 32 14.3 32 32s-14.3 32-32 32H32C14.3 128 0 113.7 0 96zM0 256c0-17.7 14.3-32 32-32H416c17.7 0 32 14.3 32 32s-14.3 32-32 32H32c-17.7 0-32-14.3-32-32zM448 416c0 17.7-14.3 32-32 32H32c-17.7 0-32-14.3-32-32s14.3-32 32-32H416c17.7 0 32 14.3 32 32z'
        
      ]
    };

    
      var faNavicon = faBars;
    
  
    

    var faSquareMinus = {
      prefix: 'fas',
      iconName: 'square-minus',
      icon: [
        448,
        512,
        
            [61767,'minus-square']
        ,
        'f146',
        
        'M64 32C28.7 32 0 60.7 0 96V416c0 35.3 28.7 64 64 64H384c35.3 0 64-28.7 64-64V96c0-35.3-28.7-64-64-64H64zm88 200H296c13.3 0 24 10.7 24 24s-10.7 24-24 24H152c-13.3 0-24-10.7-24-24s10.7-24 24-24z'
        
      ]
    };

    
      var faMinusSquare = faSquareMinus;
    
  
    

    var faCircleNotch = {
      prefix: 'fas',
      iconName: 'circle-notch',
      icon: [
        512,
        512,
        
            []
          ,
        'f1ce',
        
        'M222.7 32.1c5 16.9-4.6 34.8-21.5 39.8C121.8 95.6 64 169.1 64 256c0 106 86 192 192 192s192-86 192-192c0-86.9-57.8-160.4-137.1-184.1c-16.9-5-26.6-22.9-21.5-39.8s22.9-26.6 39.8-21.5C434.9 42.1 512 140 512 256c0 141.4-114.6 256-256 256S0 397.4 0 256C0 140 77.1 42.1 182.9 10.6c16.9-5 34.8 4.6 39.8 21.5z'
        
      ]
    };

    
  
    

    var faSquareArrowRight = {
      prefix: 'fas',
      iconName: 'square-arrow-right',
      icon: [
        448,
        512,
        
            ['arrow-square-right']
        ,
        'f33b',
        
        'M448 96c0-35.3-28.7-64-64-64L64 32C28.7 32 0 60.7 0 96L0 416c0 35.3 28.7 64 64 64l320 0c35.3 0 64-28.7 64-64l0-320zM361 273L249 385c-9.4 9.4-24.6 9.4-33.9 0s-9.4-24.6 0-33.9l71-71L104 280c-13.3 0-24-10.7-24-24s10.7-24 24-24l182.1 0-71-71c-9.4-9.4-9.4-24.6 0-33.9s24.6-9.4 33.9 0L361 239c9.4 9.4 9.4 24.6 0 33.9z'
        
      ]
    };

    
      var faArrowSquareRight = faSquareArrowRight;
    
  
    

    var faCalculatorSimple = {
      prefix: 'fas',
      iconName: 'calculator-simple',
      icon: [
        512,
        512,
        
            ['calculator-alt']
        ,
        'f64c',
        
        'M0 48C0 21.5 21.5 0 48 0H176c26.5 0 48 21.5 48 48V176c0 26.5-21.5 48-48 48H48c-26.5 0-48-21.5-48-48V48zm288 0c0-26.5 21.5-48 48-48H464c26.5 0 48 21.5 48 48V176c0 26.5-21.5 48-48 48H336c-26.5 0-48-21.5-48-48V48zm48 240H464c26.5 0 48 21.5 48 48V464c0 26.5-21.5 48-48 48H336c-26.5 0-48-21.5-48-48V336c0-26.5 21.5-48 48-48zM0 336c0-26.5 21.5-48 48-48H176c26.5 0 48 21.5 48 48V464c0 26.5-21.5 48-48 48H48c-26.5 0-48-21.5-48-48V336zM416 64c0-8.8-7.2-16-16-16s-16 7.2-16 16V96H352c-8.8 0-16 7.2-16 16s7.2 16 16 16h32v32c0 8.8 7.2 16 16 16s16-7.2 16-16V128h32c8.8 0 16-7.2 16-16s-7.2-16-16-16H416V64zM64 96c-8.8 0-16 7.2-16 16s7.2 16 16 16h96c8.8 0 16-7.2 16-16s-7.2-16-16-16H64zM83.3 348.7c-6.2-6.2-16.4-6.2-22.6 0s-6.2 16.4 0 22.6L89.4 400 60.7 428.7c-6.2 6.2-6.2 16.4 0 22.6s16.4 6.2 22.6 0L112 422.6l28.7 28.7c6.2 6.2 16.4 6.2 22.6 0s6.2-16.4 0-22.6L134.6 400l28.7-28.7c6.2-6.2 6.2-16.4 0-22.6s-16.4-6.2-22.6 0L112 377.4 83.3 348.7zM352 352c-8.8 0-16 7.2-16 16s7.2 16 16 16h96c8.8 0 16-7.2 16-16s-7.2-16-16-16H352zm0 64c-8.8 0-16 7.2-16 16s7.2 16 16 16h96c8.8 0 16-7.2 16-16s-7.2-16-16-16H352z'
        
      ]
    };

    
      var faCalculatorAlt = faCalculatorSimple;
    
  
    

    var faCircleMinus = {
      prefix: 'fas',
      iconName: 'circle-minus',
      icon: [
        512,
        512,
        
            ['minus-circle']
        ,
        'f056',
        
        'M256 512A256 256 0 1 0 256 0a256 256 0 1 0 0 512zM184 232H328c13.3 0 24 10.7 24 24s-10.7 24-24 24H184c-13.3 0-24-10.7-24-24s10.7-24 24-24z'
        
      ]
    };

    
      var faMinusCircle = faCircleMinus;
    
  

  return {
  
    faDown: faDown,
    
      faArrowAltDown: faArrowAltDown,
    
  
    faCircleXmark: faCircleXmark,
    
      faTimesCircle: faTimesCircle,
    
      faXmarkCircle: faXmarkCircle,
    
  
    faTriangleExclamation: faTriangleExclamation,
    
      faExclamationTriangle: faExclamationTriangle,
    
      faWarning: faWarning,
    
  
    faBookOpen: faBookOpen,
    
  
    faCheck: faCheck,
    
  
    faBook: faBook,
    
  
    faCirclePlus: faCirclePlus,
    
      faPlusCircle: faPlusCircle,
    
  
    faClockRotateLeft: faClockRotateLeft,
    
      faHistory: faHistory,
    
  
    faChevronRight: faChevronRight,
    
  
    faChevronLeft: faChevronLeft,
    
  
    faXmark: faXmark,
    
      faClose: faClose,
    
      faMultiply: faMultiply,
    
      faRemove: faRemove,
    
      faTimes: faTimes,
    
  
    faPlus: faPlus,
    
      faAdd: faAdd,
    
  
    faUserHeadset: faUserHeadset,
    
  
    faCircleUser: faCircleUser,
    
      faUserCircle: faUserCircle,
    
  
    faChevronDown: faChevronDown,
    
  
    faPlay: faPlay,
    
  
    faEraser: faEraser,
    
  
    faGreaterThan: faGreaterThan,
    
  
    faLocationDot: faLocationDot,
    
      faMapMarkerAlt: faMapMarkerAlt,
    
  
    faBookOpenReader: faBookOpenReader,
    
      faBookReader: faBookReader,
    
  
    faLessThan: faLessThan,
    
  
    faSquareArrowLeft: faSquareArrowLeft,
    
      faArrowSquareLeft: faArrowSquareLeft,
    
  
    faStop: faStop,
    
  
    faImages: faImages,
    
  
    faPowerOff: faPowerOff,
    
  
    faEllipsisVertical: faEllipsisVertical,
    
      faEllipsisV: faEllipsisV,
    
  
    faMinus: faMinus,
    
      faSubtract: faSubtract,
    
  
    faCircleInfo: faCircleInfo,
    
      faInfoCircle: faInfoCircle,
    
  
    faArrowLeft: faArrowLeft,
    
  
    faCircleQuestion: faCircleQuestion,
    
      faQuestionCircle: faQuestionCircle,
    
  
    faWrench: faWrench,
    
  
    faCircle: faCircle,
    
  
    faLockKeyhole: faLockKeyhole,
    
      faLockAlt: faLockAlt,
    
  
    faArrowRight: faArrowRight,
    
  
    faCircleArrowRight: faCircleArrowRight,
    
      faArrowCircleRight: faArrowCircleRight,
    
  
    faSquare: faSquare,
    
  
    faCommentQuestion: faCommentQuestion,
    
  
    faCircleArrowLeft: faCircleArrowLeft,
    
      faArrowCircleLeft: faArrowCircleLeft,
    
  
    faPause: faPause,
    
  
    faIdBadge: faIdBadge,
    
  
    faCircleCheck: faCircleCheck,
    
      faCheckCircle: faCheckCircle,
    
  
    faSquarePlus: faSquarePlus,
    
      faPlusSquare: faPlusSquare,
    
  
    faVolume: faVolume,
    
      faVolumeMedium: faVolumeMedium,
    
  
    faUserPen: faUserPen,
    
      faUserEdit: faUserEdit,
    
  
    faBooks: faBooks,
    
  
    faHighlighter: faHighlighter,
    
  
    faUser: faUser,
    
  
    faChevronUp: faChevronUp,
    
  
    faUsers: faUsers,
    
  
    faLightbulbOn: faLightbulbOn,
    
  
    faLock: faLock,
    
  
    faCircleDot: faCircleDot,
    
      faDotCircle: faDotCircle,
    
  
    faSquareCheck: faSquareCheck,
    
      faCheckSquare: faCheckSquare,
    
  
    faLightbulb: faLightbulb,
    
  
    faBars: faBars,
    
      faNavicon: faNavicon,
    
  
    faSquareMinus: faSquareMinus,
    
      faMinusSquare: faMinusSquare,
    
  
    faCircleNotch: faCircleNotch,
    
  
    faSquareArrowRight: faSquareArrowRight,
    
      faArrowSquareRight: faArrowSquareRight,
    
  
    faCalculatorSimple: faCalculatorSimple,
    
      faCalculatorAlt: faCalculatorAlt,
    
  
    faCircleMinus: faCircleMinus,
    
      faMinusCircle: faMinusCircle,
    
  
  };

 })()
  

  
  var fadIcons = (function () {
  
    

    var faDown = {
      prefix: 'fad',
      iconName: 'down',
      icon: [
        384,
        512,
        
            ['arrow-alt-down']
        ,
        'f354',
        
        ['M256 256H128V72c0-22.1 17.9-40 40-40h48c22.1 0 40 17.9 40 40l0 184z','M128 256v0l-96 0c-12.9 0-24.6 7.8-29.6 19.8s-2.2 25.7 6.9 34.9l160 160c12.5 12.5 32.8 12.5 45.3 0l160-160c9.2-9.2 11.9-22.9 6.9-34.9s-16.6-19.8-29.6-19.8l-96 0v0H128z']
        
      ]
    };

    
      var faArrowAltDown = faDown;
    
  
    

    var faCircleXmark = {
      prefix: 'fad',
      iconName: 'circle-xmark',
      icon: [
        512,
        512,
        
            [61532,'times-circle','xmark-circle']
        ,
        'f057',
        
        ['M256 512A256 256 0 1 0 256 0a256 256 0 1 0 0 512zM175 175c9.4-9.4 24.6-9.4 33.9 0l47 47 47-47c9.4-9.4 24.6-9.4 33.9 0s9.4 24.6 0 33.9l-47 47 47 47c9.4 9.4 9.4 24.6 0 33.9s-24.6 9.4-33.9 0l-47-47-47 47c-9.4 9.4-24.6 9.4-33.9 0s-9.4-24.6 0-33.9l47-47-47-47c-9.4-9.4-9.4-24.6 0-33.9z','M209 175c-9.4-9.4-24.6-9.4-33.9 0s-9.4 24.6 0 33.9l47 47-47 47c-9.4 9.4-9.4 24.6 0 33.9s24.6 9.4 33.9 0l47-47 47 47c9.4 9.4 24.6 9.4 33.9 0s9.4-24.6 0-33.9l-47-47 47-47c9.4-9.4 9.4-24.6 0-33.9s-24.6-9.4-33.9 0l-47 47-47-47z']
        
      ]
    };

    
      var faTimesCircle = faCircleXmark;
    
      var faXmarkCircle = faCircleXmark;
    
  
    

    var faBookOpen = {
      prefix: 'fad',
      iconName: 'book-open',
      icon: [
        576,
        512,
        
            [128366,128214]
        ,
        'f518',
        
        ['M288 72V480s92.8-32 144-32c38.5 0 88.4 12.1 119.9 22.6c11.3 3.8 24.1-4.6 24.1-16.5V83.8c0-12.1-6.8-23.3-18.1-27.6C529.7 45.3 482.5 32 432 32c-64 0-128 24-144 40z','M288 72V480s-92.8-32-144-32c-38.5 0-88.4 12.1-119.9 22.6C12.8 474.3 0 466 0 454.1V83.8C0 71.7 6.8 60.5 18.1 56.1C46.3 45.3 93.5 32 144 32c64 0 128 24 144 40z']
        
      ]
    };

    
  
    

    var faCheck = {
      prefix: 'fad',
      iconName: 'check',
      icon: [
        448,
        512,
        
            [10004,10003]
        ,
        'f00c',
        
        ['','M438.6 105.4c12.5 12.5 12.5 32.8 0 45.3l-256 256c-12.5 12.5-32.8 12.5-45.3 0l-128-128c-12.5-12.5-12.5-32.8 0-45.3s32.8-12.5 45.3 0L160 338.7 393.4 105.4c12.5-12.5 32.8-12.5 45.3 0z']
        
      ]
    };

    
  
    

    var faBook = {
      prefix: 'fad',
      iconName: 'book',
      icon: [
        448,
        512,
        
            [128212]
        ,
        'f02d',
        
        ['M64 416c0-17.7 14.3-32 32-32H416v64H96c-17.7 0-32-14.3-32-32z','M0 96C0 43 43 0 96 0H384h32c17.7 0 32 14.3 32 32V352c0 17.7-14.3 32-32 32H352 256 96c-17.7 0-32 14.3-32 32s14.3 32 32 32H256h96 64c17.7 0 32 14.3 32 32s-14.3 32-32 32H384 96c-53 0-96-43-96-96V96zm144 32c-8.8 0-16 7.2-16 16s7.2 16 16 16H336c8.8 0 16-7.2 16-16s-7.2-16-16-16H144zm-16 80c0 8.8 7.2 16 16 16H336c8.8 0 16-7.2 16-16s-7.2-16-16-16H144c-8.8 0-16 7.2-16 16z']
        
      ]
    };

    
  
    

    var faCirclePlus = {
      prefix: 'fad',
      iconName: 'circle-plus',
      icon: [
        512,
        512,
        
            ['plus-circle']
        ,
        'f055',
        
        ['M256 512A256 256 0 1 0 256 0a256 256 0 1 0 0 512zM232 344V280H168c-13.3 0-24-10.7-24-24s10.7-24 24-24h64V168c0-13.3 10.7-24 24-24s24 10.7 24 24v64h64c13.3 0 24 10.7 24 24s-10.7 24-24 24H280v64c0 13.3-10.7 24-24 24s-24-10.7-24-24z','M232 280v64c0 13.3 10.7 24 24 24s24-10.7 24-24V280h64c13.3 0 24-10.7 24-24s-10.7-24-24-24H280V168c0-13.3-10.7-24-24-24s-24 10.7-24 24v64H168c-13.3 0-24 10.7-24 24s10.7 24 24 24h64z']
        
      ]
    };

    
      var faPlusCircle = faCirclePlus;
    
  
    

    var faClockRotateLeft = {
      prefix: 'fad',
      iconName: 'clock-rotate-left',
      icon: [
        512,
        512,
        
            ['history']
        ,
        'f1da',
        
        ['M120.2 120.2C155 85.5 203 64 256 64c106 0 192 86 192 192s-86 192-192 192c-40.8 0-78.6-12.7-109.7-34.4c-14.5-10.1-34.4-6.6-44.6 7.9s-6.6 34.4 7.9 44.6C151.2 495 201.7 512 256 512c141.4 0 256-114.6 256-256S397.4 0 256 0C185.3 0 121.3 28.7 75 75L41 41C25.9 25.9 0 36.6 0 57.9V168c0 13.3 10.7 24 24 24H134.1c21.4 0 32.1-25.9 17-41l-30.8-30.8z','M256 128c13.3 0 24 10.7 24 24v94.1l65 65c9.4 9.4 9.4 24.6 0 33.9s-24.6 9.4-33.9 0l-72-72c-4.5-4.5-7-10.6-7-17V152c0-13.3 10.7-24 24-24z']
        
      ]
    };

    
      var faHistory = faClockRotateLeft;
    
  
    

    var faChevronRight = {
      prefix: 'fad',
      iconName: 'chevron-right',
      icon: [
        320,
        512,
        
            [9002]
        ,
        'f054',
        
        ['M310.6 233.4c12.5 12.5 12.5 32.8 0 45.3l-192 192c-12.5 12.5-32.8 12.5-45.3 0s-12.5-32.8 0-45.3L242.7 256 73.4 86.6c-12.5-12.5-12.5-32.8 0-45.3s32.8-12.5 45.3 0l192 192z','']
        
      ]
    };

    
  
    

    var faChevronLeft = {
      prefix: 'fad',
      iconName: 'chevron-left',
      icon: [
        320,
        512,
        
            [9001]
        ,
        'f053',
        
        ['M9.4 233.4c-12.5 12.5-12.5 32.8 0 45.3l192 192c12.5 12.5 32.8 12.5 45.3 0s12.5-32.8 0-45.3L77.3 256 246.6 86.6c12.5-12.5 12.5-32.8 0-45.3s-32.8-12.5-45.3 0l-192 192z','']
        
      ]
    };

    
  
    

    var faXmark = {
      prefix: 'fad',
      iconName: 'xmark',
      icon: [
        384,
        512,
        
            [215,10060,10006,10005,128473,'close','multiply','remove','times']
        ,
        'f00d',
        
        ['M297.4 406.6c12.5 12.5 32.8 12.5 45.3 0s12.5-32.8 0-45.3L237.3 256 342.6 150.6c12.5-12.5 12.5-32.8 0-45.3s-32.8-12.5-45.3 0L192 210.7 86.6 105.4c-12.5-12.5-32.8-12.5-45.3 0s-12.5 32.8 0 45.3L146.7 256 41.4 361.4c-12.5 12.5-12.5 32.8 0 45.3s32.8 12.5 45.3 0L192 301.3 297.4 406.6z','']
        
      ]
    };

    
      var faClose = faXmark;
    
      var faMultiply = faXmark;
    
      var faRemove = faXmark;
    
      var faTimes = faXmark;
    
  
    

    var faPlus = {
      prefix: 'fad',
      iconName: 'plus',
      icon: [
        448,
        512,
        
            [61543,10133,'add']
        ,
        '2b',
        
        ['M256 80c0-17.7-14.3-32-32-32s-32 14.3-32 32V224H48c-17.7 0-32 14.3-32 32s14.3 32 32 32H192V432c0 17.7 14.3 32 32 32s32-14.3 32-32V288H400c17.7 0 32-14.3 32-32s-14.3-32-32-32H256V80z','']
        
      ]
    };

    
      var faAdd = faPlus;
    
  
    

    var faUserHeadset = {
      prefix: 'fad',
      iconName: 'user-headset',
      icon: [
        448,
        512,
        
            []
          ,
        'f82d',
        
        ['M96 192c0-70.7 57.3-128 128-128s128 57.3 128 128c0 13.9-2.2 27.3-6.3 39.8C337.4 246.3 321.8 256 304 256h-8.6c-11.1-19.1-31.7-32-55.4-32H208c-35.3 0-64 28.7-64 64c0 1.4 0 2.7 .1 4C114.8 268.6 96 232.5 96 192z','M224 32C135.6 32 64 103.6 64 192v16c0 8.8-7.2 16-16 16s-16-7.2-16-16V192C32 86 118 0 224 0S416 86 416 192v16c0 61.9-50.1 112-112 112H240 224 208c-17.7 0-32-14.3-32-32s14.3-32 32-32h32c17.7 0 32 14.3 32 32h32c44.2 0 80-35.8 80-80V192c0-88.4-71.6-160-160-160zM134.4 352H313.6C387.8 352 448 412.2 448 486.4c0 14.1-11.5 25.6-25.6 25.6H25.6C11.5 512 0 500.5 0 486.4C0 412.2 60.2 352 134.4 352z']
        
      ]
    };

    
  
    

    var faCircleUser = {
      prefix: 'fad',
      iconName: 'circle-user',
      icon: [
        512,
        512,
        
            [62142,'user-circle']
        ,
        'f2bd',
        
        ['M399 384.2C376.9 345.8 335.4 320 288 320H224c-47.4 0-88.9 25.8-111 64.2c35.2 39.2 86.2 63.8 143 63.8s107.8-24.7 143-63.8zM0 256a256 256 0 1 1 512 0A256 256 0 1 1 0 256zm256 16a72 72 0 1 0 0-144 72 72 0 1 0 0 144z','M256 272a72 72 0 1 0 0-144 72 72 0 1 0 0 144zm0 176c56.8 0 107.8-24.7 143-63.8C376.9 345.8 335.4 320 288 320H224c-47.4 0-88.9 25.8-111 64.2c35.2 39.2 86.2 63.8 143 63.8z']
        
      ]
    };

    
      var faUserCircle = faCircleUser;
    
  
    

    var faChevronDown = {
      prefix: 'fad',
      iconName: 'chevron-down',
      icon: [
        512,
        512,
        
            []
          ,
        'f078',
        
        ['M278.6 406.6c-12.5 12.5-32.8 12.5-45.3 0l-192-192c-12.5-12.5-12.5-32.8 0-45.3s32.8-12.5 45.3 0L256 338.7 425.4 169.4c12.5-12.5 32.8-12.5 45.3 0s12.5 32.8 0 45.3l-192 192z','']
        
      ]
    };

    
  
    

    var faPlay = {
      prefix: 'fad',
      iconName: 'play',
      icon: [
        384,
        512,
        
            [9654]
        ,
        'f04b',
        
        ['','M73 39c-14.8-9.1-33.4-9.4-48.5-.9S0 62.6 0 80V432c0 17.4 9.4 33.4 24.5 41.9s33.7 8.1 48.5-.9L361 297c14.3-8.7 23-24.2 23-41s-8.7-32.2-23-41L73 39z']
        
      ]
    };

    
  
    

    var faEraser = {
      prefix: 'fad',
      iconName: 'eraser',
      icon: [
        576,
        512,
        
            []
          ,
        'f12d',
        
        ['M409.9 393.9l-45.3-45.3L297.4 416H288l-105.4 0-80-80L227.3 211.3l-45.3-45.3L57.4 290.7c-25 25-25 65.5 0 90.5l80 80c12 12 28.3 18.7 45.3 18.7H288h9.4H512c17.7 0 32-14.3 32-32s-14.3-32-32-32H387.9l22.1-22.1z','M409.9 393.9L518.6 285.3c25-25 25-65.5 0-90.5L381.3 57.4c-25-25-65.5-25-90.5 0L182.1 166.1l45.3 45.3L364.7 348.7l45.3 45.3z']
        
      ]
    };

    
  
    

    var faGreaterThan = {
      prefix: 'fad',
      iconName: 'greater-than',
      icon: [
        384,
        512,
        
            [62769]
        ,
        '3e',
        
        ['M3.4 81.7c-7.9 15.8-1.5 35 14.3 42.9L280.5 256 17.7 387.4C1.9 395.3-4.5 414.5 3.4 430.3s27.1 22.2 42.9 14.3l320-160c10.8-5.4 17.7-16.5 17.7-28.6s-6.8-23.2-17.7-28.6l-320-160c-15.8-7.9-35-1.5-42.9 14.3z','']
        
      ]
    };

    
  
    

    var faLocationDot = {
      prefix: 'fad',
      iconName: 'location-dot',
      icon: [
        384,
        512,
        
            ['map-marker-alt']
        ,
        'f3c5',
        
        ['M215.7 499.2C267 435 384 279.4 384 192C384 86 298 0 192 0S0 86 0 192c0 87.4 117 243 168.3 307.2c12.3 15.3 35.1 15.3 47.4 0zM192 112a80 80 0 1 1 0 160 80 80 0 1 1 0-160z','M192 144a48 48 0 1 0 0 96 48 48 0 1 0 0-96z']
        
      ]
    };

    
      var faMapMarkerAlt = faLocationDot;
    
  
    

    var faBookOpenReader = {
      prefix: 'fad',
      iconName: 'book-open-reader',
      icon: [
        512,
        512,
        
            ['book-reader']
        ,
        'f5da',
        
        ['M256 192A96 96 0 1 0 256 0a96 96 0 1 0 0 192z','M240 512V248c-52.1-36.4-114.1-56-177.7-56H32c-17.7 0-32 14.3-32 32V427c0 16.4 12.5 30.2 28.8 31.8l96 9.6c23.2 2.3 45.9 8.9 66.8 19.3L240 512zm32 0l48.4-24.2c20.9-10.4 43.5-17 66.8-19.3l96-9.6c16.4-1.6 28.8-15.4 28.8-31.8V224c0-17.7-14.3-32-32-32H449.7c-63.6 0-125.6 19.6-177.7 56V512z']
        
      ]
    };

    
      var faBookReader = faBookOpenReader;
    
  
    

    var faLessThan = {
      prefix: 'fad',
      iconName: 'less-than',
      icon: [
        384,
        512,
        
            [62774]
        ,
        '3c',
        
        ['M380.6 81.7c7.9 15.8 1.5 35-14.3 42.9L103.6 256 366.3 387.4c15.8 7.9 22.2 27.1 14.3 42.9s-27.1 22.2-42.9 14.3l-320-160C6.8 279.2 0 268.1 0 256s6.8-23.2 17.7-28.6l320-160c15.8-7.9 35-1.5 42.9 14.3z','']
        
      ]
    };

    
  
    

    var faSquareArrowLeft = {
      prefix: 'fad',
      iconName: 'square-arrow-left',
      icon: [
        448,
        512,
        
            ['arrow-square-left']
        ,
        'f33a',
        
        ['M0 416c0 35.3 28.7 64 64 64l320 0c35.3 0 64-28.7 64-64l0-320c0-35.3-28.7-64-64-64L64 32C28.7 32 0 60.7 0 96L0 416zM87 239L199 127c9.4-9.4 24.6-9.4 33.9 0s9.4 24.6 0 33.9l-71 71L344 232c13.3 0 24 10.7 24 24s-10.7 24-24 24l-182.1 0 71 71c9.4 9.4 9.4 24.6 0 33.9s-24.6 9.4-33.9 0L87 273c-9.4-9.4-9.4-24.6 0-33.9z','M87 273c-9.4-9.4-9.4-24.6 0-33.9L199 127c9.4-9.4 24.6-9.4 33.9 0s9.4 24.6 0 33.9l-71 71L344 232c13.3 0 24 10.7 24 24s-10.7 24-24 24l-182.1 0 71 71c9.4 9.4 9.4 24.6 0 33.9s-24.6 9.4-33.9 0L87 273z']
        
      ]
    };

    
      var faArrowSquareLeft = faSquareArrowLeft;
    
  
    

    var faStop = {
      prefix: 'fad',
      iconName: 'stop',
      icon: [
        384,
        512,
        
            [9209]
        ,
        'f04d',
        
        ['M0 128C0 92.7 28.7 64 64 64H320c35.3 0 64 28.7 64 64V384c0 35.3-28.7 64-64 64H64c-35.3 0-64-28.7-64-64V128z','']
        
      ]
    };

    
  
    

    var faImages = {
      prefix: 'fad',
      iconName: 'images',
      icon: [
        576,
        512,
        
            []
          ,
        'f302',
        
        ['M96 96c0-35.3 28.7-64 64-64H512c35.3 0 64 28.7 64 64V320c0 35.3-28.7 64-64 64H160c-35.3 0-64-28.7-64-64V96zm280 32c-8 0-15.5 4-20 10.7l-56 84L282.7 201c-4.6-5.7-11.4-9-18.7-9s-14.2 3.3-18.7 9l-64 80c-5.8 7.2-6.9 17.1-2.9 25.4s12.4 13.6 21.6 13.6h80 48H472c8.9 0 17-4.9 21.2-12.7s3.7-17.3-1.2-24.6l-96-144C391.5 132 384 128 376 128zM224 160a32 32 0 1 0 0-64 32 32 0 1 0 0 64z','M48 120c0-13.3-10.7-24-24-24S0 106.7 0 120V344c0 75.1 60.9 136 136 136H456c13.3 0 24-10.7 24-24s-10.7-24-24-24H136c-48.6 0-88-39.4-88-88V120zm348 18.7C391.5 132 384 128 376 128s-15.5 4-20 10.7l-56 84L282.7 201c-4.6-5.7-11.4-9-18.7-9s-14.2 3.3-18.7 9l-64 80c-5.8 7.2-6.9 17.1-2.9 25.4s12.4 13.6 21.6 13.6h80 48H472c8.9 0 17-4.9 21.2-12.7s3.7-17.3-1.2-24.6l-96-144z']
        
      ]
    };

    
  
    

    var faPowerOff = {
      prefix: 'fad',
      iconName: 'power-off',
      icon: [
        512,
        512,
        
            [9211]
        ,
        'f011',
        
        ['M256 0c17.7 0 32 14.3 32 32V256c0 17.7-14.3 32-32 32s-32-14.3-32-32V32c0-17.7 14.3-32 32-32z','M147.7 75.5c11.3 13.6 9.4 33.8-4.1 45.1C104.7 152.9 80 201.6 80 256c0 97.2 78.8 176 176 176s176-78.8 176-176c0-54.4-24.7-103.1-63.5-135.4c-13.6-11.3-15.4-31.5-4.1-45.1s31.5-15.4 45.1-4.1C462.2 115.4 496 181.8 496 256c0 132.5-107.5 240-240 240S16 388.6 16 256c0-74.2 33.7-140.6 86.6-184.6c13.6-11.3 33.8-9.4 45.1 4.1z']
        
      ]
    };

    
  
    

    var faEllipsisVertical = {
      prefix: 'fad',
      iconName: 'ellipsis-vertical',
      icon: [
        128,
        512,
        
            ['ellipsis-v']
        ,
        'f142',
        
        ['M8 256a56 56 0 1 1 112 0A56 56 0 1 1 8 256z','M120 96A56 56 0 1 0 8 96a56 56 0 1 0 112 0zm0 320A56 56 0 1 0 8 416a56 56 0 1 0 112 0z']
        
      ]
    };

    
      var faEllipsisV = faEllipsisVertical;
    
  
    

    var faMinus = {
      prefix: 'fad',
      iconName: 'minus',
      icon: [
        448,
        512,
        
            [10134,8722,8211,'subtract']
        ,
        'f068',
        
        ['M432 256c0 17.7-14.3 32-32 32L48 288c-17.7 0-32-14.3-32-32s14.3-32 32-32l352 0c17.7 0 32 14.3 32 32z','']
        
      ]
    };

    
      var faSubtract = faMinus;
    
  
    

    var faCircleInfo = {
      prefix: 'fad',
      iconName: 'circle-info',
      icon: [
        512,
        512,
        
            ['info-circle']
        ,
        'f05a',
        
        ['M256 512A256 256 0 1 0 256 0a256 256 0 1 0 0 512zM216 336h24V272H216c-13.3 0-24-10.7-24-24s10.7-24 24-24h48c13.3 0 24 10.7 24 24v88h8c13.3 0 24 10.7 24 24s-10.7 24-24 24H216c-13.3 0-24-10.7-24-24s10.7-24 24-24zm40-208a32 32 0 1 1 0 64 32 32 0 1 1 0-64z','M256 128a32 32 0 1 1 0 64 32 32 0 1 1 0-64zM192 248c0-13.3 10.7-24 24-24h48c13.3 0 24 10.7 24 24v88h8c13.3 0 24 10.7 24 24s-10.7 24-24 24H216c-13.3 0-24-10.7-24-24s10.7-24 24-24h24V272H216c-13.3 0-24-10.7-24-24z']
        
      ]
    };

    
      var faInfoCircle = faCircleInfo;
    
  
    

    var faArrowLeft = {
      prefix: 'fad',
      iconName: 'arrow-left',
      icon: [
        448,
        512,
        
            [8592]
        ,
        'f060',
        
        ['M109.3 288L416 288c17.7 0 32-14.3 32-32s-14.3-32-32-32l-306.7 0-32 32 32 32z','M9.4 278.6c-12.5-12.5-12.5-32.8 0-45.3l160-160c12.5-12.5 32.8-12.5 45.3 0s12.5 32.8 0 45.3L77.3 256 214.6 393.4c12.5 12.5 12.5 32.8 0 45.3s-32.8 12.5-45.3 0l-160-160z']
        
      ]
    };

    
  
    

    var faCircleQuestion = {
      prefix: 'fad',
      iconName: 'circle-question',
      icon: [
        512,
        512,
        
            [62108,'question-circle']
        ,
        'f059',
        
        ['M256 512A256 256 0 1 0 256 0a256 256 0 1 0 0 512zM169.8 165.3c7.9-22.3 29.1-37.3 52.8-37.3h58.3c34.9 0 63.1 28.3 63.1 63.1c0 22.6-12.1 43.5-31.7 54.8L280 264.4c-.2 13-10.9 23.6-24 23.6c-13.3 0-24-10.7-24-24V250.5c0-8.6 4.6-16.5 12.1-20.8l44.3-25.4c4.7-2.7 7.6-7.7 7.6-13.1c0-8.4-6.8-15.1-15.1-15.1H222.6c-3.4 0-6.4 2.1-7.5 5.3l-.4 1.2c-4.4 12.5-18.2 19-30.6 14.6s-19-18.2-14.6-30.6l.4-1.2zM224 352a32 32 0 1 1 64 0 32 32 0 1 1 -64 0z','M222.6 128c-23.7 0-44.8 14.9-52.8 37.3l-.4 1.2c-4.4 12.5 2.1 26.2 14.6 30.6s26.2-2.1 30.6-14.6l.4-1.2c1.1-3.2 4.2-5.3 7.5-5.3h58.3c8.4 0 15.1 6.8 15.1 15.1c0 5.4-2.9 10.4-7.6 13.1l-44.3 25.4c-7.5 4.3-12.1 12.2-12.1 20.8V264c0 13.3 10.7 24 24 24c13.1 0 23.8-10.5 24-23.6l32.3-18.5c19.6-11.3 31.7-32.2 31.7-54.8c0-34.9-28.3-63.1-63.1-63.1H222.6zM256 384a32 32 0 1 0 0-64 32 32 0 1 0 0 64z']
        
      ]
    };

    
      var faQuestionCircle = faCircleQuestion;
    
  
    

    var faWrench = {
      prefix: 'fad',
      iconName: 'wrench',
      icon: [
        512,
        512,
        
            [128295]
        ,
        'f0ad',
        
        ['M201.5 214.5L19.9 396.1C7.2 408.8 0 426.1 0 444.1C0 481.6 30.4 512 67.9 512c18 0 35.3-7.2 48-19.9L297.5 310.5c-44.5-16.1-79.9-51.5-96-96zM56 432a24 24 0 1 1 48 0 24 24 0 1 1 -48 0z','M352 320c88.4 0 160-71.6 160-160c0-15.3-2.2-30.1-6.2-44.2c-3.1-10.8-16.4-13.2-24.3-5.3l-76.8 76.8c-3 3-7.1 4.7-11.3 4.7H336c-8.8 0-16-7.2-16-16V118.6c0-4.2 1.7-8.3 4.7-11.3l76.8-76.8c7.9-7.9 5.4-21.2-5.3-24.3C382.1 2.2 367.3 0 352 0C263.6 0 192 71.6 192 160s71.6 160 160 160z']
        
      ]
    };

    
  
    

    var faCircle = {
      prefix: 'fad',
      iconName: 'circle',
      icon: [
        512,
        512,
        
            [61915,61708,11044,9899,9898,9679,128996,128995,128994,128993,128992,128309,128308]
        ,
        'f111',
        
        ['M256 512A256 256 0 1 0 256 0a256 256 0 1 0 0 512z','']
        
      ]
    };

    
  
    

    var faWifiSlash = {
      prefix: 'fad',
      iconName: 'wifi-slash',
      icon: [
        640,
        512,
        
            []
          ,
        'f6ac',
        
        ['M364.6 260.4c39.2 7.9 74.7 26.1 103.6 51.6c13.3 11.7 33.5 10.4 45.2-2.8s10.4-33.5-2.8-45.2C459.8 219.2 393 192 320 192c-13.3 0-26.5 .9-39.3 2.7l83.9 65.8zM185.6 120.2C227.4 104.5 272.7 96 320 96c103.2 0 196.8 40.7 265.8 106.9c12.8 12.2 33 11.8 45.2-.9s11.8-33-.9-45.2C549.7 79.5 440.4 32 320 32c-68.7 0-133.7 15.5-191.9 43.1l57.5 45.1zM380.8 396l-55.6-43.8c-1.7-.1-3.4-.2-5.2-.2c-35.3 0-64 28.7-64 64s28.7 64 64 64s64-28.7 64-64c0-7-1.1-13.7-3.2-20zM228 275.7L173 232.3c-15.5 9.2-30.1 19.8-43.5 31.7c-13.3 11.7-14.5 31.9-2.8 45.2s31.9 14.5 45.2 2.8c16.7-14.8 35.6-27 56.2-36.3zM93.6 169.8L41.7 128.9C30.7 137.7 20 147 9.8 156.7C-2.9 169-3.3 189.2 8.9 202s32.5 13.2 45.2 .9c12.4-11.9 25.6-23 39.5-33.1z','M5.1 9.2C13.3-1.2 28.4-3.1 38.8 5.1l592 464c10.4 8.2 12.3 23.3 4.1 33.7s-23.3 12.3-33.7 4.1L9.2 42.9C-1.2 34.7-3.1 19.6 5.1 9.2z']
        
      ]
    };

    
  
    

    var faLockKeyhole = {
      prefix: 'fad',
      iconName: 'lock-keyhole',
      icon: [
        448,
        512,
        
            ['lock-alt']
        ,
        'f30d',
        
        ['M224 64c-44.2 0-80 35.8-80 80v48H80V144C80 64.5 144.5 0 224 0s144 64.5 144 144v48H304V144c0-44.2-35.8-80-80-80z','M64 192c-35.3 0-64 28.7-64 64V448c0 35.3 28.7 64 64 64H384c35.3 0 64-28.7 64-64V256c0-35.3-28.7-64-64-64H64zM256 320v64c0 17.7-14.3 32-32 32s-32-14.3-32-32V320c0-17.7 14.3-32 32-32s32 14.3 32 32z']
        
      ]
    };

    
      var faLockAlt = faLockKeyhole;
    
  
    

    var faArrowRight = {
      prefix: 'fad',
      iconName: 'arrow-right',
      icon: [
        448,
        512,
        
            [8594]
        ,
        'f061',
        
        ['M338.7 224L32 224c-17.7 0-32 14.3-32 32s14.3 32 32 32l306.7 0 32-32-32-32z','M438.6 233.4c12.5 12.5 12.5 32.8 0 45.3l-160 160c-12.5 12.5-32.8 12.5-45.3 0s-12.5-32.8 0-45.3L370.7 256 233.4 118.6c-12.5-12.5-12.5-32.8 0-45.3s32.8-12.5 45.3 0l160 160z']
        
      ]
    };

    
  
    

    var faCircleArrowRight = {
      prefix: 'fad',
      iconName: 'circle-arrow-right',
      icon: [
        512,
        512,
        
            ['arrow-circle-right']
        ,
        'f0a9',
        
        ['M0 256a256 256 0 1 0 512 0A256 256 0 1 0 0 256zM281 385c-9.4 9.4-24.6 9.4-33.9 0s-9.4-24.6 0-33.9l71-71L136 280c-13.3 0-24-10.7-24-24s10.7-24 24-24l182.1 0-71-71c-9.4-9.4-9.4-24.6 0-33.9s24.6-9.4 33.9 0L393 239c9.4 9.4 9.4 24.6 0 33.9L281 385z','M393 239c9.4 9.4 9.4 24.6 0 33.9L281 385c-9.4 9.4-24.6 9.4-33.9 0s-9.4-24.6 0-33.9l71-71L136 280c-13.3 0-24-10.7-24-24s10.7-24 24-24l182.1 0-71-71c-9.4-9.4-9.4-24.6 0-33.9s24.6-9.4 33.9 0L393 239z']
        
      ]
    };

    
      var faArrowCircleRight = faCircleArrowRight;
    
  
    

    var faSquare = {
      prefix: 'fad',
      iconName: 'square',
      icon: [
        448,
        512,
        
            [61590,9724,9723,9632]
        ,
        'f0c8',
        
        ['M0 96C0 60.7 28.7 32 64 32H384c35.3 0 64 28.7 64 64V416c0 35.3-28.7 64-64 64H64c-35.3 0-64-28.7-64-64V96z','']
        
      ]
    };

    
  
    

    var faCommentQuestion = {
      prefix: 'fad',
      iconName: 'comment-question',
      icon: [
        512,
        512,
        
            []
          ,
        'e14b',
        
        ['M256 448c141.4 0 256-93.1 256-208S397.4 32 256 32S0 125.1 0 240c0 45.1 17.7 86.8 47.7 120.9c-1.9 24.5-11.4 46.3-21.4 62.9c-5.5 9.2-11.1 16.6-15.2 21.6c-2.1 2.5-3.7 4.4-4.9 5.7c-.6 .6-1 1.1-1.3 1.4l-.3 .3 0 0 0 0 0 0 0 0c-4.6 4.6-5.9 11.4-3.4 17.4c2.5 6 8.3 9.9 14.8 9.9c28.7 0 57.6-8.9 81.6-19.3c22.9-10 42.4-21.9 54.3-30.6c31.8 11.5 67 17.9 104.1 17.9zM169.8 149.3c7.9-22.3 29.1-37.3 52.8-37.3h58.3c34.9 0 63.1 28.3 63.1 63.1c0 22.6-12.1 43.5-31.7 54.8L280 248.4c-.2 13-10.9 23.6-24 23.6c-13.3 0-24-10.7-24-24V234.5c0-8.6 4.6-16.5 12.1-20.8l44.3-25.4c4.7-2.7 7.6-7.7 7.6-13.1c0-8.4-6.8-15.1-15.1-15.1H222.6c-3.4 0-6.4 2.1-7.5 5.3l-.4 1.2c-4.4 12.5-18.2 19-30.6 14.6s-19-18.2-14.6-30.6l.4-1.2zM224 336a32 32 0 1 1 64 0 32 32 0 1 1 -64 0z','M222.6 112c-23.7 0-44.8 14.9-52.8 37.3l-.4 1.2c-4.4 12.5 2.1 26.2 14.6 30.6s26.2-2.1 30.6-14.6l.4-1.2c1.1-3.2 4.2-5.3 7.5-5.3h58.3c8.4 0 15.1 6.8 15.1 15.1c0 5.4-2.9 10.4-7.6 13.1l-44.3 25.4c-7.5 4.3-12.1 12.2-12.1 20.8V248c0 13.3 10.7 24 24 24c13.1 0 23.8-10.5 24-23.6l32.3-18.5c19.6-11.3 31.7-32.2 31.7-54.8c0-34.9-28.3-63.1-63.1-63.1H222.6zM256 368a32 32 0 1 0 0-64 32 32 0 1 0 0 64z']
        
      ]
    };

    
  
    

    var faCircleArrowLeft = {
      prefix: 'fad',
      iconName: 'circle-arrow-left',
      icon: [
        512,
        512,
        
            ['arrow-circle-left']
        ,
        'f0a8',
        
        ['M512 256A256 256 0 1 0 0 256a256 256 0 1 0 512 0zM231 127c9.4-9.4 24.6-9.4 33.9 0s9.4 24.6 0 33.9l-71 71L376 232c13.3 0 24 10.7 24 24s-10.7 24-24 24l-182.1 0 71 71c9.4 9.4 9.4 24.6 0 33.9s-24.6 9.4-33.9 0L119 273c-9.4-9.4-9.4-24.6 0-33.9L231 127z','M119 273c-9.4-9.4-9.4-24.6 0-33.9L231 127c9.4-9.4 24.6-9.4 33.9 0s9.4 24.6 0 33.9l-71 71L376 232c13.3 0 24 10.7 24 24s-10.7 24-24 24l-182.1 0 71 71c9.4 9.4 9.4 24.6 0 33.9s-24.6 9.4-33.9 0L119 273z']
        
      ]
    };

    
      var faArrowCircleLeft = faCircleArrowLeft;
    
  
    

    var faPause = {
      prefix: 'fad',
      iconName: 'pause',
      icon: [
        320,
        512,
        
            [9208]
        ,
        'f04c',
        
        ['M48 64C21.5 64 0 85.5 0 112V400c0 26.5 21.5 48 48 48H80c26.5 0 48-21.5 48-48V112c0-26.5-21.5-48-48-48H48zm192 0c-26.5 0-48 21.5-48 48V400c0 26.5 21.5 48 48 48h32c26.5 0 48-21.5 48-48V112c0-26.5-21.5-48-48-48H240z','']
        
      ]
    };

    
  
    

    var faIdBadge = {
      prefix: 'fad',
      iconName: 'id-badge',
      icon: [
        384,
        512,
        
            []
          ,
        'f2c1',
        
        ['M64 0C28.7 0 0 28.7 0 64V448c0 35.3 28.7 64 64 64H320c35.3 0 64-28.7 64-64V64c0-35.3-28.7-64-64-64H64zm96 320h64c44.2 0 80 35.8 80 80c0 8.8-7.2 16-16 16H96c-8.8 0-16-7.2-16-16c0-44.2 35.8-80 80-80zm-32-96a64 64 0 1 1 128 0 64 64 0 1 1 -128 0zM144 64h96c8.8 0 16 7.2 16 16s-7.2 16-16 16H144c-8.8 0-16-7.2-16-16s7.2-16 16-16z','M192 288a64 64 0 1 0 0-128 64 64 0 1 0 0 128zm-32 32c-44.2 0-80 35.8-80 80c0 8.8 7.2 16 16 16H288c8.8 0 16-7.2 16-16c0-44.2-35.8-80-80-80H160z']
        
      ]
    };

    
  
    

    var faCircleCheck = {
      prefix: 'fad',
      iconName: 'circle-check',
      icon: [
        512,
        512,
        
            [61533,'check-circle']
        ,
        'f058',
        
        ['M256 512A256 256 0 1 0 256 0a256 256 0 1 0 0 512zM369 209L241 337c-9.4 9.4-24.6 9.4-33.9 0l-64-64c-9.4-9.4-9.4-24.6 0-33.9s24.6-9.4 33.9 0l47 47L335 175c9.4-9.4 24.6-9.4 33.9 0s9.4 24.6 0 33.9z','M369 175c9.4 9.4 9.4 24.6 0 33.9L241 337c-9.4 9.4-24.6 9.4-33.9 0l-64-64c-9.4-9.4-9.4-24.6 0-33.9s24.6-9.4 33.9 0l47 47L335 175c9.4-9.4 24.6-9.4 33.9 0z']
        
      ]
    };

    
      var faCheckCircle = faCircleCheck;
    
  
    

    var faSquarePlus = {
      prefix: 'fad',
      iconName: 'square-plus',
      icon: [
        448,
        512,
        
            [61846,'plus-square']
        ,
        'f0fe',
        
        ['M64 32C28.7 32 0 60.7 0 96V416c0 35.3 28.7 64 64 64H384c35.3 0 64-28.7 64-64V96c0-35.3-28.7-64-64-64H64zM200 344V280H136c-13.3 0-24-10.7-24-24s10.7-24 24-24h64V168c0-13.3 10.7-24 24-24s24 10.7 24 24v64h64c13.3 0 24 10.7 24 24s-10.7 24-24 24H248v64c0 13.3-10.7 24-24 24s-24-10.7-24-24z','M200 280v64c0 13.3 10.7 24 24 24s24-10.7 24-24V280h64c13.3 0 24-10.7 24-24s-10.7-24-24-24H248V168c0-13.3-10.7-24-24-24s-24 10.7-24 24v64H136c-13.3 0-24 10.7-24 24s10.7 24 24 24h64z']
        
      ]
    };

    
      var faPlusSquare = faSquarePlus;
    
  
    

    var faVolume = {
      prefix: 'fad',
      iconName: 'volume',
      icon: [
        576,
        512,
        
            [128265,'volume-medium']
        ,
        'f6a8',
        
        ['M471.3 110.5c8.4-10.3 23.5-11.8 33.8-3.5c43.2 35.2 70.9 88.9 70.9 149s-27.7 113.8-70.9 149c-10.3 8.4-25.4 6.8-33.8-3.5s-6.8-25.4 3.5-33.8C507.3 341.3 528 301.1 528 256s-20.7-85.3-53.2-111.8c-10.3-8.4-11.8-23.5-3.5-33.8zM410.8 185c8.4-10.3 23.5-11.8 33.8-3.5C466.1 199.1 480 225.9 480 256s-13.9 56.9-35.4 74.5c-10.3 8.4-25.4 6.8-33.8-3.5s-6.8-25.4 3.5-33.8C425.1 284.4 432 271 432 256s-6.9-28.4-17.7-37.3c-10.3-8.4-11.8-23.5-3.5-33.8z','M352 64c0-12.6-7.4-24-18.9-29.2s-25-3.1-34.4 5.3L163.8 160H96c-35.3 0-64 28.7-64 64v64c0 35.3 28.7 64 64 64h67.8L298.7 471.9c9.4 8.4 22.9 10.4 34.4 5.3S352 460.6 352 448V64z']
        
      ]
    };

    
      var faVolumeMedium = faVolume;
    
  
    

    var faUserPen = {
      prefix: 'fad',
      iconName: 'user-pen',
      icon: [
        640,
        512,
        
            ['user-edit']
        ,
        'f4ff',
        
        ['M96 128a128 128 0 1 1 256 0A128 128 0 1 1 96 128zM0 482.3C0 383.8 79.8 304 178.3 304h91.4c48.1 0 91.8 19.1 123.9 50.1l-40.3 40.3c-8.2 8.2-14 18.5-16.8 29.7l-15 60.1c-2.3 9.4-1.8 19 1.4 27.8H29.7C13.3 512 0 498.7 0 482.3z','M557.2 235.7l-29.4 29.4 71 71 29.4-29.4c15.6-15.6 15.6-40.9 0-56.6l-14.4-14.4c-15.6-15.6-40.9-15.6-56.6 0zm-52 52L375.9 417c-4.1 4.1-7 9.2-8.4 14.9l-15 60.1c-1.4 5.5 .2 11.2 4.2 15.2s9.7 5.6 15.2 4.2l60.1-15c5.6-1.4 10.8-4.3 14.9-8.4L576.1 358.7l-71-71z']
        
      ]
    };

    
      var faUserEdit = faUserPen;
    
  
    

    var faWifi = {
      prefix: 'fad',
      iconName: 'wifi',
      icon: [
        640,
        512,
        
            ['wifi-3','wifi-strong']
        ,
        'f1eb',
        
        ['','M54.2 202.9C123.2 136.7 216.8 96 320 96s196.8 40.7 265.8 106.9c12.8 12.2 33 11.8 45.2-.9s11.8-33-.9-45.2C549.7 79.5 440.4 32 320 32S90.3 79.5 9.8 156.7C-2.9 169-3.3 189.2 8.9 202s32.5 13.2 45.2 .9zM320 256c56.8 0 108.6 21.1 148.2 56c13.3 11.7 33.5 10.4 45.2-2.8s10.4-33.5-2.8-45.2C459.8 219.2 393 192 320 192s-139.8 27.2-190.5 72c-13.3 11.7-14.5 31.9-2.8 45.2s31.9 14.5 45.2 2.8c39.5-34.9 91.3-56 148.2-56zm64 160a64 64 0 1 0 -128 0 64 64 0 1 0 128 0z']
        
      ]
    };

    
      var faWifi3 = faWifi;
    
      var faWifiStrong = faWifi;
    
  
    

    var faBooks = {
      prefix: 'fad',
      iconName: 'books',
      icon: [
        512,
        512,
        
            [128218]
        ,
        'f5db',
        
        ['M0 32C0 14.3 14.3 0 32 0H96c17.7 0 32 14.3 32 32V96H0V32zm0 96H128V384H0V128zM0 416H128v64c0 17.7-14.3 32-32 32H32c-17.7 0-32-14.3-32-32V416zM160 32c0-17.7 14.3-32 32-32h64c17.7 0 32 14.3 32 32V96H160V32zm0 96H288V384H160V128zm0 288H288v64c0 17.7-14.3 32-32 32H192c-17.7 0-32-14.3-32-32V416zM289.4 117.8L412.2 85l8.2 30.9L297.6 148.8l-8.2-30.9zm74.2 278.3l122.8-32.9 8.2 30.9L371.8 427l-8.2-30.9z','M288 112.6l1.4 5.2L412.2 85 395.8 23.7c-4.5-17-22-27.1-38.9-22.6L295.5 17.6c-2.7 .7-5.2 1.8-7.5 3.1L288 96H160v32H288l0-15.4zm132.4 3.2L297.6 148.8l66 247.4 122.8-32.9-66-247.4zM388.2 488.3c4.5 17 22 27.1 38.9 22.6l61.4-16.5c16.9-4.6 27-22.1 22.5-39.1l-16.3-61.1L371.8 427l16.3 61.3zM0 96v32H128V96H0zM128 384H0v32H128V384zm160 0H160v32H288V384z']
        
      ]
    };

    
  
    

    var faHighlighter = {
      prefix: 'fad',
      iconName: 'highlighter',
      icon: [
        576,
        512,
        
            []
          ,
        'f591',
        
        ['M360.7 360.7L183.3 183.3l-35.7 26.3c-12.3 9-19.5 23.4-19.5 38.6V320l0 0L70.6 377.4c-12.5 12.5-12.5 32.8 0 45.3l50.7 50.7c12.5 12.5 32.8 12.5 45.3 0L224 416h71.7c15.3 0 29.6-7.2 38.6-19.5l26.3-35.7z','M360.7 360.7L183.3 183.3 420.6 8.4C428 2.9 437 0 446.2 0c11.4 0 22.4 4.5 30.5 12.6l54.8 54.8c8.1 8.1 12.6 19 12.6 30.5c0 9.2-2.9 18.2-8.4 25.6L360.7 360.7zM7 466.3l56-56c1.5 4.5 4.1 8.7 7.6 12.2l50.7 50.7c3.6 3.6 7.8 6.1 12.2 7.6l-24 24c-4.5 4.5-10.6 7-17 7H24c-13.3 0-24-10.7-24-24v-4.7c0-6.4 2.5-12.5 7-17z']
        
      ]
    };

    
  
    

    var faUser = {
      prefix: 'fad',
      iconName: 'user',
      icon: [
        448,
        512,
        
            [62144,128100]
        ,
        'f007',
        
        ['M96 128a128 128 0 1 1 256 0A128 128 0 1 1 96 128z','M0 482.3C0 383.8 79.8 304 178.3 304h91.4C368.2 304 448 383.8 448 482.3c0 16.4-13.3 29.7-29.7 29.7H29.7C13.3 512 0 498.7 0 482.3z']
        
      ]
    };

    
  
    

    var faChevronUp = {
      prefix: 'fad',
      iconName: 'chevron-up',
      icon: [
        512,
        512,
        
            []
          ,
        'f077',
        
        ['M233.4 105.4c12.5-12.5 32.8-12.5 45.3 0l192 192c12.5 12.5 12.5 32.8 0 45.3s-32.8 12.5-45.3 0L256 173.3 86.6 342.6c-12.5 12.5-32.8 12.5-45.3 0s-12.5-32.8 0-45.3l192-192z','']
        
      ]
    };

    
  
    

    var faUsers = {
      prefix: 'fad',
      iconName: 'users',
      icon: [
        640,
        512,
        
            []
          ,
        'f0c0',
        
        ['M224 80A80 80 0 1 0 64 80a80 80 0 1 0 160 0zm368 0A80 80 0 1 0 432 80a80 80 0 1 0 160 0zM106.7 192C47.8 192 0 239.8 0 298.7C0 310.4 9.6 320 21.3 320H234.7c.2 0 .4 0 .7 0c-26.6-23.5-43.3-57.8-43.3-96c0-7.6 .7-15 1.9-22.3c-13.6-6.3-28.7-9.7-44.6-9.7H106.7zm298 128c.2 0 .4 0 .7 0H618.7c11.8 0 21.3-9.6 21.3-21.3C640 239.8 592.2 192 533.3 192H490.7c-15.9 0-31 3.5-44.6 9.7c1.3 7.2 1.9 14.7 1.9 22.3c0 38.2-16.8 72.5-43.3 96z','M320 320a96 96 0 1 0 0-192 96 96 0 1 0 0 192zm-58.7 32C187.7 352 128 411.7 128 485.3c0 14.7 11.9 26.7 26.7 26.7H485.3c14.7 0 26.7-11.9 26.7-26.7C512 411.7 452.3 352 378.7 352H261.3z']
        
      ]
    };

    
  
    

    var faLightbulbOn = {
      prefix: 'fad',
      iconName: 'lightbulb-on',
      icon: [
        640,
        512,
        
            []
          ,
        'f672',
        
        ['M449.2 297.8c-19.8 27.1-39.7 54.4-49.2 86.2H240c-9.6-31.9-29.5-59.1-49.2-86.2c-5.2-7.1-10.4-14.2-15.4-21.4C155.6 247.9 144 213.3 144 176C144 78.8 222.8 0 320 0s176 78.8 176 176c0 37.3-11.6 71.9-31.4 100.3c-5 7.2-10.2 14.3-15.4 21.4zM240 176c0-44.2 35.8-80 80-80c8.8 0 16-7.2 16-16s-7.2-16-16-16c-61.9 0-112 50.1-112 112c0 8.8 7.2 16 16 16s16-7.2 16-16z','M69.3 4l48 32c11 7.4 14 22.3 6.7 33.3s-22.3 14-33.3 6.7l-48-32c-11-7.4-14-22.3-6.7-33.3S58.3-3.3 69.3 4zM597.3 44l-48 32c-11 7.4-25.9 4.4-33.3-6.7s-4.4-25.9 6.7-33.3l48-32c11-7.4 25.9-4.4 33.3 6.7s4.4 25.9-6.7 33.3zM24 160H88c13.3 0 24 10.7 24 24s-10.7 24-24 24H24c-13.3 0-24-10.7-24-24s10.7-24 24-24zm528 0h64c13.3 0 24 10.7 24 24s-10.7 24-24 24H552c-13.3 0-24-10.7-24-24s10.7-24 24-24zM117.3 332l-48 32c-11 7.4-25.9 4.4-33.3-6.7s-4.4-25.9 6.7-33.3l48-32c11-7.4 25.9-4.4 33.3 6.7s4.4 25.9-6.7 33.3zm432-39.9l48 32c11 7.4 14 22.3 6.7 33.3s-22.3 14-33.3 6.7l-48-32c-11-7.4-14-22.3-6.7-33.3s22.3-14 33.3-6.7zM400 432c0 44.2-35.8 80-80 80s-80-35.8-80-80V384H400v48z']
        
      ]
    };

    
  
    

    var faLock = {
      prefix: 'fad',
      iconName: 'lock',
      icon: [
        448,
        512,
        
            [128274]
        ,
        'f023',
        
        ['M224 64c-44.2 0-80 35.8-80 80v48H80V144C80 64.5 144.5 0 224 0s144 64.5 144 144v48H304V144c0-44.2-35.8-80-80-80z','M0 256c0-35.3 28.7-64 64-64H384c35.3 0 64 28.7 64 64V448c0 35.3-28.7 64-64 64H64c-35.3 0-64-28.7-64-64V256z']
        
      ]
    };

    
  
    

    var faCircleDot = {
      prefix: 'fad',
      iconName: 'circle-dot',
      icon: [
        512,
        512,
        
            [128280,'dot-circle']
        ,
        'f192',
        
        ['M256 512A256 256 0 1 0 256 0a256 256 0 1 0 0 512zm0-352a96 96 0 1 1 0 192 96 96 0 1 1 0-192z','M256 160a96 96 0 1 0 0 192 96 96 0 1 0 0-192z']
        
      ]
    };

    
      var faDotCircle = faCircleDot;
    
  
    

    var faSquareCheck = {
      prefix: 'fad',
      iconName: 'square-check',
      icon: [
        448,
        512,
        
            [61510,9989,9745,'check-square']
        ,
        'f14a',
        
        ['M64 32C28.7 32 0 60.7 0 96V416c0 35.3 28.7 64 64 64H384c35.3 0 64-28.7 64-64V96c0-35.3-28.7-64-64-64H64zM337 209L209 337c-9.4 9.4-24.6 9.4-33.9 0l-64-64c-9.4-9.4-9.4-24.6 0-33.9s24.6-9.4 33.9 0l47 47L303 175c9.4-9.4 24.6-9.4 33.9 0s9.4 24.6 0 33.9z','M337 175c9.4 9.4 9.4 24.6 0 33.9L209 337c-9.4 9.4-24.6 9.4-33.9 0l-64-64c-9.4-9.4-9.4-24.6 0-33.9s24.6-9.4 33.9 0l47 47L303 175c9.4-9.4 24.6-9.4 33.9 0z']
        
      ]
    };

    
      var faCheckSquare = faSquareCheck;
    
  
    

    var faLightbulb = {
      prefix: 'fad',
      iconName: 'lightbulb',
      icon: [
        384,
        512,
        
            [128161]
        ,
        'f0eb',
        
        ['M321.2 297.8c-19.8 27.1-39.7 54.4-49.2 86.2H112c-9.6-31.9-29.5-59.1-49.2-86.2c-5.2-7.1-10.4-14.2-15.4-21.4C27.6 247.9 16 213.3 16 176C16 78.8 94.8 0 192 0s176 78.8 176 176c0 37.3-11.6 71.9-31.4 100.3c-5 7.2-10.2 14.3-15.4 21.4zM112 176c0-44.2 35.8-80 80-80c8.8 0 16-7.2 16-16s-7.2-16-16-16C130.1 64 80 114.1 80 176c0 8.8 7.2 16 16 16s16-7.2 16-16z','M192 512c44.2 0 80-35.8 80-80V384H112v48c0 44.2 35.8 80 80 80z']
        
      ]
    };

    
  
    

    var faBars = {
      prefix: 'fad',
      iconName: 'bars',
      icon: [
        448,
        512,
        
            ['navicon']
        ,
        'f0c9',
        
        ['M0 256c0-17.7 14.3-32 32-32H416c17.7 0 32 14.3 32 32s-14.3 32-32 32H32c-17.7 0-32-14.3-32-32z','M448 96c0-17.7-14.3-32-32-32H32C14.3 64 0 78.3 0 96s14.3 32 32 32H416c17.7 0 32-14.3 32-32zm0 320c0-17.7-14.3-32-32-32H32c-17.7 0-32 14.3-32 32s14.3 32 32 32H416c17.7 0 32-14.3 32-32z']
        
      ]
    };

    
      var faNavicon = faBars;
    
  
    

    var faSquareMinus = {
      prefix: 'fad',
      iconName: 'square-minus',
      icon: [
        448,
        512,
        
            [61767,'minus-square']
        ,
        'f146',
        
        ['M64 32C28.7 32 0 60.7 0 96V416c0 35.3 28.7 64 64 64H384c35.3 0 64-28.7 64-64V96c0-35.3-28.7-64-64-64H64zm88 200H296c13.3 0 24 10.7 24 24s-10.7 24-24 24H152c-13.3 0-24-10.7-24-24s10.7-24 24-24z','M128 256c0-13.3 10.7-24 24-24H296c13.3 0 24 10.7 24 24s-10.7 24-24 24H152c-13.3 0-24-10.7-24-24z']
        
      ]
    };

    
      var faMinusSquare = faSquareMinus;
    
  
    

    var faCircleNotch = {
      prefix: 'fad',
      iconName: 'circle-notch',
      icon: [
        512,
        512,
        
            []
          ,
        'f1ce',
        
        ['M222.7 32.1c5 16.9-4.6 34.8-21.5 39.8C121.8 95.6 64 169.1 64 256c0 106 86 192 192 192s192-86 192-192c0-86.9-57.8-160.4-137.1-184.1c-16.9-5-26.6-22.9-21.5-39.8s22.9-26.6 39.8-21.5C434.9 42.1 512 140 512 256c0 141.4-114.6 256-256 256S0 397.4 0 256C0 140 77.1 42.1 182.9 10.6c16.9-5 34.8 4.6 39.8 21.5z','']
        
      ]
    };

    
  
    

    var faSquareArrowRight = {
      prefix: 'fad',
      iconName: 'square-arrow-right',
      icon: [
        448,
        512,
        
            ['arrow-square-right']
        ,
        'f33b',
        
        ['M448 96c0-35.3-28.7-64-64-64L64 32C28.7 32 0 60.7 0 96L0 416c0 35.3 28.7 64 64 64l320 0c35.3 0 64-28.7 64-64l0-320zM361 273L249 385c-9.4 9.4-24.6 9.4-33.9 0s-9.4-24.6 0-33.9l71-71L104 280c-13.3 0-24-10.7-24-24s10.7-24 24-24l182.1 0-71-71c-9.4-9.4-9.4-24.6 0-33.9s24.6-9.4 33.9 0L361 239c9.4 9.4 9.4 24.6 0 33.9z','M361 239c9.4 9.4 9.4 24.6 0 33.9L249 385c-9.4 9.4-24.6 9.4-33.9 0s-9.4-24.6 0-33.9l71-71L104 280c-13.3 0-24-10.7-24-24s10.7-24 24-24l182.1 0-71-71c-9.4-9.4-9.4-24.6 0-33.9s24.6-9.4 33.9 0L361 239z']
        
      ]
    };

    
      var faArrowSquareRight = faSquareArrowRight;
    
  
    

    var faCalculatorSimple = {
      prefix: 'fad',
      iconName: 'calculator-simple',
      icon: [
        512,
        512,
        
            ['calculator-alt']
        ,
        'f64c',
        
        ['M48 0C21.5 0 0 21.5 0 48V176c0 26.5 21.5 48 48 48H176c26.5 0 48-21.5 48-48V48c0-26.5-21.5-48-48-48H48zM336 0c-26.5 0-48 21.5-48 48V176c0 26.5 21.5 48 48 48H464c26.5 0 48-21.5 48-48V48c0-26.5-21.5-48-48-48H336zM0 336V464c0 26.5 21.5 48 48 48H176c26.5 0 48-21.5 48-48V336c0-26.5-21.5-48-48-48H48c-26.5 0-48 21.5-48 48zM416 64V96h32c8.8 0 16 7.2 16 16s-7.2 16-16 16H416v32c0 8.8-7.2 16-16 16s-16-7.2-16-16V128H352c-8.8 0-16-7.2-16-16s7.2-16 16-16h32V64c0-8.8 7.2-16 16-16s16 7.2 16 16zM64 96h96c8.8 0 16 7.2 16 16s-7.2 16-16 16H64c-8.8 0-16-7.2-16-16s7.2-16 16-16zM83.3 348.7L112 377.4l28.7-28.7c6.2-6.2 16.4-6.2 22.6 0s6.2 16.4 0 22.6L134.6 400l28.7 28.7c6.2 6.2 6.2 16.4 0 22.6s-16.4 6.2-22.6 0L112 422.6 83.3 451.3c-6.2 6.2-16.4 6.2-22.6 0s-6.2-16.4 0-22.6L89.4 400 60.7 371.3c-6.2-6.2-6.2-16.4 0-22.6s16.4-6.2 22.6 0z','M416 64V96h32c8.8 0 16 7.2 16 16s-7.2 16-16 16H416v32c0 8.8-7.2 16-16 16s-16-7.2-16-16V128H352c-8.8 0-16-7.2-16-16s7.2-16 16-16h32V64c0-8.8 7.2-16 16-16s16 7.2 16 16zM64 96h96c8.8 0 16 7.2 16 16s-7.2 16-16 16H64c-8.8 0-16-7.2-16-16s7.2-16 16-16zM83.3 348.7L112 377.4l28.7-28.7c6.2-6.2 16.4-6.2 22.6 0s6.2 16.4 0 22.6L134.6 400l28.7 28.7c6.2 6.2 6.2 16.4 0 22.6s-16.4 6.2-22.6 0L112 422.6 83.3 451.3c-6.2 6.2-16.4 6.2-22.6 0s-6.2-16.4 0-22.6L89.4 400 60.7 371.3c-6.2-6.2-6.2-16.4 0-22.6s16.4-6.2 22.6 0zM288 336c0-26.5 21.5-48 48-48H464c26.5 0 48 21.5 48 48V464c0 26.5-21.5 48-48 48H336c-26.5 0-48-21.5-48-48V336zm48 32c0 8.8 7.2 16 16 16h96c8.8 0 16-7.2 16-16s-7.2-16-16-16H352c-8.8 0-16 7.2-16 16zm0 64c0 8.8 7.2 16 16 16h96c8.8 0 16-7.2 16-16s-7.2-16-16-16H352c-8.8 0-16 7.2-16 16z']
        
      ]
    };

    
      var faCalculatorAlt = faCalculatorSimple;
    
  
    

    var faCircleMinus = {
      prefix: 'fad',
      iconName: 'circle-minus',
      icon: [
        512,
        512,
        
            ['minus-circle']
        ,
        'f056',
        
        ['M256 512A256 256 0 1 0 256 0a256 256 0 1 0 0 512zM184 232H328c13.3 0 24 10.7 24 24s-10.7 24-24 24H184c-13.3 0-24-10.7-24-24s10.7-24 24-24z','M160 256c0-13.3 10.7-24 24-24H328c13.3 0 24 10.7 24 24s-10.7 24-24 24H184c-13.3 0-24-10.7-24-24z']
        
      ]
    };

    
      var faMinusCircle = faCircleMinus;
    
  

  return {
  
    faDown: faDown,
    
      faArrowAltDown: faArrowAltDown,
    
  
    faCircleXmark: faCircleXmark,
    
      faTimesCircle: faTimesCircle,
    
      faXmarkCircle: faXmarkCircle,
    
  
    faBookOpen: faBookOpen,
    
  
    faCheck: faCheck,
    
  
    faBook: faBook,
    
  
    faCirclePlus: faCirclePlus,
    
      faPlusCircle: faPlusCircle,
    
  
    faClockRotateLeft: faClockRotateLeft,
    
      faHistory: faHistory,
    
  
    faChevronRight: faChevronRight,
    
  
    faChevronLeft: faChevronLeft,
    
  
    faXmark: faXmark,
    
      faClose: faClose,
    
      faMultiply: faMultiply,
    
      faRemove: faRemove,
    
      faTimes: faTimes,
    
  
    faPlus: faPlus,
    
      faAdd: faAdd,
    
  
    faUserHeadset: faUserHeadset,
    
  
    faCircleUser: faCircleUser,
    
      faUserCircle: faUserCircle,
    
  
    faChevronDown: faChevronDown,
    
  
    faPlay: faPlay,
    
  
    faEraser: faEraser,
    
  
    faGreaterThan: faGreaterThan,
    
  
    faLocationDot: faLocationDot,
    
      faMapMarkerAlt: faMapMarkerAlt,
    
  
    faBookOpenReader: faBookOpenReader,
    
      faBookReader: faBookReader,
    
  
    faLessThan: faLessThan,
    
  
    faSquareArrowLeft: faSquareArrowLeft,
    
      faArrowSquareLeft: faArrowSquareLeft,
    
  
    faStop: faStop,
    
  
    faImages: faImages,
    
  
    faPowerOff: faPowerOff,
    
  
    faEllipsisVertical: faEllipsisVertical,
    
      faEllipsisV: faEllipsisV,
    
  
    faMinus: faMinus,
    
      faSubtract: faSubtract,
    
  
    faCircleInfo: faCircleInfo,
    
      faInfoCircle: faInfoCircle,
    
  
    faArrowLeft: faArrowLeft,
    
  
    faCircleQuestion: faCircleQuestion,
    
      faQuestionCircle: faQuestionCircle,
    
  
    faWrench: faWrench,
    
  
    faCircle: faCircle,
    
  
    faWifiSlash: faWifiSlash,
    
  
    faLockKeyhole: faLockKeyhole,
    
      faLockAlt: faLockAlt,
    
  
    faArrowRight: faArrowRight,
    
  
    faCircleArrowRight: faCircleArrowRight,
    
      faArrowCircleRight: faArrowCircleRight,
    
  
    faSquare: faSquare,
    
  
    faCommentQuestion: faCommentQuestion,
    
  
    faCircleArrowLeft: faCircleArrowLeft,
    
      faArrowCircleLeft: faArrowCircleLeft,
    
  
    faPause: faPause,
    
  
    faIdBadge: faIdBadge,
    
  
    faCircleCheck: faCircleCheck,
    
      faCheckCircle: faCheckCircle,
    
  
    faSquarePlus: faSquarePlus,
    
      faPlusSquare: faPlusSquare,
    
  
    faVolume: faVolume,
    
      faVolumeMedium: faVolumeMedium,
    
  
    faUserPen: faUserPen,
    
      faUserEdit: faUserEdit,
    
  
    faWifi: faWifi,
    
      faWifi3: faWifi3,
    
      faWifiStrong: faWifiStrong,
    
  
    faBooks: faBooks,
    
  
    faHighlighter: faHighlighter,
    
  
    faUser: faUser,
    
  
    faChevronUp: faChevronUp,
    
  
    faUsers: faUsers,
    
  
    faLightbulbOn: faLightbulbOn,
    
  
    faLock: faLock,
    
  
    faCircleDot: faCircleDot,
    
      faDotCircle: faDotCircle,
    
  
    faSquareCheck: faSquareCheck,
    
      faCheckSquare: faCheckSquare,
    
  
    faLightbulb: faLightbulb,
    
  
    faBars: faBars,
    
      faNavicon: faNavicon,
    
  
    faSquareMinus: faSquareMinus,
    
      faMinusSquare: faMinusSquare,
    
  
    faCircleNotch: faCircleNotch,
    
  
    faSquareArrowRight: faSquareArrowRight,
    
      faArrowSquareRight: faArrowSquareRight,
    
  
    faCalculatorSimple: faCalculatorSimple,
    
      faCalculatorAlt: faCalculatorAlt,
    
  
    faCircleMinus: faCircleMinus,
    
      faMinusCircle: faMinusCircle,
    
  
  };

 })()
  

  

  


var byPrefixAndName = {

  'fal': {},

  'far': {},

  'fas': {},

  'fad': {},

  

  

};

var all = [];

  function addIcons (icons) {
    Object.keys(icons).forEach(function (iconName) {
      if (iconName === 'prefix') {
        return;
      }

      var icon = icons[iconName];
      var aliases = icon.icon[2];
      aliases.forEach(function (alias) {
        if (typeof alias === 'string') {
          byPrefixAndName[icon.prefix][alias] = icon;
        }
      })
      byPrefixAndName[icon.prefix][icon.iconName] = icon;
      all.push(icon);
    });
  }


  
  addIcons(falIcons);
  var fal = falIcons;
  exports.fal = falIcons;
  

  
  addIcons(farIcons);
  var far = farIcons;
  exports.far = farIcons;
  

  
  addIcons(fasIcons);
  var fas = fasIcons;
  exports.fas = fasIcons;
  

  
  addIcons(fadIcons);
  var fad = fadIcons;
  exports.fad = fadIcons;
  

  

  


  exports.byPrefixAndName = byPrefixAndName;
  exports.all = all;

  Object.defineProperty(exports, '__esModule', { value: true });
})));
